(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MathUtility = require('../Utility/MathUtility');

var _MathUtility2 = _interopRequireDefault(_MathUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Angletool = function () {
	function Angletool() {
		var _this = this;

		_classCallCheck(this, Angletool);

		this.calcType = 'article';
		this.container = document.getElementById('angletool');
		this.resultsContainer = document.getElementById('angle-results-container');
		this.inputs = [].slice.call(document.getElementsByClassName('angletool-input')).reduce(function (acc, input) {
			acc[input.name] = input;
			return acc;
		}, []);
		this.flexibleCalcToggle = document.getElementById('flexible-calculation-toggle');
		this.articleCalcToggle = document.getElementById('article-calculation-toggle');

		this.angleResultOutput = document.getElementById('result-angle');
		this.floodheightResultOutput = document.getElementById('result-floodheight');
		this.articlenrResultOutput = document.getElementById('result-articlenr');
		this.chokesizeResultOutput = document.getElementById('result-chokesize');
		this.pdfButton = document.getElementById('download-pdf-button');
		this.pdfEnButton = document.getElementById('download-pdf-en-button');

		this.canvas = document.getElementById('angle-visualization');
		this.canvasbgimage = new Image(576, 577);
		this.canvasbgimage.src = document.getElementById('angle-visualization').dataset.image;

		// Current calculation results
		this.currentArticle = null;
		this.currentAngle = 0;
		this.currentFloodHeight = 0;
		this.currentDischarge = 0;

		var inputCollection = document.getElementsByClassName('angletool-input');
		for (var i in inputCollection) {
			if (Object.hasOwn(inputCollection, i)) {
				/* input event is needed for select fields or when the user pastes a value */
				inputCollection[i].addEventListener('input', function () {
					_this.validateInputs();
				});
				inputCollection[i].addEventListener('keyup', function () {
					_this.validateInputs();
				});
			}
		}

		this.flexibleCalcToggle.addEventListener('click', function () {
			_this.container.classList.remove('article-calculation');
			_this.container.classList.add('flexible-calculation');
			_this.calcType = 'flexible';
			_this.validateInputs();
		});
		this.articleCalcToggle.addEventListener('click', function () {
			_this.container.classList.remove('flexible-calculation');
			_this.container.classList.add('article-calculation');
			_this.calcType = 'article';
			_this.validateInputs();
		});

		// Add PDF button click event if the button exists
		if (this.pdfButton) {
			this.pdfButton.addEventListener('click', function (e) {
				e.preventDefault();
				_this.downloadPdf('de');
			});
		}

		// Add EN PDF button click event if the button exists
		if (this.pdfEnButton) {
			this.pdfEnButton.addEventListener('click', function (e) {
				e.preventDefault();
				_this.downloadPdf('en');
			});
		}
	}

	_createClass(Angletool, [{
		key: 'triggerCalculation',
		value: function triggerCalculation() {
			var discharge = this.getDischargeValue();

			if (this.calcType === 'article') {
				var articleUid = parseInt(this.inputs.article.value);
				if (!isNaN(discharge) && articleUid > 0) {
					var article = angletooldata['articles'][articleUid],
					    choke = angletooldata['chokes'][article['choke']];

					this.calculateAngle(discharge, article, choke);
				} else {
					this.hideResults();
				}
			} else if (this.calcType === 'flexible') {
				var chokeUid = parseInt(this.inputs.chokesize.value),
				    floodHeight = this.getFloodHeightValue();

				if (!isNaN(discharge) && chokeUid > 0 && !isNaN(floodHeight)) {
					var _choke = angletooldata['chokes'][chokeUid];

					// Only store floodHeight for flexible calculations
					this.currentFloodHeight = floodHeight;
					this.calculateAngle(discharge, null, _choke, floodHeight);
				} else {
					this.hideResults();
				}
			}
		}
	}, {
		key: 'validateInputs',
		value: function validateInputs() {
			/* clear results, we only want results if everything is valid */
			this.hideResults();

			var valid = true;
			this.inputs.discharge.classList.remove('angletool-error');
			this.inputs.floodheight.classList.remove('angletool-error');
			var discharge = this.getDischargeValue();
			if (isNaN(discharge) || discharge < 0.05 || discharge > 70) {
				this.inputs.discharge.classList.add('angletool-error');
				valid = false;
			}
			if (this.calcType === 'flexible') {
				var floodHeight = this.getFloodHeightValue();
				if (isNaN(floodHeight) || floodHeight > 3) {
					this.inputs.floodheight.classList.add('angletool-error');
					valid = false;
				}
			}

			if (valid) {
				this.triggerCalculation();
			}
		}
	}, {
		key: 'getDischargeValue',
		value: function getDischargeValue() {
			var _this2 = this;

			/* limit input to 2 decimal places */
			var discharge = this.inputs.discharge.value;
			var delimiters = ['.', ','];
			delimiters.forEach(function (delimiter) {
				if (discharge.indexOf(delimiter) >= 0) {
					_this2.inputs.discharge.value = discharge.slice(0, discharge.indexOf(delimiter) + 3);
				}
			});

			var dischargeFloat = _MathUtility2.default.round(parseFloat(this.inputs.discharge.value.replace(',', '.')), 2);

			if (!isNaN(dischargeFloat)) {
				return dischargeFloat;
			}

			return NaN;
		}
	}, {
		key: 'getFloodHeightValue',
		value: function getFloodHeightValue() {
			var _this3 = this;

			/* limit input to 2 decimal places */
			var floodHeight = this.inputs.floodheight.value;
			var delimiters = ['.', ','];
			delimiters.forEach(function (delimiter) {
				if (floodHeight.indexOf(delimiter) >= 0) {
					_this3.inputs.floodheight.value = floodHeight.slice(0, floodHeight.indexOf(delimiter) + 3);
				}
			});

			var floodHeightFloat = _MathUtility2.default.round(parseFloat(this.inputs.floodheight.value.replace(',', '.')), 2);

			if (!isNaN(floodHeightFloat)) {
				return floodHeightFloat;
			}

			return NaN;
		}
	}, {
		key: 'calculateAngle',
		value: function calculateAngle(qMax, article, choke) {
			var floodHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

			// correction factor, multiply all values by this factor to circumvent floating point precision errors
			var G = 9.81,
			    U = 0.6;

			// Store current values for PDF generation
			this.currentDischarge = qMax;
			this.currentArticle = article;

			if (article) {
				floodHeight = article.floodHeight;
				this.articlenrResultOutput.innerText = article.nr;
				this.chokesizeResultOutput.innerText = choke.n;
			}

			var v1 = Math.sqrt(2 * G * floodHeight) * U,
			    area = qMax / 1000 / v1,
			    angleTmp = Math.pow(choke.r, 2) - Math.pow(choke.ws, 2),
			    angle = area * 360 / (Math.PI * angleTmp);

			if (angle > 180.5) {
				this.resultsContainer.classList.remove('hidden');
				this.resultsContainer.classList.add('angle-error');
				this.resultsContainer.classList.add('error-large');
				return;
			}
			if (angle < 9.5) {
				this.resultsContainer.classList.remove('hidden');
				this.resultsContainer.classList.add('angle-error');
				this.resultsContainer.classList.add('error-small');
				return;
			}

			// Store current angle for PDF generation
			this.currentAngle = _MathUtility2.default.round(angle, 0);

			this.resultsContainer.classList.remove('angle-error', 'error-small', 'error-large');

			this.angleResultOutput.innerText = this.currentAngle;
			this.floodheightResultOutput.innerText = _MathUtility2.default.round(floodHeight, 2).toLocaleString();

			this.drawVisualization(angle);
			this.resultsContainer.classList.remove('hidden');
		}
	}, {
		key: 'hideResults',
		value: function hideResults() {
			this.resultsContainer.classList.add('hidden');
		}

		// Important: visualization is also done in php for the pdf output (AngletoolPdf.php)

	}, {
		key: 'drawVisualization',
		value: function drawVisualization(angle) {
			var ctx = this.canvas.getContext('2d'),
			    length = 270,
			    x0 = Math.round(this.canvas.width / 2),
			    y0 = Math.round(this.canvas.height / 2),
			    x1 = x0 + length,
			    y1 = y0,
			    alpha = angle * (Math.PI / 180),
			    x2 = x0 + length * Math.cos(alpha),
			    y2 = y0 - length * Math.sin(alpha);

			ctx.reset();
			ctx.drawImage(this.canvasbgimage, 0, 0, this.canvas.width, this.canvas.height);

			ctx.strokeStyle = "red";
			ctx.beginPath();
			ctx.moveTo(x0, y0);
			ctx.lineTo(x1, y1);
			ctx.stroke();

			ctx.beginPath();
			ctx.moveTo(x0, y0);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}

		/**
   * Updates the PDF download links based on current calculation
   */

	}, {
		key: 'updatePdfLink',
		value: function updatePdfLink() {
			if (!this.pdfButton && !this.pdfEnButton) {
				return;
			}

			// Update DE button
			if (this.pdfButton) {
				var deUrl = this.generatePdfUrl('de');
				if (deUrl) {
					this.pdfButton.setAttribute('href', deUrl);
				}
			}

			// Update EN button
			if (this.pdfEnButton) {
				var enUrl = this.generatePdfUrl('en');
				if (enUrl) {
					this.pdfEnButton.setAttribute('href', enUrl);
				}
			}
		}

		/**
   * Generates a PDF URL based on the current calculation
   * @param {string} language - The language code ('de' or 'en')
   * @returns {string|null} The PDF URL or null if no valid calculation is available
   */

	}, {
		key: 'generatePdfUrl',
		value: function generatePdfUrl() {
			var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'de';

			// Base URL structure from pdfLinks in angletooldata
			var baseUrl = window.location.pathname + '?tx_iggrafinfiltration_angletool[action]=pdf';
			var articleId = 0;
			var articleType = 'retention';

			if (this.calcType === 'article' && this.currentArticle) {
				articleId = parseInt(this.inputs.article.value);
				articleType = this.currentArticle.type;

				// Check if this is a lifting choke shaft (has a realUid property)
				if (articleType === 'lifting') {
					articleId = this.currentArticle.realUid;
				}
			} else if (this.calcType === 'flexible') {
				// For flexible calculation, use a choke directly
				articleType = 'flexible';
				articleId = parseInt(this.inputs.chokesize.value);
			}

			// Add angle parameter to URL
			var url = new URL(baseUrl, window.location.origin);
			var params = new URLSearchParams(url.search);

			// Set the article parameters
			params.set('tx_iggrafinfiltration_angletool[articleId]', articleId);
			params.set('tx_iggrafinfiltration_angletool[discharge]', this.currentDischarge);
			params.set('tx_iggrafinfiltration_angletool[articleType]', articleType);
			params.set('tx_iggrafinfiltration_angletool[angle]', this.currentAngle);
			params.set('tx_iggrafinfiltration_angletool[floodHeight]', this.currentFloodHeight);
			params.set('tx_iggrafinfiltration_angletool[language]', language);

			url.search = params.toString();
			return url.toString();
		}

		/**
   * Initiates the PDF download
   * @param {string} language - The language code ('de' or 'en')
   */

	}, {
		key: 'downloadPdf',
		value: function downloadPdf() {
			var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'de';

			var url = this.generatePdfUrl(language);
			if (url) {
				window.open(url, '_blank');
			}
		}
	}]);

	return Angletool;
}();

exports.default = Angletool;

},{"../Utility/MathUtility":16}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AjaxUtility = require('../Utility/AjaxUtility');

var _AjaxUtility2 = _interopRequireDefault(_AjaxUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_LENGTH_M = 80;

var Articletool = function () {
	function Articletool() {
		var _this = this;

		_classCallCheck(this, Articletool);

		this.container = document.getElementById('articletool');
		if (!this.container) {
			return;
		}
		this.resultsContainer = document.getElementById('articletool-results');

		this.inputs = {
			product: document.getElementById('articletool-product'),
			length: document.getElementById('articletool-length'),
			width: document.getElementById('articletool-width'),
			height: document.getElementById('articletool-height')
		};

		this.products = window.articletooldata || {};
		this.debounceTimer = null;

		this.inputs.product.addEventListener('change', function () {
			_this.repopulateDimensionDropdowns();
			_this.scheduleCalculation();
		});
		['length', 'width', 'height'].forEach(function (key) {
			_this.inputs[key].addEventListener('change', function () {
				return _this.scheduleCalculation();
			});
		});

		this.repopulateDimensionDropdowns();
		this.scheduleCalculation();
	}

	_createClass(Articletool, [{
		key: 'currentProduct',
		value: function currentProduct() {
			var uid = parseInt(this.inputs.product.value, 10);
			return this.products[uid] || null;
		}
	}, {
		key: 'repopulateDimensionDropdowns',
		value: function repopulateDimensionDropdowns() {
			var product = this.currentProduct();
			if (!product) {
				return;
			}

			this.fillBlockMultipleDropdown(this.inputs.length, product.blocLength);
			this.fillBlockMultipleDropdown(this.inputs.width, product.blocWidth);
			this.fillLayerDropdown(this.inputs.height, product);
		}
	}, {
		key: 'fillBlockMultipleDropdown',
		value: function fillBlockMultipleDropdown(select, blocSize) {
			select.innerHTML = '';
			var maxCount = Math.floor(MAX_LENGTH_M / blocSize);
			for (var n = 1; n <= maxCount; n++) {
				var meters = (n * blocSize).toFixed(2).replace('.', ',');
				var option = document.createElement('option');
				option.value = String(n);
				option.textContent = meters + ' Meter (' + n + ' St\xFCck)';
				select.appendChild(option);
			}
		}
	}, {
		key: 'fillLayerDropdown',
		value: function fillLayerDropdown(select, product) {
			select.innerHTML = '';
			select.disabled = false;

			var maxLayers = product.isTunnel ? 1 : Math.max(1, parseInt(product.maxLayers, 10) || 1);

			for (var n = 1; n <= maxLayers; n++) {
				var fullMeters = (n * product.displayBlocHeight + product.basePlateHeight).toFixed(2).replace('.', ',');
				var fullLabel = n === 1 ? '1 Lage' : n + ' Lagen';
				var fullOption = document.createElement('option');
				fullOption.value = String(n);
				fullOption.textContent = fullMeters + ' Meter (' + fullLabel + ')';
				select.appendChild(fullOption);

				// Extra ("½ Lage") step on top of n full layers, mirroring getHeightSteps()
				// (offered on 1 … maxLayers-1, never on the top full-layer count).
				if (product.hasExtraBloc && n < maxLayers) {
					var extraMeters = (n * product.displayBlocHeight + product.extraBlocHeight + product.basePlateHeight).toFixed(2).replace('.', ',');
					var extraOption = document.createElement('option');
					extraOption.value = String(n);
					extraOption.dataset.extraBloc = '1';
					extraOption.textContent = extraMeters + ' Meter (' + n + ',5 Lagen)';
					select.appendChild(extraOption);
				}
			}

			if (product.isTunnel) {
				select.value = '1';
				select.disabled = true;
			}
		}
	}, {
		key: 'scheduleCalculation',
		value: function scheduleCalculation() {
			var _this2 = this;

			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(function () {
				return _this2.runCalculation();
			}, 150);
		}
	}, {
		key: 'runCalculation',
		value: function runCalculation() {
			var _this3 = this;

			var product = this.currentProduct();
			if (!product) {
				return;
			}
			var blocksLength = parseInt(this.inputs.length.value, 10);
			var blocksWidth = parseInt(this.inputs.width.value, 10);
			var heightSelect = this.inputs.height;
			var layers = parseInt(heightSelect.value, 10);
			var selectedOption = heightSelect.options[heightSelect.selectedIndex];
			var extraBloc = selectedOption && selectedOption.dataset.extraBloc === '1' ? 1 : 0;

			if (isNaN(blocksLength) || isNaN(blocksWidth) || isNaN(layers)) {
				return;
			}

			this.resultsContainer.classList.add('is-loading');

			_AjaxUtility2.default.request('Articletool', {
				controller: 'Articletool',
				action: 'calculate',
				productUid: parseInt(this.inputs.product.value, 10),
				blocksLength: blocksLength,
				blocksWidth: blocksWidth,
				layers: layers,
				extraBloc: extraBloc
			}).done(function (html) {
				_this3.resultsContainer.innerHTML = html;
			}).fail(function () {
				_this3.resultsContainer.innerHTML = '<p class="article-list-tool__error">Die Artikelaufstellung konnte nicht berechnet werden. Bitte erneut versuchen.</p>';
			}).always(function () {
				_this3.resultsContainer.classList.remove('is-loading');
			});
		}
	}]);

	return Articletool;
}();

exports.default = Articletool;

},{"../Utility/AjaxUtility":15}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// Removed map imports; map handling moved to LocationManager

// NEW: Area managers extracted from this file (see comments below)


var _ConfigurationFormConfig = require('./ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

var _AjaxUtility = require('../Utility/AjaxUtility');

var _AjaxUtility2 = _interopRequireDefault(_AjaxUtility);

var _MathUtility = require('../Utility/MathUtility');

var _MathUtility2 = _interopRequireDefault(_MathUtility);

var _LocationManager = require('./Modules/LocationManager');

var _LocationManager2 = _interopRequireDefault(_LocationManager);

var _AreaManagerLegacy = require('./Modules/AreaManagerLegacy');

var _AreaManagerLegacy2 = _interopRequireDefault(_AreaManagerLegacy);

var _AreaManagerNew = require('./Modules/AreaManagerNew');

var _AreaManagerNew2 = _interopRequireDefault(_AreaManagerNew);

var _FOrtQuestionManager = require('./Modules/FOrtQuestionManager');

var _FOrtQuestionManager2 = _interopRequireDefault(_FOrtQuestionManager);

var _KiWizardManager = require('./Modules/KiWizardManager');

var _KiWizardManager2 = _interopRequireDefault(_KiWizardManager);

var _FKWizardManager = require('./Modules/FKWizardManager');

var _FKWizardManager2 = _interopRequireDefault(_FKWizardManager);

var _FMethodeManager = require('./Modules/FMethodeManager');

var _FMethodeManager2 = _interopRequireDefault(_FMethodeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfigurationForm = function () {
	function ConfigurationForm() {
		var _this = this;

		_classCallCheck(this, ConfigurationForm);

		this.initializing = true;
		this.form = $(_ConfigurationFormConfig2.default.selectors.configurationForm);
		this.state = {
			country: _ConfigurationFormConfig2.default.values.countries.GERMANY,
			propertyType: null,
			surfaceCategory: null
		};
		this.locationManager = new _LocationManager2.default(this.form, this.state);
		// Initialize area managers (legacy DWA-A 138 and new DWA-A 138-1)
		// Keep behaviour 1:1; managers call back into this for updateFormData/updateSummary
		// CHANGE: logic moved out of this class
		this.areaManagerLegacy = new _AreaManagerLegacy2.default(this.form, this.state, this);
		this.areaManagerNew = new _AreaManagerNew2.default(this.form, this.state, this);
		// VSO-409: fOrt question wizard manager (Step 5)
		this.fOrtQuestionManager = new _FOrtQuestionManager2.default(this.form, this.state, this);
		// VSO-409: remaining wizard managers (Steps 1/3/6)
		this.kiWizardManager = new _KiWizardManager2.default(this.form, this.state, this);
		this.fkWizardManager = new _FKWizardManager2.default(this.form, this.state, this);
		this.fMethodeManager = new _FMethodeManager2.default(this.form, this.state, this);
		// Continue only on form page
		if (this.form.length) {
			this.currentSlideIndex = 0;
			this.slideProgress = 0;
			this.slides = $(_ConfigurationFormConfig2.default.selectors.slides);
			this.configurationSummary = $(_ConfigurationFormConfig2.default.selectors.configurationSummary);
			this.formData = {};
			this.progressMeter = $(_ConfigurationFormConfig2.default.selectors.progressMeter);
			this.completionPercentage = 0;
			this.isEditMode = $(_ConfigurationFormConfig2.default.selectors.calculator).data('type') === 'edit';

			// CHANGE: coefficientStep moved to FormConfig.settings; host property removed
			this.areaTypeCount = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock).length;
			// CHANGE: areaTypeMax moved to FormConfig.settings; host property removed
			this.rcIndexInput = $(_ConfigurationFormConfig2.default.selectors.rcIndexInput);
			this.rcIndex = this.rcIndexInput.val();

			this.runoffTypes = {};

			this.customRunoffValueInput = $(_ConfigurationFormConfig2.default.selectors.customRunoffValueInput);
			this.customRunoffValueSignificand = $(_ConfigurationFormConfig2.default.selectors.customRunoffValueSignificand);
			this.customRunoffValueExponent = $(_ConfigurationFormConfig2.default.selectors.customRunoffValueExponent);
			this.runoffValueIndexNotationResult = $(_ConfigurationFormConfig2.default.selectors.runoffValueIndexNotationResult);
			this.weatherStation = $(_ConfigurationFormConfig2.default.selectors.weatherStation);
			this.nextSlideButton = $(_ConfigurationFormConfig2.default.selectors.nextSlideButton);
			this.scrollTarget = document.querySelector(_ConfigurationFormConfig2.default.selectors.nextSlideScrollTarget);

			this.slides.each(function (index, slide) {
				$(slide).data('slideindex', index);
			});

			if (this.customRunoffValueSignificand.length && this.customRunoffValueExponent.length) {
				this.setCustomRunoffValueIndexNotation();
				this.resolveCustomRunoffValueIndexNotation();
			}

			$(_ConfigurationFormConfig2.default.selectors.areaTypeSelect).each(function (index, element) {
				// CHANGE: delegate to AreaManagerLegacy
				_this.areaManagerLegacy.fillAreaTypeData($(element), parseInt(element.value), true);
			});

			var resultMessageContainer = $(_ConfigurationFormConfig2.default.selectors.weatherStationCheckResult);
			if (resultMessageContainer.length > 0 && resultMessageContainer.html().length > 0) {
				resultMessageContainer.show();
			}

			if ($(_ConfigurationFormConfig2.default.selectors.groundReportFilesUploadHidden).prop('checked')) {
				this.activateGroundReportFilesUpload();
			}

			this.bindHandlers();

			// CHANGE: delegate to AreaManagerLegacy
			this.areaManagerLegacy.toggleRemoveButtons();

			// Initialize DWA-A 138-1 area handlers if the new UI is present
			// CHANGE: delegate to AreaManagerNew
			this.areaManagerNew.initAreaType1381Handlers();
			// VSO-409: Initialize fOrt question wizard block (Step 5)
			this.fOrtQuestionManager.init();
			// VSO-409: Initialize remaining wizard steps
			this.kiWizardManager.init();
			this.fkWizardManager.init();
			this.fMethodeManager.init();

			// fancybox settings
			$.fancybox.defaults = $.extend($.fancybox.defaults, {
				maxWidth: 1080,
				helpers: {
					overlay: {
						locked: false
					}
				}
			});

			$('.fancybox').not('.iframe').fancybox();

			$('.fancybox.iframe').fancybox({
				type: 'iframe'
			});

			// VSO-334: Prevent submit with ENTER
			this.form.keydown(function (event) {
				if (event.keyCode === 13) {
					event.preventDefault();
					return false;
				}
			});
		}
		this.initializing = false;
	}

	_createClass(ConfigurationForm, [{
		key: 'bindHandlers',
		value: function bindHandlers() {
			var _this2 = this;

			this.nextSlideButton.on('click', function (e) {
				e.preventDefault();
				_this2.nextSlide();
			});

			var formInputs = this.form.find('input, select, textarea');
			formInputs.on('change', function (e) {
				_this2.updateFormData(e.target);
			});
			formInputs.each(function (i, input) {
				_this2.updateFormData(input, false);
			});

			// initial slideIndex Update
			if (this.isEditMode) {
				this.slideProgress = this.slides.length;
				$(_ConfigurationFormConfig2.default.selectors.progressButton).addClass('complete');
			} else {
				var lastSummary = $(_ConfigurationFormConfig2.default.selectors.configurationSummary).find('.summaryItem').eq(-1);
				var furthestSlide = $('[data-property="' + lastSummary.data('summaryproperty') + '"]').eq(0).parents(_ConfigurationFormConfig2.default.selectors.slides);
				if (furthestSlide.length) {
					this.slideProgress = furthestSlide.data('slideindex');
				}
			}

			var checkboxRoots = this.form.find(_ConfigurationFormConfig2.default.selectors.checkboxRoot);
			checkboxRoots.on('click', function (e) {
				var field = $(e.target).find('input').last()[0];
				if (field && !field.disabled) {
					// Trigger the native input click; the bound 'change' handler
					// will update formData and the summary. Avoid calling
					// updateFormData() here to prevent double processing
					// that caused duplicate entries (e.g., products) in the sidebar.
					field.click();
				}
			});

			var squareCheckboxes = this.form.find(_ConfigurationFormConfig2.default.selectors.squareCheckbox + ' input');
			squareCheckboxes.on('click', function (e) {
				var input = $(e.target);
				input.parent().toggleClass('checked');
			});

			this.form.find(_ConfigurationFormConfig2.default.selectors.checkboxTeaser).on('click', function (e) {
				$(e.target).parents('.checkbox-inner-wrapper').find(_ConfigurationFormConfig2.default.selectors.checkboxRoot).click();
			});

			this.updateSummary();

			var infiltrationRadios = $(_ConfigurationFormConfig2.default.selectors.infiltrationType);
			infiltrationRadios.on('click', function (e) {
				_this2.infiltrationTypeChange(parseInt(e.target.value), true);
			});
			this.infiltrationTypeChange(parseInt(infiltrationRadios.filter(':checked').val()));

			var attenuationPlusCheckbox = $(_ConfigurationFormConfig2.default.selectors.attenuationPlusCheckbox);
			attenuationPlusCheckbox.on('click', function (e) {
				_this2.attenuationPlusChange($(_ConfigurationFormConfig2.default.selectors.attenuationPlusCheckbox));
			});
			this.attenuationPlusChange($(_ConfigurationFormConfig2.default.selectors.attenuationPlusCheckbox));

			this.customRunoffValueInput.hide();
			// show javascript based index notation input
			$(_ConfigurationFormConfig2.default.selectors.customRunoffValueIndexNotation).show();

			this.customRunoffValueSignificand.add(this.customRunoffValueExponent).on('change keyup', function (e) {
				_this2.resolveCustomRunoffValueIndexNotation();
			});

			$(_ConfigurationFormConfig2.default.selectors.addAreaTypeButton).on('click', function (e) {
				e.preventDefault();

				// CHANGE: delegate to AreaManagerLegacy
				_this2.areaManagerLegacy.addAreaType();
				return false;
			});

			// Toggle area slide UI between DWA-A 138 and DWA-A 138-1 depending on guideline selection
			var guidelineRadios = this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios);
			guidelineRadios.on('change', function () {
				_this2.toggleAreaSlideByGuideline();
				_this2.clearSlides(guidelineRadios.parents(_ConfigurationFormConfig2.default.selectors.slides).nextAll(_ConfigurationFormConfig2.default.selectors.slides));
			});
			// Initialize visibility on first load
			// Ensure this happens after form data has been initialized from inputs
			window.setTimeout(function () {
				_this2.toggleAreaSlideByGuideline();
				_this2.updateSummary();

				// Force update of all 138-1 related managers if guideline is active
				if (_this2.isGuideline1381Active()) {
					if (_this2.fOrtQuestionManager) _this2.fOrtQuestionManager.updateVisibility();
					if (_this2.kiWizardManager) _this2.kiWizardManager.updateVisibility();
					if (_this2.fkWizardManager) _this2.fkWizardManager.updateVisibility();
					if (_this2.fMethodeManager) _this2.fMethodeManager.updateVisibility();
				}
			}, 150);

			this.bindPermittedDischargeHandlers();
			// CHANGE: delegate area select binds to AreaManagerLegacy
			this.areaManagerLegacy.bindAreaTypeSelectHandlers();

			this.resilienceChange($(_ConfigurationFormConfig2.default.selectors.resilienceRadio + ':checked'));

			var assignedTeamSelect = $(_ConfigurationFormConfig2.default.selectors.assignedTeamSelect);
			assignedTeamSelect.on('change', function (e) {
				_this2.updateProcessorSelect(e.target.value);
			});

			var configurationSubmit = $(_ConfigurationFormConfig2.default.selectors.configurationSubmit);
			configurationSubmit.on('click', function (e) {
				if (!_this2.isValidSlide(_this2.getCurrentSlide())) {
					e.preventDefault();
					return false;
				}
				var citySelect = $(_ConfigurationFormConfig2.default.selectors.citySelect);
				// no weather station selected
				if (_this2.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY && citySelect[0].selectedIndex !== 0) {
					e.preventDefault();
					_this2.locationManager.checkWeatherStation(null, false, true);
					return false;
				}
			});

			var groundReportInfoStep1 = $(_ConfigurationFormConfig2.default.selectors.groundReportInfoStep1),
			    groundReportInfoStep2 = $(_ConfigurationFormConfig2.default.selectors.groundReportInfoStep2),
			    activateGroundReportFilesUploadButton = $(_ConfigurationFormConfig2.default.selectors.activateGroundReportFilesUploadButton),
			    confirmGroundReportFilesUpload = $(_ConfigurationFormConfig2.default.selectors.confirmGroundReportFilesUpload),
			    cancelGroundReportFilesUpload = $(_ConfigurationFormConfig2.default.selectors.cancelGroundReportFilesUpload);

			activateGroundReportFilesUploadButton.on('click', function (e) {
				e.preventDefault();
				groundReportInfoStep1.hide();
				groundReportInfoStep2.show();
				confirmGroundReportFilesUpload.show();
				$.fancybox.update();

				confirmGroundReportFilesUpload.on('click', function (e) {
					e.preventDefault();
					confirmGroundReportFilesUpload.off('click');
					confirmGroundReportFilesUpload.hide();
					_this2.activateGroundReportFilesUpload();
					$.fancybox.close();
				});
			});
			cancelGroundReportFilesUpload.on('click', function (e) {
				e.preventDefault();
				confirmGroundReportFilesUpload.off('click');
				_this2.deactivateGroundReportFilesUpload();
				groundReportInfoStep2.hide();
				groundReportInfoStep1.show();
				$.fancybox.update();
			});

			var fancyboxClosers = $('.closeFancybox');
			fancyboxClosers.on('click', function (e) {
				e.preventDefault();
				$.fancybox.close();
			});

			var clientTypeSelect = $(_ConfigurationFormConfig2.default.selectors.clientTypeSelect);
			clientTypeSelect.on('change', function (e) {
				_this2.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));
			});
			this.customerTypeBasedToggles(parseInt(clientTypeSelect.val()));

			var grafPartnerCheckbox = $(_ConfigurationFormConfig2.default.selectors.grafPartnerCheckbox);
			grafPartnerCheckbox.on('change', function (e) {
				_this2.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));
			});
			this.grafPartnerCheckboxToggle(grafPartnerCheckbox.prop('checked'));

			this.progressButtons = $(_ConfigurationFormConfig2.default.selectors.progressButton);
			this.progressButtons.on('click', function (e) {
				e.preventDefault();
				var category = $(e.target).data('slidecategory'),
				    firstMatchingSlide = _this2.form.find('[data-category="' + category + '"]').eq(0),
				    slideIndex = parseInt(firstMatchingSlide.data('slideindex'));

				if (slideIndex <= _this2.slideProgress) {
					_this2.goToSlide(slideIndex);
				}
			});

			$(_ConfigurationFormConfig2.default.selectors.backButton).on('click', function (e) {
				e.preventDefault();
				_this2.prevSlide();
			});

			$(_ConfigurationFormConfig2.default.selectors.startCalculatorButton).on('click', function (e) {
				e.preventDefault();
				$(_ConfigurationFormConfig2.default.selectors.inquiryIntro).hide();
				$(_ConfigurationFormConfig2.default.selectors.calculator).show();
			});

			$('.soilType').on('change', function (e) {
				var required = $(e.target).data('furtherrequire') || false;
				$('#customRunoffValueSignificand').prop('required', required);

				if (!required) {
					// Clear custom values from formData if we switched back to a predefined soil type
					var category = $(e.target).parents(_ConfigurationFormConfig2.default.selectors.slides).data('category');
					var customProperty = $('#customRunoffValueSignificand').data('property');

					if (category && customProperty && _this2.formData[category] && _this2.formData[category].hasOwnProperty(customProperty)) {
						delete _this2.formData[category][customProperty];
					}

					// Also clear the inputs to stay consistent
					_this2.customRunoffValueInput.val('');
					_this2.customRunoffValueSignificand.val('');
					if (_this2.customRunoffValueExponent.length && _this2.customRunoffValueExponent[0].options) {
						_this2.customRunoffValueExponent[0].selectedIndex = 0;
					}
					_this2.resolveCustomRunoffValueIndexNotation();

					_this2.updateSummary();
				}
			});

			var selectedPropertyType = $(_ConfigurationFormConfig2.default.selectors.propertyType).filter(':checked');
			if (selectedPropertyType) {
				this.state.propertyType = parseInt(selectedPropertyType.val());
			}
			$(_ConfigurationFormConfig2.default.selectors.propertyType).on('click', function (e) {
				_this2.state.propertyType = parseInt($(e.currentTarget).val());
				_this2.areaManagerNew.toggleAreaCategorizationRows();
				_this2.clearInputs($(_ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle).add(_ConfigurationFormConfig2.default.selectors.areacategorizationInput));
			});
		}

		// Helper: enable/disable all inputs in a container

	}, {
		key: 'setInputsDisabled',
		value: function setInputsDisabled($container, disabled) {
			$container.find('input, select, textarea').each(function (i, el) {
				var $el = $(el);
				// Never disable Extbase/Fluid security fields.
				var name = String($el.attr('name') || '');
				if (name.indexOf('__trustedProperties') !== -1 || name.indexOf('__referrer') !== -1) {
					return;
				}
				if ($el.data('infiltrationnotpossible') !== 1) {
					$el.prop('disabled', disabled);
				}
				if (disabled) {
					if ($el.prop('required')) {
						$el.data('prop-required', true);
					}

					$el.removeClass('error');
					$el.removeAttr('required');
				} else {
					// Restore required attribute if data-required is set
					if ($el.data('required') || $el.data('prop-required')) {
						$el.prop('required', true);
					}
				}
			});
		}

		// Show correct area slide variant depending on selected guideline (0 = DWA-A 138, 1 = DWA-A 138-1)

	}, {
		key: 'toggleAreaSlideByGuideline',
		value: function toggleAreaSlideByGuideline() {
			var _this3 = this;

			var selected = this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios + ':checked');

			// Fallback for edit mode if radio binding failed in Fluid: check data attribute on container
			if (!selected.length) {
				var $container = $('.flex-container.flex-wrap[data-initial-new-guideline]');
				if ($container.length && $container.attr('data-initial-new-guideline') !== '') {
					var initialValue = $container.attr('data-initial-new-guideline');
					var $radio = this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios + '[value="' + initialValue + '"]');
					if ($radio.length) {
						$radio.prop('checked', true);
						selected = $radio;
					}
				}
			}

			var value = selected.length ? parseInt(selected.val(), 10) : 0;
			var $area138 = $('#areaGuideline138');
			var $area1381 = $('#areaGuideline1381');

			if (value === 1) {
				$area138.hide();
				this.setInputsDisabled($area138, true);
				$area1381.show();
				this.setInputsDisabled($area1381, false);

				$('.guideline138').hide();
				$('.newGuideline138-1').show();

				// Switch data-property for summary sidebar
				this.form.find('[data-property1381]').each(function (i, el) {
					var $el = $(el);
					var category = $el.parents(_ConfigurationFormConfig2.default.selectors.slides).data('category');
					var oldProperty = $el.attr('data-property');

					if (!$el.attr('data-property-orig')) {
						$el.attr('data-property-orig', oldProperty);
					}
					var newProperty = $el.attr('data-property1381');
					$el.attr('data-property', newProperty);
					$el.data('property', newProperty); // VSO-409: Update jQuery data cache, otherwise old name stays in sidebar

					// Clean up old property from formData
					if (category && oldProperty !== newProperty && _this3.formData[category]) {
						delete _this3.formData[category][oldProperty];
					}
				});
			} else {
				$area1381.hide();
				this.setInputsDisabled($area1381, true);
				$area138.show();
				this.setInputsDisabled($area138, false);

				$('.newGuideline138-1').hide();
				$('.guideline138').show();

				// Restore data-property for summary sidebar
				this.form.find('[data-property-orig]').each(function (i, el) {
					var $el = $(el);
					var category = $el.parents(_ConfigurationFormConfig2.default.selectors.slides).data('category');
					var oldProperty = $el.attr('data-property');
					var origProperty = $el.attr('data-property-orig');

					$el.attr('data-property', origProperty);
					$el.data('property', origProperty); // VSO-409: Restore jQuery data cache

					// Clean up property from formData
					if (category && oldProperty !== origProperty && _this3.formData[category]) {
						delete _this3.formData[category][oldProperty];
					}
				});
			}

			// Refresh formData to reflect property name changes in summary
			this.form.find('input, select, textarea').each(function (i, input) {
				_this3.updateFormData(input, false);
			});

			// Clear any previous validation errors when switching variants to avoid stale blocking state
			var $areaSlide = $area138.parents(_ConfigurationFormConfig2.default.selectors.slides).first();
			if ($areaSlide && $areaSlide.length) {
				$areaSlide.find(_ConfigurationFormConfig2.default.selectors.errorList).hide().find('ul').html('');
				$areaSlide.find('input, select, textarea').removeClass('error');
			}
			// Recompute sidebar
			this.updateSummary();
			// VSO-409: toggle fOrt question wizard visibility along with guideline
			if (this.fOrtQuestionManager && typeof this.fOrtQuestionManager.updateVisibility === 'function') {
				this.fOrtQuestionManager.updateVisibility();
			}
			if (this.kiWizardManager && typeof this.kiWizardManager.updateVisibility === 'function') {
				this.kiWizardManager.updateVisibility();
			}
			if (this.fkWizardManager && typeof this.fkWizardManager.updateVisibility === 'function') {
				this.fkWizardManager.updateVisibility();
			}
			if (this.fMethodeManager && typeof this.fMethodeManager.updateVisibility === 'function') {
				this.fMethodeManager.updateVisibility();
			}
			// VSO-489: covers guideline switches, initial load and the forced legacy
			// guideline click on country change (state.country is updated by then)
			this.updateRainFrequencyDisabledState();
		}

		// Helper to detect if 138-1 UI is the currently selected path

	}, {
		key: 'isGuideline1381Active',
		value: function isGuideline1381Active() {
			var selected = this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios + ':checked');
			var value = selected.length ? parseInt(selected.val(), 10) : 0;
			// IMPORTANT: Do NOT couple guideline selection to any specific slide visibility.
			// Otherwise this returns false on non-area slides (parents hidden) and breaks downstream toggles.
			return value === 1;
		}

		// VSO-489: DWA-A 138-1 works with fixed rain frequencies for Mulden-Rigole (DE),
		// so the rainFrequency select must not be editable in that combination.
		// A disabled select is not submitted - safe here, since the 138-1 calculation
		// does not read rainFrequency and the PDF omits it for MuRi 138-1.

	}, {
		key: 'updateRainFrequencyDisabledState',
		value: function updateRainFrequencyDisabledState() {
			var infiltrationType = parseInt($(_ConfigurationFormConfig2.default.selectors.infiltrationType + ':checked').val(), 10);
			var disable = this.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY && infiltrationType === _ConfigurationFormConfig2.default.values.infiltrationType.TROUGH_RIGOLE && this.isGuideline1381Active();

			var $rainFrequencySelect = $(_ConfigurationFormConfig2.default.selectors.rainFrequencySelect);
			if ($rainFrequencySelect.length && $rainFrequencySelect.prop('disabled') !== disable) {
				$rainFrequencySelect.prop('disabled', disable);
				// refresh the sidebar summary, which omits the rain frequency while disabled
				this.updateFormData($rainFrequencySelect[0]);
			}
		}

		// Area 138-1 logic moved to AreaManagerNew (Modules/AreaManagerNew.js)

	}, {
		key: 'nextSlide',
		value: function nextSlide() {
			this.goToSlide(this.currentSlideIndex + 1);
		}
	}, {
		key: 'prevSlide',
		value: function prevSlide() {
			this.goToSlide(this.currentSlideIndex - 1, -1);
		}
	}, {
		key: 'goToSlide',
		value: function goToSlide(index) {
			var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

			if ((index < this.currentSlideIndex || this.isValidSlide(this.getCurrentSlide())) && index >= 0 && index < this.slides.length) {
				this.slides.eq(this.currentSlideIndex).hide();
				var newSlide = this.slides.eq(index);
				newSlide.show();
				this.currentSlideIndex = index;
				this.slideProgress = Math.max(this.currentSlideIndex, this.slideProgress);
				var category = newSlide.data('category');

				// check if new slide has any displayable content
				// Ignore the error box when deciding if a slide has content. Otherwise,
				// a hidden slide (e.g., rigoleOnly content) with only a visible error box
				// would block navigation and show an empty error-only slide.
				var slideElements = this.slides.eq(index).children().not(_ConfigurationFormConfig2.default.selectors.errorList);
				if (!slideElements.toArray().some(function (element) {
					return window.getComputedStyle(element).display !== 'none';
				}) || newSlide.data('skip') === true) {
					this.goToSlide(index + fallback, fallback);
				} else {
					// execute any slide specific actions
					var action = newSlide.data('action');
					if (action && typeof this[action] === "function") {
						this[action]();
					}

					this.progressButtons.removeClass('active');
					$(_ConfigurationFormConfig2.default.selectors.progressButton + '[data-slidecategory="' + category + '"]').addClass('active').addClass('complete');

					// scroll to top of slide
					this.scrollTarget.scrollIntoView({
						behavior: 'smooth'
					});
				}

				var progress = parseFloat(newSlide.data('progress'));
				if (progress && progress > this.completionPercentage) {
					this.completionPercentage = progress;
					this.progressMeter.css('width', progress + '%');
				}

				// is final slide
				if (index === this.slides.length - 1) {
					this.nextSlideButton.hide();
				} else {
					this.nextSlideButton.show();
				}

				return true;
			}
		}
	}, {
		key: 'isValidSlide',
		value: function isValidSlide(slide) {
			var _this4 = this;

			var formFields = slide.find('input:visible, select:visible, textarea:visible'),
			    errors = {},
			    choiceRequired = formFields.eq(0).data('required');
			var valueSet = false;

			formFields.each(function (index, field) {
				$(field).removeClass('error');
				if (field.required && !field.checkValidity()) {
					_this4.addError(field, errors);
				}
				_this4.specialValidation(field, errors);
				if ((field.type === 'checkbox' || field.type === 'radio') && field.checked) {
					valueSet = true;
				}
			});

			if (choiceRequired && !valueSet) {
				this.addError(formFields[0], errors);
			}

			// VSO-409: Custom validation for Step 5 & 6
			if (this.isGuideline1381Active()) {
				if (slide.find('#fOrtStep5').is(':visible')) {
					if (this.fOrtQuestionManager && !this.fOrtQuestionManager.isValid()) {
						var $wizard = slide.find('#fOrtQuestionWizard');
						errors['fOrtQuestions'] = {
							message: $wizard.data('validationmessage') || 'Bitte beantworten Sie alle Fragen oder wählen Sie den Empfehlungswert.'
						};
					}
				}
				if (slide.find('#fMethodeStep6').is(':visible')) {
					if (this.fMethodeManager && !this.fMethodeManager.isValid()) {
						var $step = slide.find('#fMethodeStep6');
						errors['fMethodeSelection'] = {
							message: $step.data('validationmessage') || 'Bitte wählen Sie eine Methode und einen gültigen Faktor.'
						};
					}
				}
			}

			// Additional validation for DWA-A 138-1 area rows
			this.validateArea1381(slide, errors);

			this.displayErrors(slide, errors);

			return Object.keys(errors).length === 0;
		}
	}, {
		key: 'clearSlides',
		value: function clearSlides(slides) {
			var _this5 = this;

			slides.each(function (i, slide) {
				return _this5.clearSlide($(slide));
			});
			this.updateSummary();
		}
	}, {
		key: 'clearSlide',
		value: function clearSlide(slide) {
			this.clearInputs(slide.find('input'));
			this.clearInputs(slide.find('select'));
		}
	}, {
		key: 'clearInputs',
		value: function clearInputs(inputs) {
			var _this6 = this;

			inputs.each(function (i, input) {
				_this6.clearInput(input);
			});
		}
	}, {
		key: 'clearInput',
		value: function clearInput(input) {
			// do not clear inputs on first form load or for inputs that were marked as 'keep'
			if (this.initializing || $(input).data('keep')) return;

			var category = $(input).parents(_ConfigurationFormConfig2.default.selectors.slides).data('category'),
			    property = $(input).data('property');

			if (input.type === 'radio' || input.type === 'checkbox') {
				if (input.checked) input.checked = false;
			} else if (input.type === 'select-one') {
				input.selectedIndex = 0;
			} else if (input.type !== 'submit') {
				input.value = '';
			}

			if ($(input).parent('.checkbox-base').length) {
				if (input.type === 'radio') {
					this.toggleFormDataRadio(input, category, property, true);
				}
				if (input.type === 'checkbox') {
					this.toggleFormDataCheckbox(input, category, property);
				}
			} else {
				if (category && property && this.formData.hasOwnProperty(category) && this.formData[category].hasOwnProperty(property)) {
					this.formData[category][property] = [];
				}
			}

			this.updateFormData(input, false);
		}

		// Validate new DWA-A 138-1 area inputs

	}, {
		key: 'validateArea1381',
		value: function validateArea1381(slide, errors) {
			var _this7 = this;

			try {
				// Only validate if the 138-1 UI is currently active (selected guideline and visible container)
				if (!this.isGuideline1381Active()) {
					return true;
				}
				var $container = $('#areaGuideline1381');
				if (!$container.length || !$container.is(':visible')) {
					return true;
				}
				var $rows = $container.find(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).filter(':visible');
				if (!$rows.length) {
					return true;
				}

				$rows.each(function (i, row) {
					var $row = $(row);
					var $cat = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381);
					var $typeSelect = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select);
					var $typeInput = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Input);
					var $cm = $row.find(_ConfigurationFormConfig2.default.selectors.cm1381);
					var $area = $row.find(_ConfigurationFormConfig2.default.selectors.areaInput);
					var $areaCategorization = $row.find(_ConfigurationFormConfig2.default.selectors.areacategorizationInput);
					var $areaCategorizationDisplay = $row.find(_ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle);

					// Type logic
					if ($cat.length && String($cat.val()) === 'manual') {
						// Manual: require type text and Cm selection
						if ($typeInput.length && String($typeInput.val() || '').trim() === '') {
							_this7.addError($typeInput[0], errors, $typeInput.data('validationmessage'));
						}
						if ($cm.length && (!$cm.val() || String($cm.val()).trim() === '')) {
							_this7.addError($cm[0], errors, $cm.data('validationmessage'));
						}
					} else {}
					// Regular: selects are always prefilled → no additional validation necessary here


					// Area must be > 0
					if ($area.length) {
						var raw = String($area.val() || '').replace(',', '.');
						var num = parseFloat(raw);
						if (!isFinite(num) || num <= 0) {
							_this7.addError($area[0], errors, $area.data('validationmessage'));
						}
					}

					if ($areaCategorization.length) {
						var cat = parseInt($areaCategorization.val());
						if (isNaN(cat) || cat <= 0) {
							_this7.addError($areaCategorizationDisplay[0], errors, $areaCategorization.data('validationmessage'));
						}
					}
				});
				return Object.keys(errors).length === 0;
			} catch (e) {
				// Do not block navigation in case of unexpected issues
				return true;
			}
		}
	}, {
		key: 'specialValidation',
		value: function specialValidation(field, errors) {
			if (field.id === 'availableLength' && parseFloat(field.value) < parseFloat($('#availableWidth').val())) {
				return this.addError(field, errors);
			}

			if (field.id === 'customRunoffValueSignificand' && $('.soilType[data-furtherrequire]').prop('checked')) {
				var customRunoffValue = this.resolveCustomRunoffValueIndexNotation(true);
				if (customRunoffValue > 0.001 || customRunoffValue < 0.000001) {
					return this.addError(field, errors);
				}
			}

			if (field.id === 'kiSignificand' && this.isGuideline1381Active() && this.kiWizardManager.isKiManual() && !this.kiWizardManager.isKiInPermissableRange()) {
				return this.addError(field, errors);
			}

			if ($(field).hasClass('fKInput') && this.isGuideline1381Active()) {
				var raw = String(field.value || '').trim().replace(',', '.');
				var value = parseFloat(raw);
				// 0.03 to 1.00, numerisch
				if (isNaN(value) || value < 0.03 || value > 1.0) {
					return this.addError(field, errors);
				}
			}

			if (field.id === 'propertyZip') {
				// Delegate to LocationManager to respect shared state (country)
				if (!this.locationManager.validateZip(field, errors)) {
					this.locationManager.validateRcIndex(field, errors);
				}
			}

			return true;
		}
	}, {
		key: 'addError',
		value: function addError(field, errors) {
			var errorMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			errors[field.name] = {
				message: errorMsg || $(field).data('validationmessage') || field.validationMessage || 'Bitte prüfen Sie Ihre Eingabe.'
			};
			$(field).addClass('error');
			return false;
		}
	}, {
		key: 'displayErrors',
		value: function displayErrors(slide, errors) {
			var errorBox = slide.find(_ConfigurationFormConfig2.default.selectors.errorList),
			    errorList = errorBox.find('ul');

			if (Object.keys(errors).length) {
				errorBox.show();
				errorList.html('');

				for (var i in errors) {
					errorList.append('<li>' + errors[i].message + '</li>');
				}
			} else {
				errorBox.hide();
			}
		}
	}, {
		key: 'getCurrentSlide',
		value: function getCurrentSlide() {
			return this.getSlide(this.currentSlideIndex);
		}
	}, {
		key: 'getSlide',
		value: function getSlide(index) {
			return this.slides.eq(index);
		}
	}, {
		key: 'updateFormData',
		value: function updateFormData(field) {
			var updateSummary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			var category = $(field).parents(_ConfigurationFormConfig2.default.selectors.slides).data('category'),
			    property = $(field).data('property'),
			    special = $(field).data('special'),
			    value = field.value;

			if (category && !this.formData.hasOwnProperty(category)) {
				this.formData[category] = {};
			}

			if (category && property && !this.formData[category].hasOwnProperty(property)) {
				if (field.type === 'checkbox') {
					this.formData[category][property] = [];
				} else {
					this.formData[category][property] = null;
				}
			}

			if (!category || !property) {
				this.specialFormDataUpdates(special, category, property, value, field);
				this.updateSummary();
				return;
			}

			if (category && property && field.type !== 'submit') {
				if (field.type === 'radio') {
					this.toggleFormDataRadio(field, category, property, updateSummary);
				} else if (field.type === 'checkbox') {
					this.toggleFormDataCheckbox(field, category, property);
				} else {
					this.formData[category][property] = value;
				}
			}

			this.specialFormDataUpdates(special, category, property, value, field);

			if (updateSummary) {
				this.updateSummary();
			}
		}
	}, {
		key: 'specialFormDataUpdates',
		value: function specialFormDataUpdates(special, category, property) {
			var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
			var field = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

			// Only trigger special updates for checked radios (or non-radio fields)
			if (field && field.type === 'radio' && !field.checked) {
				return;
			}

			if (special === 'customRunoffValue') {
				this.formData[category][property] = '' + this.resolveCustomRunoffValueIndexNotation();
			}

			if (special === 'installationSituation') {
				this.formData[category][$(_ConfigurationFormConfig2.default.selectors.rainFrequencySelect).data('property')] = this.getSpecialInstallationSituationSummary();
			}

			if (special === 'roofArea') {
				// Ensure category bucket exists to avoid hasOwnProperty on undefined
				var effectiveCategory = category;
				if (!effectiveCategory) {
					// try to derive from field's slide, else fallback to 'area'
					if (field) {
						effectiveCategory = $(field).parents(_ConfigurationFormConfig2.default.selectors.slides).data('category') || 'area';
					} else {
						effectiveCategory = 'area';
					}
				}
				if (!this.formData.hasOwnProperty(effectiveCategory) || _typeof(this.formData[effectiveCategory]) !== 'object') {
					this.formData[effectiveCategory] = {};
				}
				var summaryProperty = $(_ConfigurationFormConfig2.default.selectors.areaTypeSelect).eq(0).data('property') || 'roofAreaSummary';
				if (!this.formData[effectiveCategory].hasOwnProperty(summaryProperty)) {
					this.formData[effectiveCategory][summaryProperty] = null;
				}
				this.formData[effectiveCategory][summaryProperty] = this.getSpecialRoofAreaSummary();
			}

			if (special === 'infiltrationType') {
				this.infiltrationTypeChange(parseInt(value));
			}

			if (special === 'resilience') {
				this.resilienceChange($(field));
			}

			if (special === 'permittedDischarge' && parseInt(value) > 0) {
				var unit = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeUnitInput)[0].selectedOptions[0].textContent;
				this.formData[category][property] = value + ' ' + unit;
			}

			if (special === 'newGuideline' && this.state.country !== _ConfigurationFormConfig2.default.values.countries.GERMANY) {
				delete this.formData[category];
			}
		}
	}, {
		key: 'getSpecialInstallationSituationSummary',
		value: function getSpecialInstallationSituationSummary() {
			var fields = [$(_ConfigurationFormConfig2.default.selectors.availableLength), $(_ConfigurationFormConfig2.default.selectors.availableWidth), $(_ConfigurationFormConfig2.default.selectors.groundwaterDistance), $(_ConfigurationFormConfig2.default.selectors.channelConnectionHeight)];

			// VSO-489: omit the rain frequency while it is disabled (DWA-A 138-1)
			var $rainFrequencySelect = $(_ConfigurationFormConfig2.default.selectors.rainFrequencySelect);
			var summary = $rainFrequencySelect.prop('disabled') ? '' : $rainFrequencySelect.find(':selected').text() + '<br>';
			var anyFieldFilled = false;

			for (var i in fields) {
				var field = fields[i],
				    value = field.val();
				if (value && value !== '0') {
					summary += field.data('speciallabel') + ' ' + value + ' | ';
					anyFieldFilled = true;
				}
			}
			if (anyFieldFilled) {
				return summary.substring(0, summary.length - 2);
			}
			return '';
		}
	}, {
		key: 'getSpecialRoofAreaSummary',
		value: function getSpecialRoofAreaSummary() {
			// If the new 138-1 UI is active, build summary as: "xxm² | Flächenart | Flächentyp"
			var blocks1381 = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381);
			if (this.isGuideline1381Active() && blocks1381.length) {
				// Only show after user reached this slide
				var slideIndex = $('#areaGuideline1381').parents(_ConfigurationFormConfig2.default.selectors.slides).data('slideindex');
				if (parseInt(slideIndex) > this.slideProgress) {
					return '';
				}
				var summary1381 = [];
				blocks1381.each(function (index, el) {
					var $b = $(el);
					var areaVal = ($b.find(_ConfigurationFormConfig2.default.selectors.areaInput).val() || '').trim();
					var $cat = $b.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381);
					var catText = $cat.length ? ($cat.find(':selected').text() || '').trim() : '';
					var typeText = '';
					if ($cat.length && $cat.val() === 'manual') {
						typeText = ($b.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Input).val() || '').trim();
					} else {
						typeText = ($b.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select).find(':selected').text() || '').trim();
					}

					var parts = [];
					if (areaVal) {
						parts.push(areaVal + 'm\xB2');
					}
					if (catText) {
						parts.push(catText);
					}
					if (typeText) {
						parts.push(typeText);
					}
					if (parts.length && areaVal) {
						summary1381.push(parts.join(' | '));
					}
				});
				return summary1381;
			}

			// Fallback: old path (DWA-A 138)
			var blocks = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock);
			var summary = [];

			blocks.each(function (index, block) {
				var summaryLine = '',
				    $block = $(block),
				    fields = [$block.find(_ConfigurationFormConfig2.default.selectors.areaInput), $block.find(_ConfigurationFormConfig2.default.selectors.coefficientSelect), $block.find(_ConfigurationFormConfig2.default.selectors.areaTypeSelect), $block.find(_ConfigurationFormConfig2.default.selectors.runofftypeSelect)];

				for (var i in fields) {
					var field = fields[i];
					var value = field.val();

					if (field.prop('tagName') === 'SELECT') {
						value = field.find(':selected').text();
					}

					if (value && value !== '0') {
						if (parseInt(i) === 0) {
							value += 'm²';
						}

						summaryLine += value + ' | ';
					}
				}

				if (fields[0].val()) {
					summary.push(summaryLine.substring(0, summaryLine.length - 2));
				}
			});

			return summary;
		}
	}, {
		key: 'toggleFormDataRadio',
		value: function toggleFormDataRadio(field, category, property) {
			var deselect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

			var value = $(field).data('value'),
			    container = $(field).parents(_ConfigurationFormConfig2.default.selectors.checkboxRoot),
			    propertyInputs = $('[data-property="' + property + '"]');

			if (deselect) {
				propertyInputs.each(function (i, input) {
					$(input).parents(_ConfigurationFormConfig2.default.selectors.checkboxRoot).removeClass('checked');
				});
			}

			if (field.checked) {
				container.addClass('checked');
				this.formData[category][property] = value;
			}
		}
	}, {
		key: 'toggleFormDataCheckbox',
		value: function toggleFormDataCheckbox(field, category, property) {
			if (typeof this.formData[category][property] !== "undefined") {
				var value = $(field).data('value'),
				    container = $(field).parents(_ConfigurationFormConfig2.default.selectors.checkboxRoot + ', ' + _ConfigurationFormConfig2.default.selectors.squareCheckboxRoot);

				if (!field.checked) {
					container.removeClass('checked');
					// Remove all occurrences of value to avoid leftovers/duplicates
					this.formData[category][property] = this.formData[category][property].filter(function (v) {
						return v !== value;
					});
				} else {
					container.addClass('checked');
					// Prevent duplicate pushes
					if (!this.formData[category][property].includes(value)) {
						this.formData[category][property].push(value);
					}
				}
			}
		}
	}, {
		key: 'updateSummary',
		value: function updateSummary() {
			var _this8 = this;

			this.configurationSummary.html('');
			// get labels for fOrt and fMethode (those are keys in formData)
			var fKLabel = $('.fKValue').data('property');
			var fOrtLabel = $('.fortValue').data('property');
			var fMethodeLabel = $('.fMethodeValue').data('property');
			// get states of ki and fK
			var kiIsManual = this.kiWizardManager ? this.kiWizardManager.getDecision() === 1 : false;
			var fKIsManual = this.fkWizardManager ? this.fkWizardManager.getDecision() === 1 : false;
			// check if properties should be skipped
			var skipProperties = [];
			// skip fOrt and fMethode if ki or fK is manual
			if (kiIsManual || fKIsManual) {
				skipProperties.push(fOrtLabel, fMethodeLabel);
			}
			// also skip fK if ki is manual
			if (kiIsManual) {
				skipProperties.push(fKLabel);
			}

			for (var category in this.formData) {
				var renderCategory = Object.values(this.formData[category]).some(function (value) {
					if (Array.isArray(value)) {
						return value.length;
					}
					return value !== null && value !== "" && value !== 0 && value !== "0";
				});

				if (renderCategory) {
					this.configurationSummary.append('<p class="summaryCategory">' + category + '</p>');

					for (var property in this.formData[category]) {
						if (skipProperties.includes(property)) {
							continue;
						}
						var value = this.formData[category][property];

						if (Array.isArray(value)) {
							value = value.join('<br>');
						}
						if (value !== null && value !== "" && value !== 0 && value !== "0") {
							this.configurationSummary.append('<div class="summaryItem" data-summaryproperty="' + property + '"><p class="summaryProperty">' + property + '</p><p class="summaryValue">' + value + '</p></div>');
						}
					}
				}
			}

			var summaryProperties = $('.summaryItem');
			summaryProperties.off('click');
			summaryProperties.on('click', function (e) {
				var property = $(e.delegateTarget).data('summaryproperty');
				var targetSlide = null;
				var firstMatchingInput = _this8.form.find('[data-property="' + property + '"]').eq(0);
				if (firstMatchingInput.length) {
					targetSlide = parseInt(firstMatchingInput.parents(_ConfigurationFormConfig2.default.selectors.slides).data('slideindex'));
				}
				if (targetSlide !== null && !isNaN(targetSlide)) {
					_this8.goToSlide(targetSlide);
				}
			});
		}

		// Legacy area handlers moved to AreaManagerLegacy (Modules/AreaManagerLegacy.js)

	}, {
		key: 'bindPermittedDischargeHandlers',
		value: function bindPermittedDischargeHandlers() {
			var _this9 = this;

			var permittedDischarge = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeInput),
			    permittedDischargeUnit = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeUnitInput),
			    rainDrainage = $(_ConfigurationFormConfig2.default.selectors.rainDrainageInput),
			    rainDrainageArea = $(_ConfigurationFormConfig2.default.selectors.rainDrainageAreaInput),
			    ignorePermittedDischarge = $(_ConfigurationFormConfig2.default.selectors.ignorePermittedDischargeCheckbox);

			// Initialize and check, if values exist (form was submitted)
			if (rainDrainageArea.val() > 0 && rainDrainage.val() > 0) {
				permittedDischarge.prop('disabled', true);
			} else if (permittedDischarge.val() > 0) {
				rainDrainage.prop('disabled', true);
				rainDrainageArea.prop('disabled', true);
			}
			if (permittedDischargeUnit.val() == 1) {
				permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
			}

			// Change placeholder if unit is changed
			permittedDischargeUnit.on('change keyup', function (e) {
				_this9.validatePermittedDischarge();

				if (permittedDischargeUnit.val() == 1) {
					permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-lmin'));
				} else {
					permittedDischarge.prop('placeholder', permittedDischarge.data('placeholder-ls'));
				}
				_this9.updateFormData(permittedDischarge[0]);
			});
			// Validate permittedDischarge if ignorePermittedDischarge is changed
			ignorePermittedDischarge.on('click', function (e) {
				_this9.validatePermittedDischarge();
			});

			// Disable rainDrainage if permittedDischarge is changed
			permittedDischarge.on('change keyup', function (e) {
				_this9.validatePermittedDischarge();

				if (permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
					rainDrainage.prop('disabled', false);
					rainDrainageArea.prop('disabled', false);
				} else {
					rainDrainage.prop('disabled', true);
					rainDrainageArea.prop('disabled', true);
				}
			});
			// Disable permittedDischarge if rainDrainage is changed
			rainDrainage.on('change keyup', function (e) {
				if (rainDrainage.val() === '' || rainDrainage.val() == 0) {
					permittedDischarge.prop('disabled', false);
				} else {
					permittedDischarge.prop('disabled', true);
				}
			});
		}
	}, {
		key: 'validatePermittedDischarge',
		value: function validatePermittedDischarge() {
			var permittedDischarge = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeInput),
			    permittedDischargeUnit = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeUnitInput),
			    rainDrainageInput = $(_ConfigurationFormConfig2.default.selectors.rainDrainageInput),
			    rainDrainageAreaInput = $(_ConfigurationFormConfig2.default.selectors.rainDrainageAreaInput),
			    ignorePermittedDischarge = $(_ConfigurationFormConfig2.default.selectors.ignorePermittedDischargeCheckbox),
			    permittedDischargeError = $(_ConfigurationFormConfig2.default.selectors.permittedDischargeError);

			if (ignorePermittedDischarge.is(':checked')) {
				permittedDischarge.prop('required', false);
				rainDrainageInput.prop('required', false);
				rainDrainageAreaInput.prop('required', false);
			} else {
				permittedDischarge.prop('required', true);
				rainDrainageInput.prop('required', true);
				rainDrainageAreaInput.prop('required', true);
			}

			if (ignorePermittedDischarge.is(':checked') || permittedDischarge.val() === '' || permittedDischarge.val() == 0) {
				permittedDischargeError.remove();
				return;
			}

			var inputVal = parseFloat(permittedDischarge.val().replace(",", ".")),
			    min = permittedDischarge.data('min-ls'),
			    max = permittedDischarge.data('max-ls'),
			    errorMessage = permittedDischarge.data('placeholder-ls');
			if (permittedDischargeUnit.val() == 1) {
				min = permittedDischarge.data('min-lmin');
				max = permittedDischarge.data('max-lmin');
				errorMessage = permittedDischarge.data('placeholder-lmin');
			}

			if (inputVal < min || inputVal > max) {
				permittedDischargeError.remove();
				permittedDischarge.after('<p class="error" id="permittedDischargeError">' + errorMessage + '</p>');
			} else {
				permittedDischargeError.remove();
			}
		}

		/**
   * Switch infiltrationType dependent form fields
   * Also disable products based on infiltration type (and resilience)
   *
   * @param infiltrationType
   * @param activeSelection bool
   */

	}, {
		key: 'infiltrationTypeChange',
		value: function infiltrationTypeChange(infiltrationType) {
			var _this10 = this;

			var activeSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if ([_ConfigurationFormConfig2.default.values.infiltrationType.RIGOLE, _ConfigurationFormConfig2.default.values.infiltrationType.TROUGH_RIGOLE].includes(infiltrationType)) {
				$(_ConfigurationFormConfig2.default.selectors.rigoleOnly).show();
				$(_ConfigurationFormConfig2.default.selectors.retentionOnly).hide();
				// disable all retention fields so they do not get submitted
				$(_ConfigurationFormConfig2.default.selectors.retentionOnly + ' input').prop('disabled', true);
				// enable rigole related inputs again (incl. guideline radios)
				$(_ConfigurationFormConfig2.default.selectors.rigoleOnly + ' input').not('[data-infiltrationnotpossible="1"]').prop('disabled', false);
				$(_ConfigurationFormConfig2.default.selectors.soilTypeInputs).prop('required', true);
				// guidelines logic (also see LocationManager -> countryChange)
				// force all countries except germany into legacy guideline
				if (this.state.country !== _ConfigurationFormConfig2.default.values.countries.GERMANY) {
					// preselect legacy guideline and disable guidelines selection for other countries
					$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).click();
					$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).parents(_ConfigurationFormConfig2.default.selectors.slides).data('skip', true);
				} else {
					$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).parents(_ConfigurationFormConfig2.default.selectors.slides).data('skip', false);
				}
			}

			if (_ConfigurationFormConfig2.default.values.infiltrationType.RETENTION_CISTERN === infiltrationType) {
				if (activeSelection) {
					this.clearSlides($(_ConfigurationFormConfig2.default.selectors.productSelectionSlide).nextAll(_ConfigurationFormConfig2.default.selectors.slides));
				}
				$(_ConfigurationFormConfig2.default.selectors.retentionOnly).show();
				$(_ConfigurationFormConfig2.default.selectors.retentionOnly + ' input').not('[data-infiltrationnotpossible="1"]').prop('disabled', false);
				$(_ConfigurationFormConfig2.default.selectors.rigoleOnly).hide();
				// disable all rigole fields so they do not get submitted
				$(_ConfigurationFormConfig2.default.selectors.rigoleOnly + ' input').prop('disabled', true);
				// clear guideline selection since it is not relevant for retention
				this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios).prop('checked', false);
				// Also clear any visual selection state on the guideline radio wrappers to avoid UI/validation mismatch
				this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios).each(function (i, el) {
					$(el).parents(_ConfigurationFormConfig2.default.selectors.checkboxRoot).removeClass('checked');
				});
				// Also remove the guideline entry from the sidebar summary data
				var $firstGuideline = this.form.find(_ConfigurationFormConfig2.default.selectors.newGuidelineRadios).eq(0);
				if ($firstGuideline.length) {
					var guidelineProperty = $firstGuideline.data('property');
					var guidelineCategory = $firstGuideline.parents(_ConfigurationFormConfig2.default.selectors.slides).data('category');
					if (guidelineProperty && guidelineCategory && this.formData[guidelineCategory] && typeof this.formData[guidelineCategory][guidelineProperty] !== 'undefined') {
						delete this.formData[guidelineCategory][guidelineProperty];
					}
				}
				// Clear validation errors on slides that are not relevant for retention (contain rigoleOnly content)
				// to prevent error-only slides from appearing when navigating.
				var rigoleSlides = this.slides.filter(function (i, el) {
					return $(el).find(_ConfigurationFormConfig2.default.selectors.rigoleOnly).length > 0;
				});
				rigoleSlides.find(_ConfigurationFormConfig2.default.selectors.errorList).hide().find('ul').html('');
				rigoleSlides.find('input, select, textarea').removeClass('error');
				$(_ConfigurationFormConfig2.default.selectors.soilTypeInputs).prop('required', false);
			}

			// VSO-309: add rainwater utilisation also to rigole
			if ([_ConfigurationFormConfig2.default.values.infiltrationType.RIGOLE, _ConfigurationFormConfig2.default.values.infiltrationType.RETENTION_CISTERN].includes(infiltrationType)) {
				$(_ConfigurationFormConfig2.default.selectors.rainwaterUtilisationOnly).show();
				$(_ConfigurationFormConfig2.default.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', false);
				// only activate attenuationPlus inputs if checkbox is checked!
				if ($(_ConfigurationFormConfig2.default.selectors.attenuationPlusCheckbox).prop('checked') !== true) {
					$(_ConfigurationFormConfig2.default.selectors.attenuationPlusRow + ' input').prop('disabled', true);
				}
			} else {
				$(_ConfigurationFormConfig2.default.selectors.rainwaterUtilisationOnly).hide();
				// disable all rainwater utilisation fields so they do not get submitted
				$(_ConfigurationFormConfig2.default.selectors.rainwaterUtilisationOnly + ' input').prop('disabled', true);
			}

			if (activeSelection) {
				// deselect previously selected product types
				var productCheckboxes = $(_ConfigurationFormConfig2.default.selectors.productCheckbox + ':checked').add($(_ConfigurationFormConfig2.default.selectors.retentionProductCheckbox + ':checked'));

				productCheckboxes.each(function (i, field) {
					var category = $(field).parents(_ConfigurationFormConfig2.default.selectors.slides).data('category'),
					    property = $(field).data('property');

					$(field).prop('checked', false);
					_this10.toggleFormDataCheckbox(field, category, property);
				});
			}

			// disable products based on infiltration type and resilience
			var $resilienceId = $(_ConfigurationFormConfig2.default.selectors.resilienceRadio + ':checked').val();
			this.updateDisabledProducts($resilienceId, infiltrationType);

			// VSO-409: Restore wizard step visibilities/skips after infiltrationTypeChange
			// which might have pauschally re-enabled inputs in rigoleOnly slides.
			if (this.kiWizardManager) this.kiWizardManager.updateVisibility();
			if (this.fkWizardManager) this.fkWizardManager.updateVisibility();
			if (this.fOrtQuestionManager) this.fOrtQuestionManager.updateVisibility();
			if (this.fMethodeManager) this.fMethodeManager.updateVisibility();

			// VSO-489: covers Mulden-Rigole <-> Rigole/Retention switches while 138-1 stays selected
			this.updateRainFrequencyDisabledState();

			// Always refresh the summary to immediately reflect changes
			// such as cleared guideline selection or product switches.
			this.updateSummary();
		}

		// Show additional fields if attenuation plus is checked and not disabled

	}, {
		key: 'attenuationPlusChange',
		value: function attenuationPlusChange(checkbox) {
			if (!checkbox.prop('disabled') && checkbox.prop('checked')) {
				$(_ConfigurationFormConfig2.default.selectors.attenuationPlusRow).show();
				$(_ConfigurationFormConfig2.default.selectors.attenuationPlusRow + ' input').prop('disabled', false);
			} else {
				$(_ConfigurationFormConfig2.default.selectors.attenuationPlusRow).hide();
				// disable fields so they do not get submitted
				$(_ConfigurationFormConfig2.default.selectors.attenuationPlusRow + ' input').prop('disabled', true);
			}
		}
	}, {
		key: 'setCustomRunoffValueIndexNotation',
		value: function setCustomRunoffValueIndexNotation() {
			var significand = parseFloat(this.customRunoffValueInput.val());

			if (significand > 0) {
				var exponent = 0;

				while (significand < 1 && exponent > -6) {
					significand *= 10;
					exponent--;
				}

				this.customRunoffValueSignificand.val(_MathUtility2.default.formatFloat(Math.round(significand * 100) / 100));
				this.customRunoffValueExponent.val(exponent);
			}
		}
	}, {
		key: 'resolveCustomRunoffValueIndexNotation',
		value: function resolveCustomRunoffValueIndexNotation() {
			var returnRaw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			var rawSignificand = String(this.customRunoffValueSignificand.val() || '').trim().replace(',', '.');
			var rawExponent = String(this.customRunoffValueExponent.val() || '').trim();

			var significandNum = parseFloat(rawSignificand);

			if (significandNum >= 1 && significandNum <= 9.9) {
				this.customRunoffValueInput.prev('input').prop('checked', true);

				var value = _MathUtility2.default.resolveIndexNotation(rawSignificand, rawExponent);
				var formattedValue = _MathUtility2.default.formatFloat(value);

				this.customRunoffValueInput.val(formattedValue);
				this.runoffValueIndexNotationResult.html('(' + formattedValue + ')');

				if (returnRaw) {
					return value;
				}
				return formattedValue;
			} else {
				this.customRunoffValueInput.val(0);
				this.runoffValueIndexNotationResult.html('');
				return '';
			}
		}

		// CHANGE: fillCmCsSelect moved to AreaManagerNew (DWA-A 138-1) to keep it close to usage and
		// avoid additional back-dependency on the host. Behaviour unchanged.

	}, {
		key: 'createOptionElement',
		value: function createOptionElement(value, label) {
			var additionalAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

			var option = document.createElement('option');
			option.setAttribute('value', value);
			option.innerHTML = label;

			additionalAttributes.forEach(function (attribute) {
				option.setAttribute(attribute.key, attribute.value);
			});

			return option;
		}

		/**
   * Resilience info should be on page
   *
   * @param $field selected resilience checkbox
   */

	}, {
		key: 'resilienceChange',
		value: function resilienceChange($field) {
			var infiltrationTypeId = parseInt($(_ConfigurationFormConfig2.default.selectors.infiltrationType + ':checked').val());
			if (infiltrationTypeId && $field && $field.prop('checked')) {
				this.updateDisabledProducts(parseInt($field.val()), infiltrationTypeId);
			}
		}

		/**
   * Disable products based on resilience and infiltration type
   *
   * @param resilience
   * @param infiltrationType
   */

	}, {
		key: 'updateDisabledProducts',
		value: function updateDisabledProducts(resilience, infiltrationType) {
			// Enable all products
			var $productCheckboxes = $(_ConfigurationFormConfig2.default.selectors.productCheckbox);
			$productCheckboxes.prop('disabled', '');
			$productCheckboxes.parents('.checkbox-wrapper').removeClass('disabled');

			// Disable products based on resilience
			if (typeof disableResiliences !== 'undefined') {
				$productCheckboxes.each(function (index, element) {
					if (disableResiliences[element.value] !== undefined && disableResiliences[element.value].indexOf(parseInt(resilience)) > -1) {
						$(element).prop('disabled', true);
						$(element).parents('.checkbox-wrapper').addClass('disabled');
					}
				});
			}

			// Disable products based on infiltrationType
			if (typeof disableProducts !== 'undefined' && disableProducts[infiltrationType] !== undefined) {
				disableProducts[infiltrationType].forEach(function (element) {
					$('#product' + element).prop('disabled', true);
				});
			}
		}
	}, {
		key: 'updateProcessorSelect',
		value: function updateProcessorSelect(team) {
			var _this11 = this;

			_AjaxUtility2.default.request('Administration', {
				controller: 'Configuration',
				action: 'getTeamMembers',
				team: team
			}).done(function (response) {
				var $processorSelect = $(_ConfigurationFormConfig2.default.selectors.processorSelect),
				    members = JSON.parse(response),

				// keep the current processor selected if they are a member of the new team
				currentProcessor = $processorSelect.val();
				$processorSelect[0].length = 0;

				for (var key in members) {
					$processorSelect[0].options.add(_this11.createOptionElement(key, members[key]));
				}

				if (currentProcessor && members.hasOwnProperty(currentProcessor)) {
					$processorSelect.val(currentProcessor);
				}
			});
		}

		// Keep delegate method to process this[action]() within goToSlide method

	}, {
		key: 'setWeatherStationManually',
		value: function setWeatherStationManually() {
			// Delegate to LocationManager
			if (this.locationManager) {
				this.locationManager.setWeatherStationManually();
			}
		}
	}, {
		key: 'activateGroundReportFilesUpload',
		value: function activateGroundReportFilesUpload() {
			$(_ConfigurationFormConfig2.default.selectors.groundReportFilesUploadHidden).prop('checked', true);
			$(_ConfigurationFormConfig2.default.selectors.soilTypeSelectionContainer).hide().find('input').prop('checked', false).prop('required', false);
			$(_ConfigurationFormConfig2.default.selectors.groundReportFilesUploadNotification).show();
			this.customRunoffValueInput.val('');
			this.customRunoffValueSignificand.val('');
			this.customRunoffValueExponent[0].selectedIndex = 0;
			this.resolveCustomRunoffValueIndexNotation();
		}
	}, {
		key: 'deactivateGroundReportFilesUpload',
		value: function deactivateGroundReportFilesUpload() {
			$(_ConfigurationFormConfig2.default.selectors.groundReportFilesUploadHidden).prop('checked', false);
			$(_ConfigurationFormConfig2.default.selectors.soilTypeSelectionContainer).hide().find('input').prop('required', true);
			$(_ConfigurationFormConfig2.default.selectors.soilTypeSelectionContainer).show();
			$(_ConfigurationFormConfig2.default.selectors.groundReportFilesUploadNotification).hide();
		}
	}, {
		key: 'customerTypeBasedToggles',
		value: function customerTypeBasedToggles(customerType) {
			// toggle company input
			var companyInput = $(_ConfigurationFormConfig2.default.selectors.companyInput);

			// if is type end customer
			if (customerType === _ConfigurationFormConfig2.default.values.customerTypes.END_CUSTOMER) {
				companyInput.val('');
				companyInput.hide();
			} else {
				companyInput.show();
			}

			// toggle graf-partner row
			var grafPartnerRow = $(_ConfigurationFormConfig2.default.selectors.grafPartnerRow);
			var grafPartnerCheckbox = $(_ConfigurationFormConfig2.default.selectors.grafPartnerCheckbox);

			// if is type end customer or processor
			if (customerType === _ConfigurationFormConfig2.default.values.customerTypes.END_CUSTOMER || customerType === _ConfigurationFormConfig2.default.values.customerTypes.PROCESSORS) {
				grafPartnerRow.show();
				$(_ConfigurationFormConfig2.default.selectors.grafPartnerRow + ' input').prop('disabled', false);
				// only activate partner input if checkbox is checked!
				if (grafPartnerCheckbox.prop('checked') !== true) {
					$(_ConfigurationFormConfig2.default.selectors.grafPartnerInput).prop('disabled', true);
				}
			} else {
				grafPartnerRow.hide();
				$(_ConfigurationFormConfig2.default.selectors.grafPartnerRow + ' input').prop('disabled', true);
			}
		}
	}, {
		key: 'grafPartnerCheckboxToggle',
		value: function grafPartnerCheckboxToggle(checked) {
			var grafPartnerInput = $(_ConfigurationFormConfig2.default.selectors.grafPartnerInput);
			if (checked) {
				grafPartnerInput.show();
				grafPartnerInput.prop('disabled', false);
			} else {
				grafPartnerInput.hide();
				grafPartnerInput.prop('disabled', true);
			}
		}
	}, {
		key: 'equalizeCheckboxDescriptions',
		value: function equalizeCheckboxDescriptions() {
			$('[data-equalizedescriptions]').each(function (index, container) {
				var descriptions = $(container).find(_ConfigurationFormConfig2.default.selectors.checkboxDescription);
				descriptions.css('height', '');
				var maxHeight = descriptions.toArray().reduce(function (carry, description) {
					return Math.max(carry, description.clientHeight);
				}, 0);
				descriptions.css('height', maxHeight);
			});
		}
	}]);

	return ConfigurationForm;
}();

exports.default = ConfigurationForm;

},{"../Utility/AjaxUtility":15,"../Utility/MathUtility":16,"./ConfigurationFormConfig":4,"./Modules/AreaManagerLegacy":5,"./Modules/AreaManagerNew":6,"./Modules/FKWizardManager":7,"./Modules/FMethodeManager":8,"./Modules/FOrtQuestionManager":9,"./Modules/KiWizardManager":10,"./Modules/LocationManager":11}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var FormConfig = {

	selectors: {
		slides: '.configurationSlide',
		nextSlideButton: '#nextSlide',
		errorList: '.errorList',
		configurationSummary: '#configurationSummary',
		productSelectionSlide: '#product-selection-slide',
		kiSlide: '#ki-value-slide',
		fkSlide: '#fk-value-slide',

		infiltrationType: '.infiltrationType',
		rigoleOnly: '.rigoleOnly',
		retentionOnly: '.retentionOnly',
		rainwaterUtilisationOnly: '.rainwaterUtilisationOnly',
		country: '.country',
		propertyType: '.propertyType',
		weatherStation: '#weatherStation',

		configurationForm: '#configurationForm',
		rcIndexInput: '#rcIndexValue',
		rcIndexOutput: '#currentRcIndex',
		originalGridIndexInput: '#originalGridIndexValue',
		regionInput: '#regionValue',
		customRunoffValueInput: '#customRunoffValue',
		customRunoffValueIndexNotation: '#customRunoffValueIndexNotation',
		customRunoffValueSignificand: '#customRunoffValueSignificand',
		customRunoffValueExponent: '#customRunoffValueExponent',
		runoffValueIndexNotationResult: '#runoffValueIndexNotationResult',
		kiIndexNotationResult: '#kiIndexNotationResult',
		addAreaTypeButton: '#addAreaType',
		addAreaTypeLimitReached: '#addAreaTypeLimitReached',
		removeAreaTypeButton: '.removeAreaType',
		areaTypeBlock: '.areaTypeBlock',
		// DWA-A 138-1 selectors
		addAreaType1381Button: '#addAreaType1381',
		addAreaType1381LimitReached: '#addAreaType1381LimitReached',
		areacategorizationInput: '.areacategorization',
		areaCategorizationDisplayToggle: '.areacategorization-display',
		areacategorizationSelection: '.areacategorization-selection',
		areacategorizationRow: '.areacategorization-row',
		loadCategory: '.load-category',
		removeAreaType1381Button: '.removeAreaType1381',
		areaTypeBlock1381: '.areaTypeBlock1381',
		surfaceCategory1381: '.surfaceCategory1381',
		surfaceType1381Select: '.surfaceType1381Select',
		surfaceType1381Input: '.surfaceType1381Input',
		cm1381: '.cm1381',
		cs1381: '.cs1381',
		areaTypeSelect: '.roofType',
		runofftypeSelect: '.runoffType',
		runofftypeValue: '.runoffTypeValue',
		coefficientSelect: '.coefficient',
		coefficientValue: '.coefficientValue',
		areaInput: '.area',
		cityInput: '#city',
		citySelect: '#citySelect',
		resilienceRadio: '.resilience',
		productCheckbox: '.products',
		retentionProductCheckbox: '.retentionProducts',
		assignedTeamSelect: '#assignedTeam',
		processorSelect: '#processor',
		weatherStationCheckLoading: '#weatherStationCheckLoading',
		rainwaterMapLoading: '#rainwaterMapLoading',
		weatherStationCheckResult: '#weatherStationCheckResult',
		weatherstationMapResult: '#weatherstationMapResult',
		manualWeatherStationSelection: '.manualWeatherStationSelection',
		propertyStreetInput: '#street',
		propertyZipInput: '#propertyZip',
		propertyCityInput: '#propertyCity',
		propertyCityDisplay: '#propertyCityDisplay',
		configurationSubmit: '#configurationSubmit',
		groundReportInfoStep1: '#groundReportInfoStep1',
		groundReportInfoStep2: '#groundReportInfoStep2',
		activateGroundReportFilesUploadButton: '#activateGroundReportFilesUpload',
		confirmGroundReportFilesUpload: '#confirmGroundReportFilesUpload',
		cancelGroundReportFilesUpload: '.cancelGroundReportFilesUpload',
		groundReportFilesUploadHidden: '#groundReportFilesUpload',
		soilTypeSelectionContainer: '#soilTypeSelection',
		soilTypeInputs: '.soilType',
		groundReportFilesUploadNotification: '#groundReportFilesUploadNotification',
		clientTypeSelect: '#clientTypes',
		companyInput: '#clientCompany',
		changeWeatherStation: '#changeWeatherStation',
		weatherStationZip: '#weatherStationZip',
		confirmManualWeatherStationSelection: '#confirmManualWeatherStationSelection',
		grafPartnerRow: '.row.graf-partner',
		grafPartnerCheckbox: '#hasGrafPartner',
		grafPartnerInput: '#clientGrafPartner > input',
		attenuationPlusRow: '.row.attenuationPlus',
		attenuationPlusCheckbox: 'input.attenuationPlusCheckbox',
		permittedDischargeInput: '#permittedDischarge',
		permittedDischargeUnitInput: '#permittedDischargeUnit',
		rainDrainageInput: '#rainDrainage',
		rainDrainageAreaInput: '#area',
		permittedDischargeError: '#permittedDischargeError',
		ignorePermittedDischargeCheckbox: '#ignorePermittedDischarge',
		rainFrequencySelect: '#rainFrequency',
		groundwaterDistance: '#groundwaterDistance',
		availableLength: '#availableLength',
		availableWidth: '#availableWidth',
		channelConnectionHeight: '#channelConnectionHeight',
		progressButton: '.progress-button',
		backButton: '.progress-back-button',
		progressMeter: '#progress-bar .meter',
		inquiryIntro: '#inquiry-intro',
		startCalculatorButton: '#start-calculator',
		calculator: '#calculator',
		checkboxRoot: '.checkbox-root',
		checkboxTeaser: '.checkbox-teaser',
		squareCheckbox: '.square-checkbox-container',
		squareCheckboxRoot: '.square-checkbox-root',
		nextSlideScrollTarget: '#next-slide-scroll-target',
		checkboxDescription: '.checkbox-description',
		newGuidelineRadios: '.newGuideline',
		legacyGuidelineRadio: '#newGuideline0',
		newGuidelineRadio: '#newGuideline1'
	},

	values: {
		infiltrationType: {
			RIGOLE: 1,
			TROUGH_RIGOLE: 2,
			RETENTION_CISTERN: 3
		},
		customerTypes: {
			END_CUSTOMER: 1,
			PROCESSORS: 2
		},
		countries: {
			GERMANY: 1,
			AUSTRIA: 2,
			SWITZERLAND: 3,
			BELGIUM: 4,
			NETHERLANDS: 5,
			LUXEMBOURG: 6
		}
	},

	// CHANGE: Centralized UI/configuration constants for the form
	// Keep defaults here so managers/host can consume a single source of truth.
	settings: {
		// Maximum number of area rows allowed (used by both legacy 138 and new 138-1 managers)
		areaTypeMax: 14,
		// Step for coefficient/Cm/Cs dropdowns; negative value means count downwards
		coefficientStep: -0.05
	}
};

exports.default = FormConfig;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('../ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

var _AjaxUtility = require('../../Utility/AjaxUtility');

var _AjaxUtility2 = _interopRequireDefault(_AjaxUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * AreaManagerLegacy (DWA-A 138)
 *
 * Responsibility:
 * - addAreaType, removeAreaType
 * - fillAreaTypeData (incl. runoffTypes caching/AJAX)
 * - fillRunoffTypeSelect, fillCoefficientSelect
 * - bindAreaTypeSelectHandlers, updateIndexes, setIndexes, toggleRemoveButtons
 *
 * Notes:
 * - Behaviour is kept 1:1 from ConfigurationForm.js, only extracted into this class.
 * - Calls to updateFormData/updateSummary now go through the provided host (ConfigurationForm) instance.
 *   // CHANGE: Use host.updateFormData() instead of this.updateFormData() because logic moved to manager.
 * - Added console.log at critical actions (add/remove/fetch/cache).
 */
var AreaManagerLegacy = function () {
    /**
     * @param {jQuery} form
     * @param {Object} state shared state (unused here but kept for symmetry)
     * @param {Object} host instance of ConfigurationForm (for callbacks)
     */
    function AreaManagerLegacy(form, state, host) {
        _classCallCheck(this, AreaManagerLegacy);

        this.form = form;
        this.state = state;
        this.host = host;

        // Local state (copied from original ConfigurationForm)
        // CHANGE: Read centralized values from FormConfig.settings first; keep safe fallbacks
        this.coefficientSteps = _ConfigurationFormConfig2.default.settings && typeof _ConfigurationFormConfig2.default.settings.coefficientStep !== 'undefined' ? _ConfigurationFormConfig2.default.settings.coefficientStep : -0.05;
        this.areaTypeMax = _ConfigurationFormConfig2.default.settings && typeof _ConfigurationFormConfig2.default.settings.areaTypeMax !== 'undefined' ? _ConfigurationFormConfig2.default.settings.areaTypeMax : 14;
        this.areaTypeCount = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock).length;
        this.runoffTypes = {}; // cache per areaType
    }

    _createClass(AreaManagerLegacy, [{
        key: 'disableIfSingleOption',
        value: function disableIfSingleOption($select) {
            if ($select.length && $select[0]) {
                if ($select[0].options.length === 1) {
                    $select.addClass('disabled');
                } else {
                    $select.removeClass('disabled');
                }
            }
        }
    }, {
        key: 'bindAreaTypeSelectHandlers',
        value: function bindAreaTypeSelectHandlers() {
            var _this = this;

            $(_ConfigurationFormConfig2.default.selectors.areaTypeSelect).off('change');
            $(_ConfigurationFormConfig2.default.selectors.areaTypeSelect).on('change', function (e) {
                _this.fillAreaTypeData($(e.target), parseInt(e.target.value));
                _this.resetArea($(e.target));
                _this.host.updateFormData(e.target); // CHANGE
            });

            $(_ConfigurationFormConfig2.default.selectors.runofftypeSelect).off('change');
            $(_ConfigurationFormConfig2.default.selectors.runofftypeSelect).on('change', function (e) {
                var $areaTypeBlock = $(e.target).parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock);
                var optionData = $(e.target.options[e.target.selectedIndex]).data();
                _this.resetArea($(e.target));

                _this.fillCoefficientSelect($areaTypeBlock, optionData);
                _this.host.updateFormData(e.target); // CHANGE
            });

            $(_ConfigurationFormConfig2.default.selectors.coefficientSelect).add(_ConfigurationFormConfig2.default.selectors.areaInput).off('change');
            $(_ConfigurationFormConfig2.default.selectors.coefficientSelect).add(_ConfigurationFormConfig2.default.selectors.areaInput).on('change', function (e) {
                _this.host.updateFormData(e.target); // CHANGE
            });

            $(_ConfigurationFormConfig2.default.selectors.removeAreaTypeButton).off('click');
            $(_ConfigurationFormConfig2.default.selectors.removeAreaTypeButton).on('click', function (e) {
                e.preventDefault();
                var $areaTypeBlock = $(e.target).parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock);
                _this.removeAreaType($areaTypeBlock);
                return false;
            });
        }
    }, {
        key: 'addAreaType',
        value: function addAreaType() {
            if (this.areaTypeCount >= this.areaTypeMax) {
                console.log('[AreaManagerLegacy] addAreaType: limit reached', this.areaTypeCount);
                return;
            }

            var $template = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock).last();
            var clone = $template.clone();

            clone.find(_ConfigurationFormConfig2.default.selectors.runofftypeSelect)[0].options.length = 0;
            clone.find(_ConfigurationFormConfig2.default.selectors.areaInput)[0].value = '';

            $template.after(clone);
            this.areaTypeCount++;
            console.log('[AreaManagerLegacy] addAreaType: new count', this.areaTypeCount);

            this.updateIndexes();

            this.fillAreaTypeData(clone.find(_ConfigurationFormConfig2.default.selectors.areaTypeSelect), parseInt(clone.find(_ConfigurationFormConfig2.default.selectors.areaTypeSelect)[0].value));

            this.bindAreaTypeSelectHandlers();

            this.toggleRemoveButtons();
        }
    }, {
        key: 'removeAreaType',
        value: function removeAreaType($areaTypeBlock) {
            if ($(_ConfigurationFormConfig2.default.selectors.areaTypeBlock).length > 1) {
                $areaTypeBlock.remove();
                this.updateIndexes();
                this.areaTypeCount--;
                console.log('[AreaManagerLegacy] removeAreaType: new count', this.areaTypeCount);
            }
            this.toggleRemoveButtons();
        }
    }, {
        key: 'updateIndexes',
        value: function updateIndexes() {
            var _this2 = this;

            var $blocks = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock);
            $blocks.each(function (index, block) {
                _this2.setIndexes($(block).find('select, input'), index);
            });
        }
    }, {
        key: 'setIndexes',
        value: function setIndexes($elements, index) {
            $elements.each(function (i, element) {
                if (element.name) {
                    element.name = element.name.replace(/\d/, index);
                }
            });
        }
    }, {
        key: 'toggleRemoveButtons',
        value: function toggleRemoveButtons() {
            var removeButtons = $(_ConfigurationFormConfig2.default.selectors.removeAreaTypeButton);
            removeButtons.toggle(removeButtons.length !== 1);

            if (this.areaTypeCount >= this.areaTypeMax) {
                $(_ConfigurationFormConfig2.default.selectors.addAreaTypeButton).hide();
                $(_ConfigurationFormConfig2.default.selectors.addAreaTypeLimitReached).show();
            } else {
                $(_ConfigurationFormConfig2.default.selectors.addAreaTypeButton).show();
                $(_ConfigurationFormConfig2.default.selectors.addAreaTypeLimitReached).hide();
            }
        }
    }, {
        key: 'fillAreaTypeData',
        value: function fillAreaTypeData($areaTypeSelect, areaType, initialFill) {
            var _this3 = this;

            var $areaTypeBlock = $areaTypeSelect.parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock);

            if (this.runoffTypes[areaType] === undefined) {
                console.log('[AreaManagerLegacy] fetch runoffTypes for areaType', areaType);
                _AjaxUtility2.default.request('Configurator', {
                    controller: 'Configuration',
                    action: 'getAreaTypeData',
                    areaType: areaType
                }).done(function (response) {
                    var runoffTypes = [];
                    try {
                        runoffTypes = JSON.parse(response);
                    } catch (e) {
                        console.error('[AreaManagerLegacy] Invalid JSON for runoffTypes', e);
                    }
                    // cache results
                    _this3.runoffTypes[areaType] = runoffTypes;
                    console.log('[AreaManagerLegacy] cached runoffTypes for', areaType, runoffTypes);
                    _this3.fillRunoffTypeSelect($areaTypeBlock, runoffTypes, initialFill);
                });
            } else {
                console.log('[AreaManagerLegacy] use cached runoffTypes for areaType', areaType);
                this.fillRunoffTypeSelect($areaTypeBlock, this.runoffTypes[areaType], initialFill);
            }
        }
    }, {
        key: 'resetArea',
        value: function resetArea($select) {
            var $areaTypeBlock = $select.parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock),
                $areaInput = $areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.areaInput);

            $areaInput.val('');
        }
    }, {
        key: 'fillRunoffTypeSelect',
        value: function fillRunoffTypeSelect($areaTypeBlock, runoffTypes, initialFill) {
            var _this4 = this;

            var $runoffTypeSelect = $areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.runofftypeSelect);
            if ($runoffTypeSelect[0] !== undefined) {
                var runoffTypeSelect = $runoffTypeSelect[0];
                runoffTypeSelect.options.length = 0; // clear options

                runoffTypes.forEach(function (element) {
                    $runoffTypeSelect[0].add(
                    // Reuse host helper for consistency
                    _this4.host.createOptionElement(element.uid, element.name, [{ key: 'data-coefficientfrom', value: element.coefficientFrom }, { key: 'data-coefficientto', value: element.coefficientTo }]));
                });

                var initialValue = $areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.runofftypeValue).data('value');
                if (initialFill && initialValue) {
                    $runoffTypeSelect.val($areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.runofftypeValue).data('value'));
                }

                this.fillCoefficientSelect($areaTypeBlock, $(runoffTypeSelect.options[runoffTypeSelect.selectedIndex]).data(), initialFill);
            }
        }
    }, {
        key: 'fillCoefficientSelect',
        value: function fillCoefficientSelect($areaTypeBlock, optionData, initialFill) {
            var $coefficientSelect = $areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.coefficientSelect);
            var coefficientSelect = $coefficientSelect[0];
            var coefficient = optionData.coefficientto;

            // clear options
            coefficientSelect.options.length = 0;

            while (coefficient >= optionData.coefficientfrom) {
                coefficientSelect.options.add(this.host.createOptionElement(coefficient, coefficient));
                // floating point shenanigans
                coefficient = Math.round((coefficient + this.coefficientSteps) * 100) / 100;
            }

            var initialValue = $areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.coefficientValue).data('value');
            if (initialFill && initialValue) {
                $coefficientSelect.val($areaTypeBlock.find(_ConfigurationFormConfig2.default.selectors.coefficientValue).data('value'));
            }

            this.disableIfSingleOption($coefficientSelect);
        }
    }]);

    return AreaManagerLegacy;
}();

exports.default = AreaManagerLegacy;

},{"../../Utility/AjaxUtility":15,"../ConfigurationFormConfig":4}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('../ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * AreaManagerNew (DWA-A 138-1)
 *
 * Responsibility:
 * - initAreaType1381Handlers, addAreaType1381, removeAreaType1381
 * - onCategoryChange1381, onTypeChange1381, fillTypeOptions1381
 * - updateIndexes1381, toggleRemoveButtons1381, decodeHtmlEntities
 *
 * Notes:
 * - Behaviour is kept 1:1 from ConfigurationForm.js, only extracted into this class.
 * - Calls to updateFormData/updateSummary now go through the provided host (ConfigurationForm) instance.
 *   // CHANGE: Use host.updateFormData()/host.updateSummary() because logic moved to manager.
 * - Added console.log at critical actions (init/add/remove/category/type parsing).
 */
var AreaManagerNew = function () {
    /**
     * @param {jQuery} form
     * @param {Object} state
     * @param {Object} host instance of ConfigurationForm (for callbacks and helpers)
     */
    function AreaManagerNew(form, state, host) {
        _classCallCheck(this, AreaManagerNew);

        this.form = form;
        this.state = state;
        this.host = host;

        // CHANGE: Read centralized areaTypeMax from FormConfig.settings; keep safe fallback
        this.areaTypeMax = _ConfigurationFormConfig2.default.settings && typeof _ConfigurationFormConfig2.default.settings.areaTypeMax !== 'undefined' ? _ConfigurationFormConfig2.default.settings.areaTypeMax : 14;
        this.areaTypeCount1381 = 0;
        this.surfaceTypesMap = {};
    }

    /**
     * CHANGE: Moved from ConfigurationForm to AreaManagerNew
     * Fill Cm or Cs select with range 0–1 (steps 0.05) for manual surface type input (DWA-A 138-1)
     * Uses centralized step from FormConfig.settings and host.createOptionElement() helper.
     *
     * @param $select jQuery select element (Cm or Cs dropdown)
     * @param initialValue optional initial value to preselect
     */


    _createClass(AreaManagerNew, [{
        key: 'fillCmCsSelect',
        value: function fillCmCsSelect($select) {
            var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (!$select.length || !$select[0]) {
                return;
            }

            var select = $select[0];
            // clear options
            select.options.length = 0;

            // Range from 1 down to 0 (same direction as legacy fillCoefficientSelect)
            var value = 1.0;
            // Use centralized step, keep safe fallback for BC
            var step = _ConfigurationFormConfig2.default.settings && typeof _ConfigurationFormConfig2.default.settings.coefficientStep !== 'undefined' ? _ConfigurationFormConfig2.default.settings.coefficientStep : -0.05;
            var minValue = 0.0;

            while (value >= minValue) {
                select.options.add(
                // reuse host helper to keep option creation consistent
                this.host.createOptionElement(value, value));
                // floating point shenanigans
                value = Math.round((value + step) * 100) / 100;
            }

            // Preselect initial value if provided
            if (initialValue !== null && initialValue !== '') {
                $select.val(String(initialValue));
            }
        }
    }, {
        key: 'disableIfSingleOption',
        value: function disableIfSingleOption($select) {
            if ($select.length && $select[0]) {
                if ($select[0].options.length === 1) {
                    $select.addClass('disabled');
                } else {
                    $select.removeClass('disabled');
                }
            }
        }

        // Decode a JSON string embedded in a HTML data-* attribute (handles &quot; &amp; &lt; &gt;)

    }, {
        key: 'decodeHtmlEntities',
        value: function decodeHtmlEntities(str) {
            return str.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        }
    }, {
        key: 'initAreaType1381Handlers',
        value: function initAreaType1381Handlers() {
            var _this = this;

            var $container = $('#areaGuideline1381');
            if (!$container.length) {
                return; // 138-1 UI not present
            }

            // Parse JSON mapping from data attribute (provided by server)
            var mapJson = $container.attr('data-surface-types-map');
            try {
                if (mapJson && typeof mapJson === 'string') {
                    mapJson = this.decodeHtmlEntities(mapJson);
                    this.surfaceTypesMap = JSON.parse(mapJson);
                } else {
                    this.surfaceTypesMap = {};
                }
            } catch (e) {
                console.error('[AreaManagerNew] Failed to parse surfaceTypesMap', e); // CHANGE: log error
                this.surfaceTypesMap = {};
            }
            console.log('[AreaManagerNew] surfaceTypesMap initialized', this.surfaceTypesMap);

            // Bind events for add/remove and selects (delegated for dynamic rows)
            this.form.on('click', _ConfigurationFormConfig2.default.selectors.addAreaType1381Button, function (e) {
                e.preventDefault();
                _this.addAreaType1381();
                return false;
            });

            this.form.on('click', _ConfigurationFormConfig2.default.selectors.removeAreaType1381Button, function (e) {
                e.preventDefault();
                var $block = $(e.currentTarget).closest(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381);
                _this.removeAreaType1381($block);
                return false;
            });

            this.form.on('change', _ConfigurationFormConfig2.default.selectors.surfaceCategory1381, function (e) {
                _this.onCategoryChange1381($(e.currentTarget));
                _this.clearAreaCategorization($(e.currentTarget));
                _this.toggleAreaCategorizationRows();
            });

            this.form.on('change', _ConfigurationFormConfig2.default.selectors.surfaceType1381Select, function (e) {
                _this.onTypeChange1381($(e.currentTarget));
                _this.clearAreaCategorization($(e.currentTarget));
            });

            // Bind change handlers for all 138-1 inputs to trigger updateFormData (like old path)
            this.form.on('change', _ConfigurationFormConfig2.default.selectors.surfaceType1381Input, function (e) {
                _this.host.updateFormData(e.target); // CHANGE
            });
            this.form.on('change', _ConfigurationFormConfig2.default.selectors.cm1381, function (e) {
                _this.host.updateFormData(e.target); // CHANGE
            });
            /*this.form.on('change', FormConfig.selectors.cs1381, e => {
                this.host.updateFormData(e.target); // CHANGE
            });*/
            // Area inputs within 138-1 blocks
            this.form.on('change', _ConfigurationFormConfig2.default.selectors.areaTypeBlock1381 + ' ' + _ConfigurationFormConfig2.default.selectors.areaInput, function (e) {
                _this.host.updateFormData(e.target); // CHANGE
            });

            this.form.on('click', _ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle, function (e) {
                var $target = $(e.currentTarget);
                _this.toggleAreaCategorizationRows();
                $target.parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).find(_ConfigurationFormConfig2.default.selectors.areacategorizationSelection).toggle();
            });
            this.form.on('click', _ConfigurationFormConfig2.default.selectors.areacategorizationRow, function (e) {
                var $target = $(e.currentTarget),
                    $selection = $target.parents(_ConfigurationFormConfig2.default.selectors.areacategorizationSelection),
                    index = $selection.data('index'),
                    $display = $(_ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle + '[data-index="' + index + '"]'),
                    $input = $(_ConfigurationFormConfig2.default.selectors.areacategorizationInput + '[data-index="' + index + '"]'),
                    category = $target.find(_ConfigurationFormConfig2.default.selectors.loadCategory).html(),
                    id = $target.data('id');

                $selection.find(_ConfigurationFormConfig2.default.selectors.areacategorizationRow).removeClass('act');
                $target.addClass('act');
                $input.val(id);
                $display.val(category);
                _this.host.updateFormData($input[0]);
                $selection.hide();
            });

            // Initialize existing rows
            this.areaTypeCount1381 = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).length || 1;
            this.toggleRemoveButtons1381();

            $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).each(function (i, el) {
                var $row = $(el);
                var $cat = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381);
                var $typeSelect = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select);
                var $typeInput = $row.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Input);
                var $cm = $row.find(_ConfigurationFormConfig2.default.selectors.cm1381);
                var $area = $row.find(_ConfigurationFormConfig2.default.selectors.areaInput);

                var storedCategory = $cat.data('initial-value') || $cat.val();
                var storedTypeUid = $typeSelect.data('initial-value') || $typeSelect.val();
                var storedManualType = $typeInput.data('initial-value') || $typeInput.val();
                var storedCm = $cm.data('initial-value') || $cm.val();
                var storedArea = $area.data('initial-value') || $area.val();

                if ($cat.length && storedCategory) {
                    console.log('[AreaManagerNew] Initializing row', i, {
                        category: storedCategory,
                        storedTypeUid: storedTypeUid,
                        storedCm: storedCm,
                        storedArea: storedArea
                    });

                    // Initialize categories but pass the stored type UID to prevent overwriting
                    _this.onCategoryChange1381($cat, true, storedTypeUid);

                    // Ensure area is set (re-check after triggers)
                    if (storedArea) {
                        $area.val(storedArea);
                    }

                    // For manual category, we need to ensure cm selection is restored
                    if (storedCategory === 'manual' && storedCm) {
                        $cm.val(storedCm);
                        // Also ensure the manual input field is shown and populated
                        $typeInput.val(storedManualType).show();
                        $typeSelect.hide();
                    }
                }

                if (storedArea && !$area.val()) {
                    $area.val(storedArea);
                }

                _this.disableIfSingleOption($cm);
            });
            console.log('[AreaManagerNew] init handlers complete, row count', this.areaTypeCount1381);
        }
    }, {
        key: 'addAreaType1381',
        value: function addAreaType1381() {
            if (this.areaTypeCount1381 >= this.areaTypeMax) {
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381Button).hide();
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381LimitReached).show();
                console.log('[AreaManagerNew] addAreaType1381: limit reached', this.areaTypeCount1381);
                return;
            }

            var $template = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).last();
            var $clone = $template.clone();

            // Reset values in clone
            $clone.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381).prop('selectedIndex', 0);
            var $typeSelect = $clone.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select);
            if ($typeSelect.length && $typeSelect[0]) {
                $typeSelect[0].options.length = 0;
            }
            $clone.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Input).val('').hide();
            $clone.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select).show();
            $clone.find(_ConfigurationFormConfig2.default.selectors.cm1381).val('');
            //$clone.find(FormConfig.selectors.cs1381).val('');
            $clone.find(_ConfigurationFormConfig2.default.selectors.areaInput).val('');
            $clone.find(_ConfigurationFormConfig2.default.selectors.areacategorizationInput).val('');
            $clone.find(_ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle).val('');
            $clone.find(_ConfigurationFormConfig2.default.selectors.areacategorizationSelection).hide();

            $template.after($clone);
            this.areaTypeCount1381++;
            this.updateIndexes1381();
            this.onCategoryChange1381($clone.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381));
            this.toggleRemoveButtons1381();
            console.log('[AreaManagerNew] addAreaType1381: new count', this.areaTypeCount1381);

            // Initialize the new row: trigger category change to fill type dropdown
            var $newCat = $clone.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381);
            if ($newCat.length && $newCat.val()) {
                this.onCategoryChange1381($newCat, false);
            }

            this.host.updateSummary(); // CHANGE
        }
    }, {
        key: 'removeAreaType1381',
        value: function removeAreaType1381($block) {
            if ($(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381).length > 1) {
                $block.remove();
                this.areaTypeCount1381--;
                this.updateIndexes1381();
                console.log('[AreaManagerNew] removeAreaType1381: new count', this.areaTypeCount1381);
            }
            this.toggleRemoveButtons1381();
            this.host.updateSummary(); // CHANGE
        }
    }, {
        key: 'toggleRemoveButtons1381',
        value: function toggleRemoveButtons1381() {
            var $removeButtons = $(_ConfigurationFormConfig2.default.selectors.removeAreaType1381Button);
            $removeButtons.toggle($removeButtons.length !== 1);

            if (this.areaTypeCount1381 >= this.areaTypeMax) {
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381Button).hide();
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381LimitReached).show();
            } else {
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381Button).show();
                $(_ConfigurationFormConfig2.default.selectors.addAreaType1381LimitReached).hide();
            }
        }
    }, {
        key: 'updateIndexes1381',
        value: function updateIndexes1381() {
            var $blocks = $(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381);
            $blocks.each(function (idx, block) {
                var $el = $(block);
                // Reindex all inputs/selects inside the block
                $el.find('input[name], select[name], textarea[name]').each(function (i, input) {
                    if (!input.name) {
                        return;
                    }
                    // Extbase-style names: ...[surfaceValue][<n>][...]
                    if (/(\[surfaceValue\]\[)\w+(\]\[)/.test(input.name)) {
                        input.name = input.name.replace(/(\[surfaceValue\]\[)\w+(\]\[)/, '$1' + idx + '$2');
                        return;
                    }
                    // Legacy local names used only for UI (category/manual helpers)
                    if (/(surfaceCategory|surfaceType|surfaceTypeManual|cm|cs)\[(\w+)\]/.test(input.name)) {
                        input.name = input.name.replace(/(surfaceCategory|surfaceType|surfaceTypeManual|cm|cs)\[(\w+)\]/, '$1[' + idx + ']');
                    }
                });
                $el.find('[data-index]').each(function (i, element) {
                    element.dataset.index = idx;
                });
            });
        }
    }, {
        key: 'onCategoryChange1381',
        value: function onCategoryChange1381($categorySelect) {
            var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var storedTypeUid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var $block = $categorySelect.closest(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381);
            var val = $categorySelect.data('initial-value') || $categorySelect.val();
            $categorySelect.data('initial-value', '');
            var $typeSelect = $block.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select);
            var $typeInput = $block.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Input);
            var $cm = $block.find(_ConfigurationFormConfig2.default.selectors.cm1381);
            //const $cs = $block.find(FormConfig.selectors.cs1381);

            if (val === 'manual') {
                // Manual case: show freitext for type, fill Cm/Cs dropdowns with range 0–1
                $typeInput.val('').show();
                if (initial) {
                    // In edit mode, we might have a manual text stored already
                    var storedManualType = $typeInput.data('initial-value') || $typeInput.val();
                    $typeInput.val(storedManualType);
                }
                $typeSelect.hide();
                // Do not submit a stale surfacetype when manual is active
                $typeSelect.val('');
                $typeSelect.prop('disabled', true);
                // Ensure manual type is submitted
                $typeInput.prop('disabled', false);
                // CHANGE: fillCmCsSelect moved into AreaManagerNew (was host)
                var storedCm = $cm.data('initial-value') || $cm.val();
                this.fillCmCsSelect($cm, initial ? storedCm : null);
                //const storedCs = $cs.data('initial-value') || $cs.val();
                //this.fillCmCsSelect($cs, initial ? storedCs : null);
                $cm.prop('disabled', false);
                this.disableIfSingleOption($cm);
                // Validation: require manual type text and Cm selection
                if ($typeInput.length) {
                    $typeInput.prop('required', true);
                }
                if ($typeSelect.length) {
                    $typeSelect.prop('required', false);
                }
                if ($cm.length) {
                    $cm.prop('required', true);
                }
                //if ($cs.length) { $cs.prop('required', true); }
                console.log('[AreaManagerNew] category change: manual');
                return;
            }

            // Regular case: show type dropdown, prepare Cm/Cs for auto-fill
            $typeInput.hide();
            // Do not submit manual text when regular mode is active
            $typeInput.prop('disabled', true);
            $typeSelect.show();
            $typeSelect.prop('disabled', false);
            // Validation: require type selection, not manual inputs
            if ($typeInput.length) {
                $typeInput.prop('required', false);
            }
            if ($typeSelect.length) {
                $typeSelect.prop('required', true);
            }
            if ($cm.length) {
                $cm.prop('required', false);
            }
            //if ($cs.length) { $cs.prop('required', false); }
            var categoryUid = parseInt(val || '0', 10);
            this.fillTypeOptions1381($block, categoryUid);

            if (initial && storedTypeUid) {
                $categorySelect.val(String(val));
                $typeSelect.val(String(storedTypeUid));
                // Trigger manual update of cm based on the stored type
                this.onTypeChange1381($typeSelect, true);
            } else {
                // Auto-select first type and fill Cm/Cs
                $typeSelect.trigger('change');
            }
            console.log('[AreaManagerNew] category change: uid', categoryUid);
        }
    }, {
        key: 'fillTypeOptions1381',
        value: function fillTypeOptions1381($block, categoryUid) {
            var $typeSelect = $block.find(_ConfigurationFormConfig2.default.selectors.surfaceType1381Select);
            if (!$typeSelect.length || !$typeSelect[0]) {
                return;
            }
            $typeSelect[0].options.length = 0;
            if (this.surfaceTypesMap && this.surfaceTypesMap[categoryUid]) {
                this.surfaceTypesMap[categoryUid].forEach(function (t) {
                    $typeSelect[0].add(new Option(t.name, String(t.uid)));
                });
            }
            // Auto-select first option if available
            if ($typeSelect[0].options.length > 0) {
                $typeSelect[0].selectedIndex = 0;
            }
        }
    }, {
        key: 'onTypeChange1381',
        value: function onTypeChange1381($typeSelect) {
            var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var $block = $typeSelect.closest(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381);
            var categoryUid = parseInt($block.find(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381).val() || '0', 10);
            var val = $typeSelect.val();
            var $cm = $block.find(_ConfigurationFormConfig2.default.selectors.cm1381);
            //const $cs = $block.find(FormConfig.selectors.cs1381);

            if (!val) {
                // No type selected: clear Cm/Cs and disable
                $cm[0].options.length = 0;
                //$cs[0].options.length = 0;
                $cm.prop('disabled', true);
                this.disableIfSingleOption($cm);
                // Validation: keep type required; Cm not required in regular mode
                $cm.prop('required', false);
                //$cs.prop('required', false);
                this.host.updateSummary(); // CHANGE
                console.log('[AreaManagerNew] type change: no value');
                return;
            }

            // Regular type selected: auto-fill Cm/Cs from map
            var match = null;
            if (this.surfaceTypesMap && this.surfaceTypesMap[categoryUid]) {
                match = this.surfaceTypesMap[categoryUid].find(function (t) {
                    return String(t.uid) === String(val);
                });
            }
            if (match) {
                // Create single-option selects with auto-value (disabled to prevent editing)
                var toComma = function toComma(n) {
                    return String(n).indexOf('.') >= 0 ? String(n).replace('.', ',') : String(n);
                };

                // If we are in initial mode, we might want to preserve a custom cm from the DB (e.g. if the norm changed)
                // but usually the norm value should win for regular types.
                var cmVal = toComma(match.cm);
                //const csVal = toComma(match.cs);

                $cm[0].options.length = 0;
                $cm[0].add(new Option(cmVal, cmVal));

                if (initial) {
                    var storedCm = $cm.data('initial-value') || $cm.val();
                    if (storedCm) {
                        // If storedCm is different from norm, we still show the option, but norm is usually the anchor.
                        // For now, let's ensure cmVal is correctly selected.
                        $cm.val(cmVal);
                    } else {
                        $cm.val(cmVal);
                    }
                } else {
                    $cm.val(cmVal);
                }

                $cm.val(cmVal); // Ensure the value is set
                $cm.prop('disabled', true);

                /*$cs[0].options.length = 0;
                $cs[0].add(new Option(csVal, csVal));
                $cs.prop('disabled', true);*/
                console.log('[AreaManagerNew] type change: match', match);
            } else {
                // No match found: clear and disable
                $cm[0].options.length = 0;
                //$cs[0].options.length = 0;
                $cm.prop('disabled', true);
                //$cs.prop('disabled', true);
                $cm.prop('required', false);
                //$cs.prop('required', false);
                console.log('[AreaManagerNew] type change: no match');
            }
            this.host.updateSummary(); // CHANGE
        }
    }, {
        key: 'toggleAreaCategorizationRows',
        value: function toggleAreaCategorizationRows() {
            var _this2 = this;

            var rows = $(_ConfigurationFormConfig2.default.selectors.areacategorizationRow);
            rows.each(function (i, row) {
                var $row = $(row),
                    index = $row.parents(_ConfigurationFormConfig2.default.selectors.areacategorizationSelection).data('index'),
                    surfaceCategory = parseInt($(_ConfigurationFormConfig2.default.selectors.surfaceCategory1381 + ('[data-index="' + index + '"]')).val());

                if ((_this2.state.propertyType === null || $row.data('propertytypes').includes(_this2.state.propertyType)) && (isNaN(surfaceCategory) || $row.data('surfacecategories').includes(surfaceCategory))) {
                    $row.show();
                } else {
                    $row.hide();
                }
            });
        }
    }, {
        key: 'clearAreaCategorization',
        value: function clearAreaCategorization($target) {
            var $areaBlock = $target.parents(_ConfigurationFormConfig2.default.selectors.areaTypeBlock1381),
                $selection = $areaBlock.find(_ConfigurationFormConfig2.default.selectors.areacategorizationSelection),
                index = $selection.data('index'),
                $display = $(_ConfigurationFormConfig2.default.selectors.areaCategorizationDisplayToggle + '[data-index="' + index + '"]'),
                $input = $(_ConfigurationFormConfig2.default.selectors.areacategorizationInput + '[data-index="' + index + '"]'),
                $areaInput = $areaBlock.find(_ConfigurationFormConfig2.default.selectors.areaInput);

            $selection.find(_ConfigurationFormConfig2.default.selectors.areacategorizationRow).removeClass('act');
            $input.val('');
            $display.val('');
            $areaInput.val('');
            this.host.updateFormData($input[0]);
        }
    }]);

    return AreaManagerNew;
}();

exports.default = AreaManagerNew;

},{"../ConfigurationFormConfig":4}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('../ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FKWizardManager (DWA-A 138-1)
 *
 * Responsibility:
 * - Step 3: decision if fK is available
 * - If yes: persist `fK` + `fKIsManual` and skip Step 4/5
 */
var FKWizardManager = function () {
	/**
  * @param {jQuery} form
  * @param {Object} state
  * @param {Object} host instance of ConfigurationForm
  */
	function FKWizardManager(form, state, host) {
		_classCallCheck(this, FKWizardManager);

		this.form = form;
		this.state = state;
		this.host = host;

		this.$step = $('#fKStep3');
		this.$wrapper = this.$step.closest('.fKWizardStep3');

		this.$fOrtStep4 = $('.fortWizardStep4');
		this.$fOrtStep5 = $('.fortWizardStep5');

		this.wasActive = false;
	}

	_createClass(FKWizardManager, [{
		key: 'init',
		value: function init() {
			if (!this.$step.length) {
				return;
			}
			this.bindHandlers();
			this.updateVisibility();
			this.syncFromPersisted();
		}
	}, {
		key: 'bindHandlers',
		value: function bindHandlers() {
			var _this = this;

			this.form.on('change', '#fKStep3 .fKDecision', function (e) {
				_this.form.find('#fKStep3 .fKDecision').not(e.target).prop('checked', false);

				var decision = _this.getDecision();
				if (decision === 1) {
					_this.setFKIsManual(true);
					_this.$step.find('.fKValueRow').show();
					_this.$step.find('.fKInput').prop('required', true);
					_this.recomputeFK();
				} else if (decision === 0) {
					_this.setFKIsManual(false);
					// Clear manual fK; it will be derived later
					_this.setFK(0);
					_this.clearFKValidity();
					_this.$step.find('.fKValueRow').hide();
					_this.$step.find('.fKInput').prop('required', false).val('');
				}

				_this.updateVisibility();
				_this.triggerDownstreamUpdate();
			});

			this.form.on('input', '#fKStep3 .fKInput', function () {
				if (_this.getDecision() === 1) {
					_this.recomputeFK();
				}
			});

			var slide = $(_ConfigurationFormConfig2.default.selectors.fkSlide);
			slide.find('input').on('change', function (e) {
				// check if this event was triggered manually via user action
				// do not clear slides if this was triggered programmatically i.e. via FMethodeManager
				if (e.hasOwnProperty('originalEvent')) {
					_this.host.clearSlides(slide.nextAll(_ConfigurationFormConfig2.default.selectors.slides));
				}
			});
		}
	}, {
		key: 'triggerDownstreamUpdate',
		value: function triggerDownstreamUpdate() {
			// Downstream depends on fK decision
			if (this.host && this.host.fOrtQuestionManager && typeof this.host.fOrtQuestionManager.updateVisibility === 'function') {
				this.host.fOrtQuestionManager.updateVisibility();
			}
			if (this.host && this.host.fMethodeManager && typeof this.host.fMethodeManager.updateVisibility === 'function') {
				this.host.fMethodeManager.updateVisibility();
			}
		}
	}, {
		key: 'updateVisibility',
		value: function updateVisibility() {
			var isActiveBase = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() : false;

			var kiIsManual = this.getPersistedBool('.kiIsManual');
			var isActive = isActiveBase && !kiIsManual;
			console.log('[FKWizardManager] updateVisibility', { isActive: isActive, kiIsManual: kiIsManual });

			if (!isActive) {
				if (this.wasActive) {
					this.reset();
				}
				if (typeof this.host.setInputsDisabled === 'function') {
					this.host.setInputsDisabled(this.$wrapper, true);
				}
				this.$step.hide();
				this.$wrapper.hide();
				this.wasActive = isActive;
				return;
			}

			this.$wrapper.show();
			this.$step.show();
			if (typeof this.host.setInputsDisabled === 'function') {
				this.host.setInputsDisabled(this.$wrapper, false);
			}

			// Skip Step 4/5 if fK is manual; otherwise re-enable them and let Step4/5 manager decide.
			var fKIsManual = this.getPersistedBool('.fKIsManual');
			console.log('[FKWizardManager] fKIsManual check', { fKIsManual: fKIsManual, kiIsManual: kiIsManual });

			if (fKIsManual || kiIsManual) {
				this.$fOrtStep4.hide();
				this.host.setInputsDisabled(this.$fOrtStep4, true);
				this.$fOrtStep5.hide();
				this.host.setInputsDisabled(this.$fOrtStep5, true);
			} else {
				this.$fOrtStep4.show();
				this.host.setInputsDisabled(this.$fOrtStep4, false);
				this.$fOrtStep5.show();
				this.host.setInputsDisabled(this.$fOrtStep5, false);
				if (this.host && this.host.fOrtQuestionManager && typeof this.host.fOrtQuestionManager.updateVisibility === 'function') {
					this.host.fOrtQuestionManager.updateVisibility();
				}
			}

			this.wasActive = isActive;
		}
	}, {
		key: 'syncFromPersisted',
		value: function syncFromPersisted() {
			var fKIsManual = this.getPersistedBool('.fKIsManual');
			console.log('[FKWizardManager] syncFromPersisted', { fKIsManual: fKIsManual });
			if (fKIsManual === true) {
				this.form.find('#fKStep3 .fKDecision[value="1"]').prop('checked', true);
				this.$step.find('.fKValueRow').show();
				this.$step.find('.fKInput').prop('required', true);

				// Recover value from hidden field
				var $field = this.form.find('input.fKValue').first();
				var val = parseFloat($field.val() || '0');
				if (val > 0) {
					this.$step.find('.fKInput').val(val.toFixed(2).replace('.', ','));
					// Set sidebar result display if needed (no explicit result span in FK step usually)
				}
			} else if (fKIsManual === false) {
				this.form.find('#fKStep3 .fKDecision[value="0"]').prop('checked', true);
				this.$step.find('.fKValueRow').hide();
				this.$step.find('.fKInput').prop('required', false);
			} else {
				// Default: if it's explicitly guideline 138-1 and no value set, pre-select "No"
				var isActive = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() : false;
				console.log('[FKWizardManager] syncFromPersisted fallback', { isActive: isActive });
				if (isActive) {
					this.form.find('#fKStep3 .fKDecision[value="0"]').prop('checked', true);
					this.setFKIsManual(false);
				}
			}
		}
	}, {
		key: 'getDecision',
		value: function getDecision() {
			var $checked = this.form.find('#fKStep3 .fKDecision:checked');
			if ($checked.length) {
				return parseInt($checked.val(), 10);
			}
			return null;
		}
	}, {
		key: 'recomputeFK',
		value: function recomputeFK() {
			var $input = this.$step.find('.fKInput');
			var inputEl = $input.length ? $input[0] : null;
			var message = String($input.data('validationmessage') || '');
			var raw = String($input.val() || '').trim();

			// Enforce required + format + range (0.03–1.00, optional 1–2 decimals)
			if (raw === '') {
				if (inputEl && typeof inputEl.setCustomValidity === 'function') {
					inputEl.setCustomValidity(message || '');
				}
				this.setFK(0);
				return;
			}

			var normalized = raw.replace(',', '.');
			var formatOk = /^\d+(?:\.\d{1,2})?$/.test(normalized);
			var value = parseFloat(normalized);
			var rangeOk = !isNaN(value) && value >= 0.03 && value <= 1.0;
			if (!formatOk || !rangeOk) {
				if (inputEl && typeof inputEl.setCustomValidity === 'function') {
					inputEl.setCustomValidity(message || '');
				}
				this.setFK(0);
				return;
			}

			if (inputEl && typeof inputEl.setCustomValidity === 'function') {
				inputEl.setCustomValidity('');
			}
			this.setFK(value);
		}
	}, {
		key: 'clearFKValidity',
		value: function clearFKValidity() {
			var $input = this.$step.find('.fKInput');
			var inputEl = $input.length ? $input[0] : null;
			if (inputEl && typeof inputEl.setCustomValidity === 'function') {
				inputEl.setCustomValidity('');
			}
		}
	}, {
		key: 'setFK',
		value: function setFK(value) {
			var $field = this.form.find('input.fKValue').first();
			if (!$field.length) {
				return;
			}
			$field.val(String(value));
			$field.trigger('change');
		}
	}, {
		key: 'setFKIsManual',
		value: function setFKIsManual(enabled) {
			var $field = this.form.find('input.fKIsManual').first();
			if (!$field.length) {
				return;
			}
			$field.val(enabled ? '1' : '0');
		}
	}, {
		key: 'getPersistedBool',
		value: function getPersistedBool(selector) {
			var $field = this.form.find(selector).first();
			if (!$field.length) {
				return null;
			}
			var raw = String($field.val() || '').trim();
			if (raw === '') {
				return null;
			}
			return raw === '1' || raw === 'true';
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.form.find('#fKStep3 .fKDecision').prop('checked', false);
			this.$step.find('.fKInput').val('').prop('required', false);
			this.$step.find('.fKValueRow').hide();
			this.setFKIsManual(false);
			this.setFK(0);
		}
	}]);

	return FKWizardManager;
}();

exports.default = FKWizardManager;

},{"../ConfigurationFormConfig":4}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FMethodeManager (DWA-A 138-1)
 *
 * Responsibility:
 * - Step 6: select fMethode option from DB
 * - If option is "manual" (custom_factor=1): show manual factor input
 * - Persist fMethodeOption (via select) and fMethode (via hidden field)
 * - If not manual fK/ki: derive fK and ki where possible
 */
var FMethodeManager = function () {
    /**
     * @param {jQuery} form
     * @param {Object} state
     * @param {Object} host instance of ConfigurationForm
     */
    function FMethodeManager(form, state, host) {
        _classCallCheck(this, FMethodeManager);

        this.form = form;
        this.state = state;
        this.host = host;

        this.$step = $('#fMethodeStep6');
        this.$wrapper = this.$step.closest('.fMethodeWizardStep6');
        this.optionsMap = {};

        this.wasActive = false;
        this.wasManualBefore = false;
    }

    _createClass(FMethodeManager, [{
        key: 'decodeHtmlEntities',
        value: function decodeHtmlEntities(str) {
            return String(str).replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        }
    }, {
        key: 'init',
        value: function init() {
            if (!this.$step.length) {
                return;
            }

            this.parseOptionsMap();
            this.bindHandlers();
            this.updateVisibility();
            this.applyFromSelection(true);
        }
    }, {
        key: 'parseOptionsMap',
        value: function parseOptionsMap() {
            var raw = this.$step.attr('data-fmethode-map');
            if (!raw) {
                this.optionsMap = {};
                return;
            }
            try {
                var json = this.decodeHtmlEntities(raw);
                this.optionsMap = JSON.parse(json) || {};
            } catch (e) {
                console.error('[FMethodeManager] Failed to parse fMethode options map', e);
                this.optionsMap = {};
            }
        }
    }, {
        key: 'bindHandlers',
        value: function bindHandlers() {
            var _this = this;

            this.form.on('change', '#fMethodeStep6 select.fMethodeOption', function () {
                _this.applyFromSelection();
            });

            this.form.on('input', '#fMethodeStep6 .fMethodeManualInput', function () {
                _this.applyFromSelection();
            });
        }
    }, {
        key: 'updateVisibility',
        value: function updateVisibility() {
            var isActive = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() && this.host.kiWizardManager.getDecision() !== 1 && this.host.fkWizardManager.getDecision() !== 1 : false;

            if (!isActive && this.wasActive) {
                this.reset();
            }

            if (isActive) {
                this.$wrapper.show();
                this.$step.show();
                if (typeof this.host.setInputsDisabled === 'function') {
                    this.host.setInputsDisabled(this.$wrapper, false);
                }
            } else {
                if (typeof this.host.setInputsDisabled === 'function') {
                    this.host.setInputsDisabled(this.$wrapper, true);
                }
                this.$step.hide();
                this.$wrapper.hide();
            }

            this.wasActive = isActive;
        }
    }, {
        key: 'applyFromSelection',
        value: function applyFromSelection() {
            var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!this.$step.length) {
                return;
            }

            var $optionSelect = this.$step.find('select.fMethodeOption');
            var $factorSelect = this.$step.find('.fMethodeManualInput');
            var $nameRow = this.$step.find('.fMethodeManualNameRow');

            var optionUid = parseInt($optionSelect.val(), 10);
            if (!optionUid) {
                this.setFMethode(0);
                $factorSelect.val('').prop('disabled', true);
                $nameRow.hide();
                this.computeDerivedValues();
                return;
            }

            var meta = this.optionsMap[String(optionUid)] || this.optionsMap[optionUid];
            var isManual = meta && meta.customFactor === 1;

            if (isManual) {
                $nameRow.show();
                $factorSelect.prop('disabled', false);
                // Reset factor if it was pre-filled from a non-manual method before
                if (!this.wasManualBefore) {
                    $factorSelect.val('');
                }
                this.wasManualBefore = true;

                var manualFactor = this.getManualFactor(init);
                this.setFMethode(manualFactor !== null ? manualFactor : 0);
                // set manual input value from hidden field on initial load
                if (init) {
                    $factorSelect.val(manualFactor.toString());
                }
            } else {
                this.wasManualBefore = false;
                $nameRow.hide();
                $factorSelect.prop('disabled', true);
                var factor = meta ? parseFloat(meta.factor) : 0;
                // Pre-fill factor dropdown with value from selected method
                if (!isNaN(factor) && factor > 0) {
                    // Try both "1" and "1.0" for selection matching
                    $factorSelect.val(factor.toFixed(1));
                    if ($factorSelect.val() === null || $factorSelect.val() === '') {
                        $factorSelect.val(String(factor));
                    }
                } else {
                    $factorSelect.val('');
                }
                this.setFMethode(isNaN(factor) ? 0 : factor);
            }

            // Derive fK / ki when possible
            this.computeDerivedValues();
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (!this.$step.length || !this.$step.is(':visible')) {
                return true;
            }
            var $optionSelect = this.$step.find('select.fMethodeOption');
            if (!$optionSelect.val()) {
                return false;
            }
            var factor = this.getManualFactor();
            return factor !== null && factor > 0;
        }
    }, {
        key: 'getManualFactor',
        value: function getManualFactor() {
            var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (init) {
                return this.$step.find('.fMethodeManualInput').data('initial');
            }

            var raw = String(this.$step.find('.fMethodeManualInput').val() || '').trim();
            if (raw === '') {
                return null;
            }
            var normalized = raw.replace(',', '.');
            var value = parseFloat(normalized);
            if (isNaN(value)) {
                return null;
            }
            return value;
        }
    }, {
        key: 'setFMethode',
        value: function setFMethode(value) {
            var $field = this.form.find('input.fMethodeValue').first();
            if (!$field.length) {
                return;
            }
            $field.val(String(value));
            $field.trigger('change');
        }
    }, {
        key: 'computeDerivedValues',
        value: function computeDerivedValues() {
            // fK
            var fKIsManual = this.getPersistedBool('.fKIsManual');
            var fOrt = this.getPersistedNumber('input.fortValue');
            var fMethode = this.getPersistedNumber('input.fMethodeValue');

            if (!fKIsManual && fOrt !== null && fOrt > 0 && fMethode !== null && fMethode > 0) {
                var fK = Math.min(fOrt * fMethode, 1.0);
                // Round fK to 2 decimals as per Step 3 requirement
                this.setFK(Math.round(fK * 100) / 100);
            }

            // ki
            var kiIsManual = this.getPersistedBool('.kiIsManual');
            if (!kiIsManual) {
                var k = this.getPersistedNumber('input[name*="[configuration][customRunoffValue]"]');
                var _fK = this.getPersistedNumber('input.fKValue');
                if (k !== null && k > 0 && _fK !== null && _fK > 0) {
                    // Fixed rounding issue for ki derivation
                    var val = k * _fK;
                    this.setKi(Math.round(val * 10000000) / 10000000);
                }
            }
        }
    }, {
        key: 'setFK',
        value: function setFK(value) {
            var $field = this.form.find('input.fKValue').first();
            if (!$field.length) {
                return;
            }
            $field.val(String(value));
            $field.trigger('change');
        }
    }, {
        key: 'setKi',
        value: function setKi(value) {
            var $field = this.form.find('input.kiValue').first();
            if (!$field.length) {
                return;
            }
            $field.val(String(value));
            this.host.updateFormData($field[0]);
        }
    }, {
        key: 'getPersistedBool',
        value: function getPersistedBool(selector) {
            var $field = this.form.find(selector).first();
            if (!$field.length) {
                return null;
            }
            var raw = String($field.val() || '').trim();
            if (raw === '') {
                return null;
            }
            return raw === '1' || raw === 'true';
        }
    }, {
        key: 'getPersistedNumber',
        value: function getPersistedNumber(selector) {
            var $field = this.form.find(selector).first();
            if (!$field.length) {
                return null;
            }
            var raw = String($field.val() || '').trim().replace(',', '.');
            if (raw === '') {
                return null;
            }
            var value = parseFloat(raw);
            return isNaN(value) ? null : value;
        }
    }, {
        key: 'reset',
        value: function reset() {
            // Keep selection as-is? Reset is safer when switching away from guideline.
            var $select = this.$step.find('select.fMethodeOption');
            $select.val('');
            this.applyFromSelection();
        }
    }]);

    return FMethodeManager;
}();

exports.default = FMethodeManager;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FOrtQuestionManager (DWA-A 138-1)
 *
 * Responsibility:
 * - Toggle visibility of the fOrt question block
 * - Bind answer events (good/medium/bad)
 * - Live-calculate fOrt and write to hidden fields (fOrt + flags)
 * - Handle manual override (manual input disables questions)
 */
var FOrtQuestionManager = function () {
	/**
  * @param {jQuery} form
  * @param {Object} state
  * @param {Object} host instance of ConfigurationForm
  */
	function FOrtQuestionManager(form, state, host) {
		_classCallCheck(this, FOrtQuestionManager);

		this.form = form;
		this.state = state;
		this.host = host;

		// Step containers (Step 4 + Step 5)
		this.$step4 = $('#fOrtStep4');
		this.$step5 = $('#fOrtStep5');
		this.$step4Wrapper = this.$step4.closest('.fortWizardStep4');
		this.$step5Wrapper = this.$step5.closest('.fortWizardStep5');
		this.$container = $('#fOrtQuestionWizard');

		this.questions = [];
		this.wasActive = false;

		// answer level → numeric value
		this.answerValueMap = {
			1: 1.0, // good
			2: 0.65, // medium
			3: 0.3 // bad
		};
	}

	_createClass(FOrtQuestionManager, [{
		key: 'decodeHtmlEntities',
		value: function decodeHtmlEntities(str) {
			return String(str).replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
		}
	}, {
		key: 'parseQuestionsFromDom',
		value: function parseQuestionsFromDom() {
			// Find first element providing the JSON (user may move the attribute)
			var $provider = $('[data-fort-questions]').first();
			if (!$provider.length) {
				return [];
			}

			var json = $provider.attr('data-fort-questions');
			if (!json || typeof json !== 'string') {
				return [];
			}

			try {
				json = this.decodeHtmlEntities(json);
				var data = JSON.parse(json);
				return Array.isArray(data) ? data : [];
			} catch (e) {
				console.error('[FOrtQuestionManager] Failed to parse fOrt questions JSON', e);
				return [];
			}
		}
	}, {
		key: 'init',
		value: function init() {
			if (!this.$step4.length && !this.$step5.length && !this.$container.length) {
				return;
			}

			// Keep parsing JSON for debugging, but visibility uses rendered rows to avoid dependency on attribute placement.
			this.questions = this.parseQuestionsFromDom();
			this.bindHandlers();
			this.updateVisibility();
			this.syncFromPersisted();
			if (this.getPersistedFlag('.fortIsDerived')) {
				this.recompute(true);
			}
		}
	}, {
		key: 'syncFromPersisted',
		value: function syncFromPersisted() {
			var decision = this.getDecision();
			if (decision === 1) {
				var $select = this.$step4.find('.fortStep4ValueSelect');
				var current = this.getPersistedFOrt();
				if (current !== null && current !== 0) {
					$select.val(String(current));
				}
				this.form.find('#fOrtStep4 .fortDecision[value="1"]').prop('checked', true);
			} else if (decision === 0) {
				this.form.find('#fOrtStep4 .fortDecision[value="0"]').prop('checked', true);
				// Sync answers if derived
				var isDerived = this.getPersistedFlag('.fortIsDerived');
				if (isDerived) {
					// The derived value display is already handled by recompute() in init()
				}
			}

			var useRecommend = this.getPersistedFlag('.fortUseRecommendation');
			var $recommend = this.$container.find('.fortRecommendCheckbox');
			if (useRecommend === true) {
				$recommend.prop('checked', true);
				$recommend.closest('.checkbox-root').addClass('checked');
				this.setManualMode(true);
				// Also re-trigger recompute to update display
				this.recompute();
			}
		}
	}, {
		key: 'updateVisibility',
		value: function updateVisibility() {
			var isActiveBase = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() : false;

			var kiIsManual = this.getPersistedFlag('.kiIsManual');
			var fKIsManual = this.getPersistedFlag('.fKIsManual');
			var isSkipped = kiIsManual || fKIsManual;

			var isActive = isActiveBase && !isSkipped;

			// Reset values when component becomes inactive (deactivated or skipped)
			if (!isActive && this.wasActive) {
				this.reset();
			}

			var hasRenderedQuestions = this.$container.length ? this.$container.find('tr[data-question-uid]').length > 0 : false;

			var decision = this.getDecision();
			this.syncDecisionRadios(decision);

			// Step 4 visible only when effectively active
			if (this.$step4.length) {
				if (isActive) {
					if (this.$step4Wrapper.length) {
						this.$step4Wrapper.show();
					}
					this.$step4.show();
					if (typeof this.host.setInputsDisabled === 'function') {
						this.host.setInputsDisabled(this.$step4, false);
					}
				} else {
					if (typeof this.host.setInputsDisabled === 'function') {
						this.host.setInputsDisabled(this.$step4, true);
					}
					this.$step4.hide();
					if (this.$step4Wrapper.length) {
						this.$step4Wrapper.hide();
					}
				}
			}

			// Step 4 value row only if user says fOrt is available (decision = 1)
			if (this.$step4.length) {
				var $valueRow = this.$step4.find('.fortStep4ValueRow');
				var $select = this.$step4.find('.fortStep4ValueSelect');
				if (decision === 1 && isActive) {
					$valueRow.show();
					$select.prop('required', true);
					// prefill from persisted hidden value if present
					var current = this.getPersistedFOrt();
					if (current !== null && current !== 0) {
						$select.val(String(current));
					}
				} else {
					$valueRow.hide();
					$select.prop('required', false);
				}
			}

			// Step 5 visible only when effectively active AND user selected "No" in Step 4
			var shouldShowStep5 = isActive && decision === 0 && hasRenderedQuestions;
			if (this.$step5.length) {
				if (shouldShowStep5) {
					if (this.$step5Wrapper.length) {
						this.$step5Wrapper.show();
					}
					this.$step5.show();
					if (typeof this.host.setInputsDisabled === 'function') {
						this.host.setInputsDisabled(this.$step5, false);
					}
				} else {
					if (typeof this.host.setInputsDisabled === 'function') {
						this.host.setInputsDisabled(this.$step5, true);
					}
					this.$step5.hide();
					if (this.$step5Wrapper.length) {
						this.$step5Wrapper.hide();
					}
				}
			}

			this.wasActive = isActive;
		}
	}, {
		key: 'syncDecisionRadios',
		value: function syncDecisionRadios(decision) {
			// Do not override user input; only sync if nothing is selected yet.
			var $checked = this.form.find('input.fortDecision:checked');
			if ($checked.length) {
				return;
			}
			if (decision === 0 || decision === 1) {
				this.form.find('input.fortDecision[value="' + String(decision) + '"]').prop('checked', true);
			}

			// Also sync recommend checkbox from persisted state
			var useRecommend = this.getPersistedFlag('.fortUseRecommendation');
			var $recommend = this.$container.find('.fortRecommendCheckbox');
			if (useRecommend === true) {
				$recommend.prop('checked', true);
				$recommend.closest('.checkbox-root').addClass('checked');
			} else {
				$recommend.prop('checked', false);
				$recommend.closest('.checkbox-root').removeClass('checked');
			}
		}
	}, {
		key: 'reset',
		value: function reset() {
			// Clear decision
			this.form.find('input.fortDecision').prop('checked', false);
			// Clear Step 4 select
			if (this.$step4.length) {
				this.$step4.find('.fortStep4ValueSelect').val('');
				this.$step4.find('.fortStep4ValueRow').hide();
			}
			// Clear Step 5 answers + checkbox
			if (this.$container.length) {
				this.$container.find('.fortAnswerLevel').prop('checked', false);
				this.$container.find('.fortRecommendCheckbox').prop('checked', false);
				this.setManualMode(false);
				this.setCalculatedDisplay(null);
			}
			// Reset persisted values/flags
			this.setFOrtValue(0);
			this.setFlags(false, false, false);
		}
	}, {
		key: 'getDecision',
		value: function getDecision() {
			// Step 4 radio decision: 1=yes (available), 0=no (go to questions)
			var $checked = this.form.find('input.fortDecision:checked');
			if ($checked.length) {
				return parseInt($checked.val(), 10);
			}

			// If no radio selected yet, try to infer from persisted flags
			var isManual = this.getPersistedFlag('.fortIsManual');
			var useRecommend = this.getPersistedFlag('.fortUseRecommendation');
			if (isManual === true && useRecommend !== true) {
				return 1;
			}
			var isDerived = this.getPersistedFlag('.fortIsDerived');
			if (isDerived === true || useRecommend === true) {
				return 0;
			}

			return null;
		}
	}, {
		key: 'getPersistedFlag',
		value: function getPersistedFlag(selector) {
			var $field = this.form.find(selector).first();
			if (!$field.length) {
				return null;
			}
			var raw = String($field.val()).trim();
			if (raw === '') {
				return null;
			}
			return raw === '1' || raw === 'true';
		}
	}, {
		key: 'getPersistedFOrt',
		value: function getPersistedFOrt() {
			var $field = this.form.find('input.fortValue').first();
			if (!$field.length) {
				return null;
			}
			var raw = String($field.val()).trim();
			if (raw === '') {
				return null;
			}
			var value = parseFloat(raw);
			return isNaN(value) ? null : value;
		}
	}, {
		key: 'bindHandlers',
		value: function bindHandlers() {
			var _this = this;

			// Step 4 decision
			this.form.on('change', 'input.fortDecision', function (e) {
				// Without a shared name attribute, radios won't auto-uncheck each other.
				_this.form.find('input.fortDecision').not(e.target).prop('checked', false);

				var decision = _this.getDecision();
				if (decision === 1) {
					// fOrt provided directly
					_this.setFlags(true, false);
					// If a value is already selected, persist immediately
					var selected = _this.$step4.length ? String(_this.$step4.find('.fortStep4ValueSelect').val() || '').trim() : '';
					if (selected !== '') {
						_this.setFOrtValue(parseFloat(selected));
					}
				} else if (decision === 0) {
					// fOrt will be derived in Step 5
					_this.setFlags(false, false);
				}
				_this.updateVisibility();
				_this.recompute();
			});

			// Step 4 value selection
			this.form.on('change', '#fOrtStep4 .fortStep4ValueSelect', function (e) {
				var raw = String($(e.target).val() || '').trim();
				if (raw === '') {
					return;
				}
				var value = parseFloat(raw);
				if (!isNaN(value)) {
					_this.setFlags(true, false);
					_this.setFOrtValue(value);
				}
			});

			// Answer selection
			this.form.on('change', '#fOrtQuestionWizard .fortAnswerLevel', function () {
				// If user answers questions, clear manual recommendation and use derived mode
				var $recommend = _this.$container.find('.fortRecommendCheckbox');
				if ($recommend.length) {
					$recommend.prop('checked', false);
					$recommend.closest('.checkbox-root').removeClass('checked');
				}

				_this.setManualMode(false);
				_this.recompute();
			});

			// Recommendation checkbox
			this.form.on('change', '#fOrtQuestionWizard .fortRecommendCheckbox', function () {
				var $recommend = _this.$container.find('.fortRecommendCheckbox');
				var isChecked = $recommend.prop('checked');
				$recommend.closest('.checkbox-root').toggleClass('checked', isChecked);

				if (isChecked) {
					_this.setManualMode(true);
					_this.setFOrtValue(0.7);
					_this.setFlags(true, false, true);
					_this.setCalculatedDisplay(0.7);
				} else {
					_this.setManualMode(false);
					_this.recompute();
				}
			});
		}
	}, {
		key: 'setManualMode',
		value: function setManualMode(enabled) {
			this.$container.find('input').each(function (i, el) {
				var $el = $(el);
				if (!$el.hasClass('fortRecommendCheckbox')) {
					$el.prop('disabled', !!enabled);
					if (enabled) {
						$el.removeAttr('required');
					}
				}
			});
		}
	}, {
		key: 'recompute',
		value: function recompute() {
			var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			// Only recompute when Step 5 is actually visible/enabled or this is
			if (!init && (!this.$container.length || this.$step5.length && !this.$step5.is(':visible'))) {
				return;
			}

			// Recommendation checkbox wins
			var useRecommend = this.$container.find('.fortRecommendCheckbox').prop('checked');
			if (useRecommend) {
				this.setManualMode(true);
				this.setFOrtValue(0.7);
				this.setFlags(true, false, true);
				this.setCalculatedDisplay(0.7);
				return;
			}

			this.setManualMode(false);

			var result = this.computeDerivedFOrt();
			if (result !== null) {
				this.setFOrtValue(result);
				this.setFlags(false, true, false);
				this.setCalculatedDisplay(result);
			} else {
				// Not complete → do not persist a partial value
				this.setFOrtValue(0);
				this.setFlags(false, false, false);
				this.setCalculatedDisplay(null);
			}
		}
	}, {
		key: 'computeDerivedFOrt',
		value: function computeDerivedFOrt() {
			var _this2 = this;

			// We require all questions to be answered to persist a derived value
			var $rows = this.$container.find('tr[data-question-uid]');
			if (!$rows.length) {
				return null;
			}

			var sum = 0.0;
			var answered = 0;

			$rows.each(function (i, row) {
				var $row = $(row);
				var $checked = $row.find('.fortAnswerLevel:checked');
				if ($checked.length) {
					var level = parseInt($checked.val(), 10);
					if (_this2.answerValueMap[level] !== undefined) {
						sum += _this2.answerValueMap[level];
						answered += 1;
					}
				}
			});

			if (answered === 0) {
				return null;
			}

			if (answered !== $rows.length) {
				return null;
			}

			var avg = sum / answered;
			return Math.round(avg * 100) / 100;
		}
	}, {
		key: 'isValid',
		value: function isValid() {
			if (!this.$step5.length || !this.$step5.is(':visible')) {
				return true;
			}
			var useRecommend = this.$container.find('.fortRecommendCheckbox').prop('checked');
			if (useRecommend) {
				return true;
			}
			return this.computeDerivedFOrt() !== null;
		}
	}, {
		key: 'setFOrtValue',
		value: function setFOrtValue(value) {
			// Persisted hidden fields live in Step 4 slide (not inside the Step 5 question container)
			var $field = this.form.find('input.fortValue').first();
			if (!$field.length) {
				return;
			}
			$field.val(String(value));
			$field.trigger('change');

			// Trigger fK recomputation when fOrt changes
			if (this.host && this.host.fMethodeManager && typeof this.host.fMethodeManager.computeDerivedValues === 'function') {
				this.host.fMethodeManager.computeDerivedValues();
			}
		}
	}, {
		key: 'setFlags',
		value: function setFlags(isManual, isDerived, useRecommend) {
			// Persisted hidden fields live in Step 4 slide
			var $manual = this.form.find('input.fortIsManual').first();
			var $derived = this.form.find('input.fortIsDerived').first();
			var $recommend = this.form.find('input.fortUseRecommendation').first();

			if ($manual.length) {
				$manual.val(isManual ? '1' : '0');
			}
			if ($derived.length) {
				$derived.val(isDerived ? '1' : '0');
			}
			if ($recommend.length) {
				$recommend.val(useRecommend ? '1' : '0');
			}
		}
	}, {
		key: 'setCalculatedDisplay',
		value: function setCalculatedDisplay(valueOrNull) {
			var $display = this.$container.find('.fortCalculatedValue');
			if (!$display.length) {
				return;
			}
			if (valueOrNull === null) {
				$display.text('–');
				return;
			}
			$display.text(String(valueOrNull));
		}
	}]);

	return FOrtQuestionManager;
}();

exports.default = FOrtQuestionManager;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('../ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

var _MathUtility = require('../../Utility/MathUtility');

var _MathUtility2 = _interopRequireDefault(_MathUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * KiWizardManager (DWA-A 138-1)
 *
 * Responsibility:
 * - Step 1: decision if k_i is available
 * - If yes: collect mantissa/exponent and persist `ki` + `kiIsManual`
 * - If yes: hide Step 2–5 (skip) and show Step 6
 */
var KiWizardManager = function () {
    /**
     * @param {jQuery} form
     * @param {Object} state
     * @param {Object} host instance of ConfigurationForm
     */
    function KiWizardManager(form, state, host) {
        _classCallCheck(this, KiWizardManager);

        this.form = form;
        this.state = state;
        this.host = host;

        this.$step = $('#kiStep1');
        this.$wrapper = this.$step.closest('.kiWizardStep1');
        this.$indexNotationResult = $(_ConfigurationFormConfig2.default.selectors.kiIndexNotationResult);

        // Downstream slide content wrappers that are skipped when ki is manual
        this.$kStep2 = $('.kWizardStep2');
        this.$fKStep3 = $('.fKWizardStep3');
        this.$fOrtStep4 = $('.fortWizardStep4');
        this.$fOrtStep5 = $('.fortWizardStep5');
        this.$fMethodeStep6 = $('.fMethodeWizardStep6');

        this.wasActive = false;
        this.kiValue = 0;
    }

    _createClass(KiWizardManager, [{
        key: 'init',
        value: function init() {
            if (!this.$step.length) {
                return;
            }
            this.bindHandlers();
            this.updateVisibility();
            this.syncFromPersisted();
            this.recomputeKi();
        }
    }, {
        key: 'bindHandlers',
        value: function bindHandlers() {
            var _this = this;

            this.form.on('change', '#kiStep1 .kiDecision', function (e) {
                // radios without name: enforce exclusivity
                _this.form.find('#kiStep1 .kiDecision').not(e.target).prop('checked', false);

                var decision = _this.getDecision();
                if (decision === 1) {
                    _this.setKiIsManual(true);
                    _this.$step.find('.kiValueRow').show();
                    _this.$step.find('.kiSignificand, .kiExponent').prop('required', true);
                    _this.recomputeKi();
                } else if (decision === 0) {
                    _this.setKiIsManual(false);
                    _this.setKi(0);
                    _this.$step.find('.kiValueRow').hide();
                    _this.$step.find('.kiSignificand, .kiExponent').prop('required', false).val('');
                }

                _this.updateVisibility();
                _this.triggerDownstreamUpdate();
            });

            this.form.on('input', '#kiStep1 .kiSignificand', function () {
                if (_this.getDecision() === 1) {
                    _this.recomputeKi();
                }
            });
            this.form.on('change', '#kiStep1 .kiExponent', function () {
                if (_this.getDecision() === 1) {
                    _this.recomputeKi();
                }
            });

            var slide = $(_ConfigurationFormConfig2.default.selectors.kiSlide);
            slide.find('input, select').on('change', function () {
                _this.host.clearSlides(slide.nextAll(_ConfigurationFormConfig2.default.selectors.slides));
            });
        }
    }, {
        key: 'triggerDownstreamUpdate',
        value: function triggerDownstreamUpdate() {
            // Refresh downstream visibility/skip logic
            if (this.host && this.host.fkWizardManager && typeof this.host.fkWizardManager.updateVisibility === 'function') {
                this.host.fkWizardManager.updateVisibility();
            }
            if (this.host && this.host.fOrtQuestionManager && typeof this.host.fOrtQuestionManager.updateVisibility === 'function') {
                this.host.fOrtQuestionManager.updateVisibility();
            }
            if (this.host && this.host.fMethodeManager && typeof this.host.fMethodeManager.updateVisibility === 'function') {
                this.host.fMethodeManager.updateVisibility();
            }
        }
    }, {
        key: 'updateVisibility',
        value: function updateVisibility() {
            var isActive = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() : false;

            if (!isActive && this.wasActive) {
                this.reset();
            }

            if (isActive) {
                this.$wrapper.show();
                this.$step.show();
                if (typeof this.host.setInputsDisabled === 'function') {
                    this.host.setInputsDisabled(this.$wrapper, false);
                }
            } else {
                if (typeof this.host.setInputsDisabled === 'function') {
                    this.host.setInputsDisabled(this.$wrapper, true);
                }
                this.$step.hide();
                this.$wrapper.hide();
            }

            // Skip logic: if ki is manual, hide step2–5 and ensure step6 is available
            if (isActive) {
                var kiIsManual = this.getPersistedBool('.kiIsManual');
                console.log('[KiWizardManager] updateVisibility skip check', { kiIsManual: kiIsManual });
                if (kiIsManual) {
                    this.$kStep2.hide();
                    this.host.setInputsDisabled(this.$kStep2, true);
                    this.$fKStep3.hide();
                    this.host.setInputsDisabled(this.$fKStep3, true);
                    this.$fOrtStep4.hide();
                    this.host.setInputsDisabled(this.$fOrtStep4, true);
                    this.$fOrtStep5.hide();
                    this.host.setInputsDisabled(this.$fOrtStep5, true);
                    this.$fMethodeStep6.show();
                    this.host.setInputsDisabled(this.$fMethodeStep6, false);
                } else {
                    // Restore hidden steps when switching back to "No"
                    this.$kStep2.show();
                    this.host.setInputsDisabled(this.$kStep2, false);
                    this.$fKStep3.show();
                    this.host.setInputsDisabled(this.$fKStep3, false);
                    this.$fOrtStep4.show();
                    this.host.setInputsDisabled(this.$fOrtStep4, false);
                    this.$fOrtStep5.show();
                    this.host.setInputsDisabled(this.$fOrtStep5, false);
                }
            }

            this.wasActive = isActive;
        }
    }, {
        key: 'syncFromPersisted',
        value: function syncFromPersisted() {
            var kiIsManual = this.getPersistedBool('.kiIsManual');
            console.log('[KiWizardManager] syncFromPersisted', { kiIsManual: kiIsManual });
            if (kiIsManual === true) {
                this.form.find('#kiStep1 .kiDecision[value="1"]').prop('checked', true);
                this.$step.find('.kiValueRow').show();
                this.$step.find('.kiSignificand, .kiExponent').prop('required', true);

                // Recover significand and exponent from the full kiValue
                var $field = this.form.find('input.kiValue').first();
                var fullValue = parseFloat($field.val() || '0');
                if (fullValue > 0) {
                    // Find best matching exponent from select options
                    var $exponentSelect = this.$step.find('.kiExponent');
                    var exponents = $exponentSelect.find('option').map(function (i, opt) {
                        return $(opt).val();
                    }).get().filter(function (v) {
                        return v !== '';
                    });

                    var bestExp = -4; // Default to -4 as it's common
                    var bestMantissa = fullValue / Math.pow(10, bestExp);

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = exponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var expStr = _step.value;

                            var exp = parseInt(expStr, 10);
                            var mantissa = fullValue / Math.pow(10, exp);
                            // If mantissa is between 0.99 and 10.01, it's a good match
                            if (mantissa >= 0.99 && mantissa < 10.01) {
                                bestExp = exp;
                                bestMantissa = mantissa;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    this.$step.find('.kiSignificand').val(_MathUtility2.default.formatFloat(Math.round(bestMantissa * 100) / 100));
                    $exponentSelect.val(String(bestExp));

                    // Set result display without triggering change
                    this.$indexNotationResult.html('(' + _MathUtility2.default.formatFloat(fullValue) + ')');
                }
            } else if (kiIsManual === false) {
                this.form.find('#kiStep1 .kiDecision[value="0"]').prop('checked', true);
                this.$step.find('.kiValueRow').hide();
                this.$step.find('.kiSignificand, .kiExponent').prop('required', false);
            } else {
                // Default: if it's explicitly guideline 138-1 and no value set, pre-select "No"
                var isActive = typeof this.host.isGuideline1381Active === 'function' ? this.host.isGuideline1381Active() : false;
                console.log('[KiWizardManager] syncFromPersisted fallback', { isActive: isActive });
                if (isActive) {
                    this.form.find('#kiStep1 .kiDecision[value="0"]').prop('checked', true);
                    this.setKiIsManual(false);
                }
            }
        }
    }, {
        key: 'getDecision',
        value: function getDecision() {
            var $checked = this.form.find('#kiStep1 .kiDecision:checked');
            if ($checked.length) {
                return parseInt($checked.val(), 10);
            }
            return null;
        }
    }, {
        key: 'recomputeKi',
        value: function recomputeKi() {
            var rawMantissa = String(this.$step.find('.kiSignificand').val() || '').trim().replace(',', '.');
            var rawExponent = String(this.$step.find('.kiExponent').val() || '').trim();
            if (rawMantissa === '' || rawExponent === '') {
                this.setKi(0);
                this.$indexNotationResult.html('');
                return;
            }

            var value = _MathUtility2.default.resolveIndexNotation(rawMantissa, rawExponent);
            this.setKi(value);

            // Show formatted result behind inputs
            this.$indexNotationResult.html('(' + _MathUtility2.default.formatFloat(value) + ')');
        }
    }, {
        key: 'setKi',
        value: function setKi(value) {
            var triggerChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var $field = this.form.find('input.kiValue').first();
            if (!$field.length) {
                return;
            }
            this.kiValue = value;
            $field.val(String(value));
            if (triggerChange) {
                $field.trigger('change');
            }
        }
    }, {
        key: 'getKi',
        value: function getKi() {
            return this.kiValue;
        }
    }, {
        key: 'setKiIsManual',
        value: function setKiIsManual(enabled) {
            var $field = this.form.find('input.kiIsManual').first();
            if (!$field.length) {
                return;
            }
            $field.val(enabled ? '1' : '0');
        }
    }, {
        key: 'isKiManual',
        value: function isKiManual() {
            return this.getPersistedBool('.kiIsManual');
        }
    }, {
        key: 'isKiInPermissableRange',
        value: function isKiInPermissableRange() {
            return this.getKi() >= 0.000001 && this.getKi() <= 0.001;
        }
    }, {
        key: 'getPersistedBool',
        value: function getPersistedBool(selector) {
            var $field = this.form.find(selector).first();
            if (!$field.length) {
                return null;
            }
            var raw = String($field.val() || '').trim();
            if (raw === '') {
                return null;
            }
            return raw === '1' || raw === 'true';
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.form.find('#kiStep1 .kiDecision').prop('checked', false);
            this.$step.find('.kiSignificand, .kiExponent').val('').prop('required', false);
            this.$step.find('.kiValueRow').hide();
            this.$indexNotationResult.html('');
            this.setKiIsManual(false);
            this.setKi(0);
        }
    }]);

    return KiWizardManager;
}();

exports.default = KiWizardManager;

},{"../../Utility/MathUtility":16,"../ConfigurationFormConfig":4}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('../ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

var _AjaxUtility = require('../../Utility/AjaxUtility');

var _AjaxUtility2 = _interopRequireDefault(_AjaxUtility);

var _RainwaterSelectionMap = require('../RainwaterSelectionMap');

var _RainwaterSelectionMap2 = _interopRequireDefault(_RainwaterSelectionMap);

var _RainwaterSelectionMapAt = require('../RainwaterSelectionMapAt');

var _RainwaterSelectionMapAt2 = _interopRequireDefault(_RainwaterSelectionMapAt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocationManager = function () {

	/**
  * @param {jQuery} form - Das Formular-Element
  * @param {Object} sharedState - Gemeinsames State-Objekt (muss { country: ... } enthalten)
  */
	function LocationManager(form, sharedState) {
		_classCallCheck(this, LocationManager);

		this.form = form;
		this.state = sharedState;

		// Wichtige DOM-Elemente cachen
		this.weatherStation = $(_ConfigurationFormConfig2.default.selectors.weatherStation);
		this.rcIndexInput = $(_ConfigurationFormConfig2.default.selectors.rcIndexInput);
		this.propertyZipInput = $(_ConfigurationFormConfig2.default.selectors.propertyZipInput);
		this.propertyCityInput = $(_ConfigurationFormConfig2.default.selectors.propertyCityInput);
		this.citySelect = $(_ConfigurationFormConfig2.default.selectors.citySelect);
		this.changeWeatherStationBtn = $(_ConfigurationFormConfig2.default.selectors.changeWeatherStation);
		this.resultMessageContainer = $(_ConfigurationFormConfig2.default.selectors.weatherStationCheckResult);

		// Local state
		this.rainwaterSelectionMap = null;
		this.rcIndex = this.rcIndexInput.val();
		this.initialMapGridSet = false;

		this.bindEvents();

		// Initial checks on load
		this.init();
	}

	_createClass(LocationManager, [{
		key: 'init',
		value: function init() {
			var _this = this;

			if (this.propertyZipInput.val() === '') {
				this.changeWeatherStationBtn.hide();
			}

			// Falls beim Laden keine Wetterstation/Index da ist, aber eine PLZ existiert -> Checken
			if (!this.rcIndex || this.rcIndex === '') {
				if (this.propertyZipInput.length && this.propertyZipInput.val() !== '') {
					var ajaxFinished = this.checkWeatherStation(this.propertyZipInput.val(), _ConfigurationFormConfig2.default.selectors.propertyCityDisplay);

					if (ajaxFinished) {
						ajaxFinished.done(function () {
							return _this.showManualWeatherStation();
						});
					}
				}
			}
		}
	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			var _this2 = this;

			// 1. Länderwahl
			var countryRadios = $(_ConfigurationFormConfig2.default.selectors.country);
			countryRadios.on('click', function (e) {
				_this2.countryChange(parseInt(e.target.value));
			});

			// Initialen State aus dem DOM lesen (falls Radio schon checked)
			var currentCountry = countryRadios.filter(':checked').val();
			if (currentCountry) {
				this.countryChange(parseInt(currentCountry), false);
			}

			// 2. PLZ Eingabe & Wetterstation Check
			this.propertyZipInput.on('blur', function (e) {
				if (_this2.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY) {
					_this2.checkWeatherStation(e.target.value, _ConfigurationFormConfig2.default.selectors.propertyCityDisplay);
				}
			});

			this.propertyZipInput.on('change', function () {
				_this2.resetWeatherStationCheck();
			});

			// 3. Manuelle Wetterstation wählen
			this.changeWeatherStationBtn.on('click', function (e) {
				e.preventDefault();
				_this2.setWeatherStationManually();
			});
		}

		/**
   * Hauptlogik für Länderwechsel (DE, AT, CH, etc.)
   */

	}, {
		key: 'countryChange',
		value: function countryChange(country) {
			var setDefaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			this.state.country = country; // Update Shared State

			// Get current element states
			var $weatherStation = $(_ConfigurationFormConfig2.default.selectors.weatherStation);
			var $cityDisplay = $(_ConfigurationFormConfig2.default.selectors.propertyCityDisplay);

			// Logik für Regenhäufigkeit (Frequency) Dropdown
			this.updateRainFrequencyOptions(country, setDefaultValues);

			// guidelines logic (also see ConfigurationForm -> infiltrationTypeChange)
			// force all countries except germany into legacy guideline
			if (country !== _ConfigurationFormConfig2.default.values.countries.GERMANY) {
				// preselect legacy guideline and disable guidelines selection for other countries
				$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).click();
				$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).parents(_ConfigurationFormConfig2.default.selectors.slides).data('skip', true);
			} else {
				$(_ConfigurationFormConfig2.default.selectors.legacyGuidelineRadio).parents(_ConfigurationFormConfig2.default.selectors.slides).data('skip', false);
			}

			// VSOAT-55: Stop at this point, if country is Austria. Do not change weather station selection or hide any options
			if (country === _ConfigurationFormConfig2.default.values.countries.AUSTRIA) {
				$cityDisplay.hide();
				this.propertyCityInput.show();
				this.changeWeatherStationBtn.hide();

				// initialise geocoder right away for Austrian map implementation
				var script = document.createElement('script');
				script.async = true;
				script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYhLdncbls5waHK0XTBHzZ8YPK88aTMUk&loading=async&callback=initGeocoder";
				document.body.appendChild(script);

				return;
			}

			// Logik für Deutschland vs. Andere
			if (country === _ConfigurationFormConfig2.default.values.countries.GERMANY) {
				// return to default
				$weatherStation.show();
				$cityDisplay.show();
				this.propertyCityInput.hide();
				if (this.propertyZipInput.val() !== '') {
					this.changeWeatherStationBtn.show();
				}
			} else {
				// switch to new mode
				$weatherStation.hide();
				$cityDisplay.hide();
				this.propertyCityInput.show();
				this.changeWeatherStationBtn.hide();

				if (this.rainwaterSelectionMap) {
					this.rainwaterSelectionMap.hide();
				}
			}
		}

		/**
   * Passt die Auswahlmöglichkeiten im Dropdown "Regenhäufigkeit" an das Land an
   */

	}, {
		key: 'updateRainFrequencyOptions',
		value: function updateRainFrequencyOptions(country) {
			var setDefaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			var indexDefaultFrequency = 3; // 5 Jahre
			var indexDefaultFrequencyCh = 4; // 10 Jahre
			var index15years = 5;
			var index50years = 8;
			var index100years = 9;

			// Manipulate rain frequency select for CH
			var rainFrequencySelect = $(_ConfigurationFormConfig2.default.selectors.rainFrequencySelect)[0];
			if (!rainFrequencySelect) return;

			// Get select options
			var rainFrequencyOptions = rainFrequencySelect.options;
			var defaultOptionText = rainFrequencySelect.dataset.defaultOptionText || '';

			// Default: hide 15 years and show 50 and 100 years
			var hideOptions = [index15years];
			var showOptions = [index50years, index100years];
			// Default selected value = 5 years
			var defaultValue = 5;
			// Add default text to 5 years (option 3) and remove from 10 years (option 4, if set by CH)
			var addDefaultTextIndex = indexDefaultFrequency;
			var removeDefaultTextIndex = indexDefaultFrequencyCh;

			if (country === _ConfigurationFormConfig2.default.values.countries.SWITZERLAND) {
				hideOptions = [index50years, index100years];
				showOptions = [index15years];
				defaultValue = 10;
				addDefaultTextIndex = indexDefaultFrequencyCh;
				removeDefaultTextIndex = indexDefaultFrequency;
			}

			// Set current default (selected) value for select
			if (setDefaultValues) {
				rainFrequencySelect.value = defaultValue;
			}

			// Add and remove default text
			if (rainFrequencyOptions[addDefaultTextIndex].innerHTML.indexOf(defaultOptionText) === -1) {
				rainFrequencyOptions[addDefaultTextIndex].innerHTML += defaultOptionText;
			}
			if (rainFrequencyOptions[removeDefaultTextIndex].innerHTML.indexOf(defaultOptionText) !== -1) {
				rainFrequencyOptions[removeDefaultTextIndex].innerHTML = rainFrequencyOptions[removeDefaultTextIndex].innerHTML.replace(defaultOptionText, '');
			}

			// Show/hide rainFrequencyOptions based on selected country
			hideOptions.forEach(function (idx) {
				if (rainFrequencyOptions[idx]) rainFrequencyOptions[idx].setAttribute('hidden', 'hidden');
			});
			showOptions.forEach(function (idx) {
				if (rainFrequencyOptions[idx]) rainFrequencyOptions[idx].removeAttribute('hidden');
			});
		}

		/**
   * Find the matching weather station
   * (this should probably be a separate object)
   *
   * @param submitForm
   * @param displayInputId
   * @param zip
   */

	}, {
		key: 'checkWeatherStation',
		value: function checkWeatherStation(zip, displayInputId) {
			var _this3 = this;

			var submitForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (this.state.country !== _ConfigurationFormConfig2.default.values.countries.GERMANY) {
				return;
			}

			var weatherStationCheckLoading = $(_ConfigurationFormConfig2.default.selectors.weatherStationCheckLoading);
			var cityInput = $(_ConfigurationFormConfig2.default.selectors.cityInput); // Hidden input für ID
			var displayInput = $(displayInputId);

			weatherStationCheckLoading.show();

			if (!zip && this.propertyZipInput.length) {
				zip = this.propertyZipInput.val();
			}

			return _AjaxUtility2.default.request('Configurator', {
				controller: 'Configuration',
				action: 'checkWeatherStation',
				zip: zip
			}).done(function (response) {
				var data = JSON.parse(response);
				var message = data.message;
				var city = data.city;

				_this3.rcIndex = data.rcIndex; // State update
				// Keep hidden input in sync for validation and backend submission
				_this3.rcIndexInput.val(_this3.rcIndex).trigger('change');

				_this3.resultMessageContainer.html(message);
				_this3.resultMessageContainer.toggle(message.length > 0);
				_this3.resultMessageContainer.toggleClass('error', data.error);
				weatherStationCheckLoading.hide();

				// set result if it was unambiguous
				if (city.uid !== undefined) {
					_this3.citySelect.html('<option value="' + city.uid + '">' + city.name + '</option>');
					_this3.citySelect.val(city.uid);

					if (displayInputId === _ConfigurationFormConfig2.default.selectors.propertyCityDisplay) {
						_this3.propertyCityInput.val(city.name);
					}
					if (displayInputId) {
						displayInput.val(city.name + '**');
					}

					cityInput.prop('required', false);

					if (submitForm) {
						_this3.form.submit();
					}

					if (_this3.rainwaterSelectionMap) {
						_this3.rainwaterSelectionMap.setViewToGridFeature(_this3.rcIndex);
						_this3.rainwaterSelectionMap.selectByRcIndex(_this3.rcIndex);
						_this3.rainwaterSelectionMap.show();
						_this3.resultMessageContainer.hide();
					} else {
						_this3.resultMessageContainer.show();
					}
				} else {
					// reset values
					_this3.citySelect.val(null);
					_this3.changeWeatherStationBtn.hide();
				}
			});
		}
	}, {
		key: 'showManualWeatherStation',
		value: function showManualWeatherStation() {
			var cityInput = $(_ConfigurationFormConfig2.default.selectors.cityInput);
			if (cityInput.length > 0 && cityInput.val().length > 0 && this.citySelect.length > 0 && this.citySelect[0].options.length === 0) {

				cityInput.addClass('error');
				$(_ConfigurationFormConfig2.default.selectors.manualWeatherStationSelection).show();
			}
		}
	}, {
		key: 'resetWeatherStationCheck',
		value: function resetWeatherStationCheck() {
			this.resultMessageContainer.hide();
		}
	}, {
		key: 'setWeatherStationManually',
		value: function setWeatherStationManually() {
			this.changeWeatherStationBtn.hide();
			this.resultMessageContainer.hide();

			if (!this.rainwaterSelectionMap) {
				if (this.state.country === _ConfigurationFormConfig2.default.values.countries.AUSTRIA) {
					this.rainwaterSelectionMap = new _RainwaterSelectionMapAt2.default();
				} else if (this.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY) {
					this.rainwaterSelectionMap = new _RainwaterSelectionMap2.default();
				}
			}

			if (this.rainwaterSelectionMap) {
				if (this.state.country === _ConfigurationFormConfig2.default.values.countries.AUSTRIA || this.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY) {
					this.rainwaterSelectionMap.show();
					// Resize-fix
					setTimeout(function () {
						window.dispatchEvent(new Event('resize'));
					}, 200);

					// Map Initialisierung (Zoom auf Grid/Home)
					if (this.rcIndex && !this.initialMapGridSet) {
						if (this.state.country === _ConfigurationFormConfig2.default.values.countries.AUSTRIA) {
							this.rainwaterSelectionMap.getNewHomeLocation();
						} else if (this.state.country === _ConfigurationFormConfig2.default.values.countries.GERMANY) {
							this.rainwaterSelectionMap.setViewToGridFeature(this.rcIndex);
							this.rainwaterSelectionMap.selectByRcIndex(this.rcIndex);
						}
						this.initialMapGridSet = true;
					}
				} else {
					this.rainwaterSelectionMap.hide();
				}
			}

			$(_ConfigurationFormConfig2.default.selectors.propertyCityDisplay).hide();
			this.propertyCityInput.show();
		}
	}, {
		key: 'validateZip',
		value: function validateZip(field, errors) {
			// Zugriff auf State country
			var country = this.state.country;

			switch (country) {
				case _ConfigurationFormConfig2.default.values.countries.GERMANY:
					if (!field.value.match(/^\d{5}$/)) {
						return this.addError(field, errors);
					}
					return true;
				case _ConfigurationFormConfig2.default.values.countries.NETHERLANDS:
					if (!field.value.match(/^\d{4}\s?\w{2}$/)) {
						return this.addError(field, errors);
					}
					return true;
				default:
					if (!field.value.match(/^\d{4}$/)) {
						return this.addError(field, errors);
					}
					return true;
			}
		}
	}, {
		key: 'validateRcIndex',
		value: function validateRcIndex(field, errors) {
			if (this.rcIndexInput.val() === '') {
				return this.addError(field, errors, $(field).data('rcindexmissing'));
			}
		}

		// Helper for validation errors

	}, {
		key: 'addError',
		value: function addError(field, errors) {
			var errorMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			errors[field.name] = {
				message: errorMsg || $(field).data('validationmessage') || field.validationMessage
			};
			$(field).addClass('error');
			return false;
		}
	}]);

	return LocationManager;
}();

exports.default = LocationManager;

},{"../../Utility/AjaxUtility":15,"../ConfigurationFormConfig":4,"../RainwaterSelectionMap":12,"../RainwaterSelectionMapAt":13}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require('./ConfigurationFormConfig');

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RainwaterSelectionMap = function () {
	function RainwaterSelectionMap() {
		var _this = this;

		_classCallCheck(this, RainwaterSelectionMap);

		$(_ConfigurationFormConfig2.default.selectors.rainwaterMapLoading).show();
		this.container = $('#weatherStationMap');
		this.gridFeatures = {};
		this.highlightLayer = null;
		this.rcIndexField = $(_ConfigurationFormConfig2.default.selectors.rcIndexInput);
		this.rcIndexOutput = $(_ConfigurationFormConfig2.default.selectors.rcIndexOutput);
		this.initialZoom = 12;

		this.show();

		this.map = L.map('weatherStationMap', {
			zoomControl: true,
			boxZoom: true,
			doubleClickZoom: true,
			dragging: true,
			scrollWheelZoom: true,
			touchZoom: true,
			maxZoom: 14,
			minZoom: 11
		}).fitBounds([[53.969012350740314, 14.963378906250002], [48.47292127248785, 6.174316406250001]]);
		this.map.zoomControl.setPosition('bottomright');
		this.map.attributionControl.setPrefix('<a href="https://www.bkg.bund.de" target="_blank">www.bkg.bund.de</a> &middot; <a href="https://github.com/tomchadwin/qgis2web" target="_blank">qgis2web</a> &middot; <a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> &middot; <a href="https://qgis.org">QGIS</a>');
		this.map.attributionControl.setPosition('bottomleft');
		var bounds_group = new L.featureGroup([]);
		this.map.createPane('pane_TopPlusOpenGraustufen_0');
		this.map.getPane('pane_TopPlusOpenGraustufen_0').style.zIndex = 400;
		var layer_TopPlusOpenGraustufen_0 = L.WMS.layer("https://sgx.geodatenzentrum.de/wms_topplus_open", "web", {
			pane: 'pane_TopPlusOpenGraustufen_0',
			format: 'image/png',
			uppercase: true,
			transparent: true,
			continuousWorld: true,
			tiled: true,
			info_format: 'text/html',
			opacity: 1,
			identify: false,
			attribution: ''
		});
		this.map.addLayer(layer_TopPlusOpenGraustufen_0);

		this.map.createPane('pane_KOSTRADWD2020Raster_1');
		this.map.getPane('pane_KOSTRADWD2020Raster_1').style.zIndex = 401;
		this.map.getPane('pane_KOSTRADWD2020Raster_1').style['mix-blend-mode'] = 'normal';
		var layer_KOSTRADWD2020Raster_1 = new L.geoJson(json_KOSTRADWD2020Raster_1, {
			attribution: '',
			interactive: true,
			dataVar: 'json_KOSTRADWD2020Raster_1',
			layerName: 'layer_KOSTRADWD2020Raster_1',
			pane: 'pane_KOSTRADWD2020Raster_1',
			onEachFeature: function onEachFeature(feature, layer) {
				return _this.pop_KOSTRADWD2020Raster_1(feature, layer);
			},
			style: function style(feature) {
				return _this.style_KOSTRADWD2020Raster_1_0(feature);
			}
		});

		var abstract = new L.Control({ 'position': 'topright' });
		abstract.onAdd = function () {
			_this.div = L.DomUtil.create('div', 'leaflet-control abstract');
			_this.div.id = 'abstract';
			_this.div.innerHTML = '<img src="/fileadmin/dwd-logo.png" />';
			return _this.div;
		};
		abstract.addTo(this.map);

		this.map.on('layeradd', function () {
			$(_ConfigurationFormConfig2.default.selectors.rainwaterMapLoading).hide();
		});

		bounds_group.addLayer(layer_KOSTRADWD2020Raster_1);
		this.map.addLayer(layer_KOSTRADWD2020Raster_1);

		this.hide();
	}

	_createClass(RainwaterSelectionMap, [{
		key: 'pop_KOSTRADWD2020Raster_1',
		value: function pop_KOSTRADWD2020Raster_1(feature, layer) {
			var _this2 = this;

			layer.on({
				mouseout: function mouseout(e) {
					if (e.target !== _this2.selectedFeature) {
						_this2.resetStyle(e.target);
					}
				},
				mouseover: function mouseover(e) {
					return _this2.highlightFeature(e);
				},
				click: function click(e) {
					return _this2.selectFeature(e);
				}
			});
			this.gridFeatures[feature.properties.INDEX_RC] = layer;
		}
	}, {
		key: 'style_KOSTRADWD2020Raster_1_0',
		value: function style_KOSTRADWD2020Raster_1_0(feature) {
			return {
				pane: 'pane_KOSTRADWD2020Raster_1',
				opacity: 1,
				color: 'rgba(53,121,177,1.0)',
				dashArray: '',
				lineCap: 'square',
				lineJoin: 'bevel',
				weight: 4.0,
				fillOpacity: 0,
				interactive: true
			};
		}
	}, {
		key: 'getFeatureLatLng',
		value: function getFeatureLatLng(INDEX_RC) {
			var layer = this.gridFeatures[INDEX_RC],
			    featureCoordinates = layer.feature.geometry.coordinates[0][0];
			// get center coordinates
			return [featureCoordinates[0][1] + (featureCoordinates[2][1] - featureCoordinates[0][1]) / 2, featureCoordinates[0][0] + (featureCoordinates[2][0] - featureCoordinates[0][0]) / 2];
		}
	}, {
		key: 'flyToGridFeature',
		value: function flyToGridFeature(INDEX_RC) {
			this.map.flyTo(this.getFeatureLatLng(INDEX_RC), this.initialZoom);
		}
	}, {
		key: 'setViewToGridFeature',
		value: function setViewToGridFeature(INDEX_RC) {
			this.map.setView(this.getFeatureLatLng(INDEX_RC), this.initialZoom);
		}
	}, {
		key: 'updateRcIndex',
		value: function updateRcIndex(rcIndex) {
			this.rcIndexField.val(rcIndex);
			this.rcIndexOutput.parent().show();
			/* Split rcIndex into row + column */
			var rcIndexOutput = 'Z' + rcIndex.slice(0, -3) + ' S' + rcIndex.slice(-3);
			this.rcIndexOutput.html(rcIndexOutput);
		}
	}, {
		key: 'highlightFeature',
		value: function highlightFeature(e) {
			if (e.target === this.selectedFeature) {
				return;
			}

			this.highlightLayer = e.target;

			this.highlightLayer.setStyle({
				fillColor: '#3179ff',
				fillOpacity: 0.3
			});
		}
	}, {
		key: 'selectFeature',
		value: function selectFeature(e) {
			this.updateRcIndex(e.target.feature.properties.INDEX_RC);

			if (this.selectedFeature) {
				this.resetStyle(this.selectedFeature);
			}

			this.selectedFeature = e.target;

			this.selectedFeature.setStyle({
				fillColor: '#3179ff',
				fillOpacity: 0.5
			});
		}
	}, {
		key: 'selectByRcIndex',
		value: function selectByRcIndex(rcIndex) {
			this.selectFeature({ target: this.gridFeatures[rcIndex] });
		}
	}, {
		key: 'resetStyle',
		value: function resetStyle(feature) {
			feature.setStyle({
				fillColor: '#3179ff',
				fillOpacity: 0
			});
		}
	}, {
		key: 'hide',
		value: function hide() {
			this.container.hide();
			console.log('hide');
		}
	}, {
		key: 'show',
		value: function show() {
			this.container.show();
			console.log('show');
		}
	}]);

	return RainwaterSelectionMap;
}();

exports.default = RainwaterSelectionMap;

},{"./ConfigurationFormConfig":4}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigurationFormConfig = require("./ConfigurationFormConfig");

var _ConfigurationFormConfig2 = _interopRequireDefault(_ConfigurationFormConfig);

var _AjaxUtility = require("../Utility/AjaxUtility");

var _AjaxUtility2 = _interopRequireDefault(_AjaxUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var geocoder;

window.initGeocoder = function () {
	geocoder = new google.maps.Geocoder();
};

var RainwaterSelectionMapAt = function () {
	function RainwaterSelectionMapAt() {
		var _this = this;

		_classCallCheck(this, RainwaterSelectionMapAt);

		$(_ConfigurationFormConfig2.default.selectors.rainwaterMapLoading).show();
		this.container = $('#weatherStationMap');
		var iconPath = this.container.data('icon-path');
		this.geoCodeErrorMsg = $('#geocodeError');
		this.rcIndexField = $(_ConfigurationFormConfig2.default.selectors.rcIndexInput);
		this.rcIndexOutput = $(_ConfigurationFormConfig2.default.selectors.rcIndexOutput);
		this.locationData = null;
		this.homeLocation = null;
		this.homeMarker = null;
		this.closestLocationMarker = null;
		this.activeMarker = null;
		this.distanceMarkers = [];
		this.propertyZipInput = $(_ConfigurationFormConfig2.default.selectors.propertyZipInput);
		this.propertyCityInput = $(_ConfigurationFormConfig2.default.selectors.propertyCityInput);
		this.propertyStreetInput = $(_ConfigurationFormConfig2.default.selectors.propertyStreetInput);
		this.originalGridIndexInput = $(_ConfigurationFormConfig2.default.selectors.originalGridIndexInput);
		this.regionInput = $(_ConfigurationFormConfig2.default.selectors.regionInput);

		this.show();

		this.map = L.map('weatherStationMap', {
			zoomControl: true,
			boxZoom: true,
			doubleClickZoom: true,
			dragging: true,
			scrollWheelZoom: true,
			touchZoom: true,
			maxZoom: 14,
			minZoom: 11
		}).fitBounds([[47.25620524764984, 9.538350376340047], [48.906986611234885, 17.012186347002995]]);
		this.map.zoomControl.setPosition('bottomright');
		this.map.attributionControl.setPrefix('<a href="https://www.bkg.bund.de" target="_blank">www.bkg.bund.de</a> &middot; <a href="https://github.com/tomchadwin/qgis2web" target="_blank">qgis2web</a> &middot; <a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> &middot; <a href="https://qgis.org">QGIS</a>');
		this.map.attributionControl.setPosition('bottomleft');
		var bounds_group = new L.featureGroup([]);
		this.map.createPane('pane_TopPlusOpenGraustufen_0');
		this.map.getPane('pane_TopPlusOpenGraustufen_0').style.zIndex = 400;
		var layer_TopPlusOpenGraustufen_0 = L.WMS.layer("https://sgx.geodatenzentrum.de/wms_topplus_open", "web", {
			pane: 'pane_TopPlusOpenGraustufen_0',
			format: 'image/png',
			uppercase: true,
			transparent: true,
			continuousWorld: true,
			tiled: true,
			info_format: 'text/html',
			opacity: 1,
			identify: false,
			attribution: ''
		});
		this.map.addLayer(layer_TopPlusOpenGraustufen_0);
		this.homeIcon = L.icon({
			iconUrl: iconPath + 'marker-home.png',
			shadowUrl: iconPath + 'marker-shadow.png',

			iconSize: [60, 61], // size of the icon
			shadowSize: [41, 41], // size of the shadow
			iconAnchor: [30, 52], // point of the icon which will correspond to marker's location
			shadowAnchor: [12, 41], // the same for the shadow
			popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
		});
		this.activeIcon = L.icon({
			iconUrl: iconPath + 'marker-active.png',
			shadowUrl: iconPath + 'marker-shadow.png',

			iconSize: [61, 61], // size of the icon
			shadowSize: [41, 41], // size of the shadow
			iconAnchor: [30, 52], // point of the icon which will correspond to marker's location
			shadowAnchor: [12, 41], // the same for the shadow
			popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
		});

		/*
  const abstract = new L.Control({'position': 'topright'});
  abstract.onAdd = () => {
  	this.div = L.DomUtil.create('div', 'leaflet-control abstract');
  	this.div.id = 'abstract'
  	this.div.innerHTML = '<img src="/fileadmin/dwd-logo.png" />'
  	return this.div;
  }
  abstract.addTo(this.map);
   */

		this.map.on('layeradd', function () {
			$(_ConfigurationFormConfig2.default.selectors.rainwaterMapLoading).hide();
		});

		this.hide();

		this.getLocationData();

		this.propertyZipInput.on('blur', function () {
			return _this.getNewHomeLocation();
		});
		this.propertyCityInput.on('blur', function () {
			return _this.getNewHomeLocation();
		});
		this.propertyStreetInput.on('blur', function () {
			return _this.getNewHomeLocation();
		});
	}

	_createClass(RainwaterSelectionMapAt, [{
		key: "addMoveHandler",
		value: function addMoveHandler() {
			var _this2 = this;

			this.map.on("moveend", function () {
				var center = _this2.map.getCenter();
				var closestLocations = _this2.findClosestLocations([center.lat, center.lng], _this2.homeLocation);
				_this2.removeDistanceMarkers();
				closestLocations.forEach(function (location) {
					_this2.setDistanceMarker(location);
				});
			});
		}
	}, {
		key: "removeMoveHandler",
		value: function removeMoveHandler() {
			this.map.off("moveend");
		}
	}, {
		key: "getNewHomeLocation",
		value: function getNewHomeLocation() {
			var zip = this.propertyZipInput[0].value;
			if (zip !== '' && /^[0-9]{4}$/.test(zip) && this.propertyCityInput[0].value !== '' && this.propertyStreetInput[0].value !== '') {
				this.findLocation(this.propertyStreetInput[0].value + ", " + this.propertyZipInput[0].value + " " + this.propertyCityInput[0].value + ", Austria");
			}
		}
	}, {
		key: "findLocation",
		value: function findLocation(address) {
			var _this3 = this;

			if (geocoder) {
				this.geoCodeErrorMsg.hide();
				this.removeMoveHandler();

				return geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == 'OK') {
						if (results[0].address_components.length < 2) {
							_this3.geoCodeErrorMsg.show();
							return;
						}

						_this3.show();
						_this3.homeLocation = [results[0].geometry.location.lat(), results[0].geometry.location.lng()];

						if (_this3.homeMarker !== null) {
							_this3.homeMarker.removeFrom(_this3.map);
						}
						_this3.homeMarker = _this3.setMarker(_this3.homeLocation, 'home');

						var closestLocations = _this3.findClosestLocations(_this3.homeLocation);
						var bounds = _this3.getBounds(closestLocations);
						_this3.originalGridIndexInput.val(closestLocations[0].location.g);
						_this3.regionInput.val(_this3.getRegionFromGeocode(results[0]));

						_this3.removeDistanceMarkers();
						closestLocations.forEach(function (location, i) {
							if (i === 0) {
								_this3.updateRcIndex(location.location.g, _this3.setDistanceMarker(location));
							} else {
								_this3.setDistanceMarker(location);
							}
						});
						_this3.map.fitBounds(bounds);
						_this3.addMoveHandler();
					} else {
						alert('Geocode was not successful for the following reason: ' + status);
					}
				});
			}
		}
	}, {
		key: "getRegionFromGeocode",
		value: function getRegionFromGeocode(geocodeResults) {
			var region = geocodeResults.address_components.find(function (addressComponent) {
				return addressComponent.types.includes('administrative_area_level_1');
			});
			if (region !== undefined) {
				return region.long_name;
			}

			return '';
		}
	}, {
		key: "setMarker",
		value: function setMarker(position, title) {
			if (title == 'home') {
				return L.marker(position, { icon: this.homeIcon }).addTo(this.map);
			}
			return L.marker(position, { title: title }).addTo(this.map);
		}
	}, {
		key: "setDistanceMarker",
		value: function setDistanceMarker(location) {
			var _this4 = this;

			var addToArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			var marker = L.marker(location.location.l, { opacity: 0.6, title: location.distance.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' km' }).addTo(this.map);
			marker.on('click', function () {
				_this4.updateRcIndex(location.location.g, marker);
			});
			if (this.activeMarker && location.location.l[0] === this.activeMarker.getLatLng().lat && location.location.l[1] === this.activeMarker.getLatLng().lng) {
				marker.setOpacity(1);
				marker.setIcon(this.activeIcon);
				this.activeMarker = marker;
			}
			if (addToArray) {
				this.distanceMarkers.push(marker);
			}
			return marker;
		}
	}, {
		key: "removeDistanceMarkers",
		value: function removeDistanceMarkers() {
			var _this5 = this;

			if (this.distanceMarkers.length) {
				this.distanceMarkers.forEach(function (marker) {
					marker.removeFrom(_this5.map);
				});
				this.distanceMarkers = [];
			}
		}
	}, {
		key: "updateRcIndex",
		value: function updateRcIndex(rcIndex, marker) {
			if (this.activeMarker !== null) {
				this.activeMarker.setOpacity(0.6);
				this.activeMarker.setIcon(marker.getIcon());
			}

			marker.setIcon(this.activeIcon);
			marker.setOpacity(1);
			this.activeMarker = marker;
			this.rcIndexField.val(rcIndex);

			this.rcIndexOutput.parent().show();
			this.rcIndexOutput.html(rcIndex);
		}
	}, {
		key: "getLocationData",
		value: function getLocationData() {
			var _this6 = this;

			this.locationData = JSON.parse(sessionStorage.getItem('locationData'));
			if (this.locationData === null) {
				_AjaxUtility2.default.request('Configurator', {
					controller: 'Configuration',
					action: 'getLocationData'
				}).done(function (response) {
					_this6.locationData = JSON.parse(response);
					sessionStorage.setItem('locationData', response);
				});
			}
		}
	}, {
		key: "findClosestLocations",
		value: function findClosestLocations(location) {
			var _this7 = this;

			var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var locations = this.locationData.reduce(function (carry, loc) {
				var distance = _this7.calcGeographicalDistance(location, loc['l']);

				if (carry.length === 0 || carry[carry.length - 1].distance > distance) {
					carry.push({
						distance: distance,
						location: loc
					});
					carry.sort(function (a, b) {
						return a.distance - b.distance;
					});
					if (carry.length > 70) {
						carry.pop();
					}
				}

				return carry;
			}, []);

			// calculate distance to origin point when searching from map center
			if (origin !== null) {
				locations.forEach(function (loc) {
					loc.distance = _this7.calcGeographicalDistance(origin, loc.location['l']);
				});
			}

			return locations;
		}

		/**
   * Calculates geographical distance between two coordinates
   */

	}, {
		key: "calcGeographicalDistance",
		value: function calcGeographicalDistance(loc1, loc2) {
			/*
   ACOS
   	(
   		(
   			SIN(Lat1) * SIN(Lat2)
   		) +
   		(
   			COS(Lat1) * COS(Lat2)
   		) *
   		(
   			COS(Lon2 - Lon1)
   		)
   	) * 6371
    */
			var loc10 = this.toRadians(loc1[0]),
			    loc11 = this.toRadians(loc1[1]),
			    loc20 = this.toRadians(loc2[0]),
			    loc21 = this.toRadians(loc2[1]);

			return Math.acos(Math.sin(loc10) * Math.sin(loc20) + Math.cos(loc10) * Math.cos(loc20) * Math.cos(loc21 - loc11)) * 6371;
		}
	}, {
		key: "getBounds",
		value: function getBounds(locations) {
			return locations.reduce(function (carry, loc) {
				if (loc.location.l[0] < carry[0][0]) {
					carry[0][0] = loc.location.l[0];
				}
				if (loc.location.l[1] < carry[0][1]) {
					carry[0][1] = loc.location.l[1];
				}
				if (loc.location.l[0] > carry[1][0]) {
					carry[1][0] = loc.location.l[0];
				}
				if (loc.location.l[1] > carry[1][1]) {
					carry[1][1] = loc.location.l[1];
				}
				return carry;
			}, [[9999, 9999], [-9999, -9999]]);
		}
	}, {
		key: "toRadians",
		value: function toRadians(deg) {
			return deg * Math.PI / 180.0;
		}
	}, {
		key: "hide",
		value: function hide() {
			this.container.hide();
		}
	}, {
		key: "show",
		value: function show() {
			this.container.show();
		}
	}]);

	return RainwaterSelectionMapAt;
}();

exports.default = RainwaterSelectionMapAt;

},{"../Utility/AjaxUtility":15,"./ConfigurationFormConfig":4}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
// set plugin names by pageTypes for ajax requests
var AjaxPageTypes = exports.AjaxPageTypes = {
	Configurator: {
		typeNum: 3500,
		pluginName: 'tx_iggrafinfiltration_configurator'
	},
	Administration: {
		typeNum: 3510,
		pluginName: 'tx_iggrafinfiltration_administration'
	},
	Articletool: {
		typeNum: 3520,
		pluginName: 'tx_iggrafinfiltration_articletool'
	}
};

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Settings = require('../Settings');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility class for ajax requests
 */
var AjaxUtility = function () {
	function AjaxUtility() {
		_classCallCheck(this, AjaxUtility);
	}

	_createClass(AjaxUtility, [{
		key: 'request',


		/**
   * Executes a ajax request to the server and returns a jqXHR Promise Object
   * @param {string} type
   * @param {object} data
   * @param {string} url
   * @returns {jqXHR|Promise}
   */
		value: function request(plugin) {
			var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location.origin;

			var ajaxConfig = _Settings.AjaxPageTypes[plugin];

			var data = {
				type: ajaxConfig.typeNum
			};

			data[ajaxConfig.pluginName] = params;

			return $.ajax({
				url: url,
				type: 'GET',
				data: data
			});
		}
	}]);

	return AjaxUtility;
}();

exports.default = new AjaxUtility();

},{"../Settings":14}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Math utility for infiltration calculations
 */
var MathUtility = function () {
  function MathUtility() {
    _classCallCheck(this, MathUtility);
  }

  _createClass(MathUtility, null, [{
    key: 'resolveIndexNotation',

    /**
     * Resolves index notation (significand * 10^exponent) and rounds to 7 decimal places
     *
     * @param {number|string} significand
     * @param {number|string} exponent
     * @returns {number}
     */
    value: function resolveIndexNotation(significand, exponent) {
      if (!significand || !exponent) {
        return 0;
      }
      var val = parseFloat(significand) * Math.pow(10, parseInt(exponent));
      return Math.round(val * 10000000) / 10000000;
    }

    /**
     * Formats a float for display (German decimal separator)
     *
     * @param {number} value
     * @returns {string}
     */

  }, {
    key: 'formatFloat',
    value: function formatFloat(value) {
      return value.toString().replace('.', ',');
    }
  }, {
    key: 'round',
    value: function round(number, precision) {
      var precisionMultiplicative = Math.pow(10, precision);

      return Math.round(number * precisionMultiplicative) / precisionMultiplicative;
    }
  }]);

  return MathUtility;
}();

exports.default = MathUtility;

},{}],17:[function(require,module,exports){
'use strict';

require('babel-polyfill');

var _ConfigurationForm = require('./ConfigurationForm/ConfigurationForm');

var _ConfigurationForm2 = _interopRequireDefault(_ConfigurationForm);

var _Angletool = require('./Angletool/Angletool');

var _Angletool2 = _interopRequireDefault(_Angletool);

var _Articletool = require('./Articletool/Articletool');

var _Articletool2 = _interopRequireDefault(_Articletool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {

	new _ConfigurationForm2.default();

	if (document.getElementById('angletool')) {
		new _Angletool2.default();
	}

	if (document.getElementById('articletool')) {
		new _Articletool2.default();
	}
});

},{"./Angletool/Angletool":1,"./Articletool/Articletool":2,"./ConfigurationForm/ConfigurationForm":3,"babel-polyfill":18}],18:[function(require,module,exports){
(function (global){(function (){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"core-js/fn/regexp/escape":20,"core-js/shim":348,"regenerator-runtime/runtime":19}],19:[function(require,module,exports){
(function (global){(function (){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],20:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":42,"../../modules/core.regexp.escape":150}],21:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],22:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":37}],23:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":62,"./_wks":148}],24:[function(require,module,exports){
'use strict';
var at = require('./_string-at')(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

},{"./_string-at":125}],25:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],26:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":71}],27:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":133,"./_to-length":137,"./_to-object":138}],28:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":133,"./_to-length":137,"./_to-object":138}],29:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":58}],30:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":133,"./_to-iobject":136,"./_to-length":137}],31:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":34,"./_ctx":44,"./_iobject":67,"./_to-length":137,"./_to-object":138}],32:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":21,"./_iobject":67,"./_to-length":137,"./_to-object":138}],33:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":69,"./_is-object":71,"./_wks":148}],34:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":33}],35:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":21,"./_invoke":66,"./_is-object":71}],36:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":37,"./_wks":148}],37:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],38:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":25,"./_ctx":44,"./_descriptors":48,"./_for-of":58,"./_iter-define":75,"./_iter-step":77,"./_meta":85,"./_object-create":90,"./_object-dp":91,"./_redefine-all":110,"./_set-species":119,"./_validate-collection":145}],39:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":29,"./_classof":36}],40:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":25,"./_an-object":26,"./_array-methods":31,"./_for-of":58,"./_has":61,"./_is-object":71,"./_meta":85,"./_redefine-all":110,"./_validate-collection":145}],41:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":25,"./_export":52,"./_fails":54,"./_for-of":58,"./_global":60,"./_inherit-if-required":65,"./_is-object":71,"./_iter-detect":76,"./_meta":85,"./_redefine":111,"./_redefine-all":110,"./_set-to-string-tag":120}],42:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],43:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":91,"./_property-desc":109}],44:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":21}],45:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":54}],46:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":26,"./_to-primitive":139}],47:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],48:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":54}],49:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":60,"./_is-object":71}],50:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],51:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":97,"./_object-keys":100,"./_object-pie":101}],52:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":42,"./_ctx":44,"./_global":60,"./_hide":62,"./_redefine":111}],53:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":148}],54:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],55:[function(require,module,exports){
'use strict';
require('./es6.regexp.exec');
var redefine = require('./_redefine');
var hide = require('./_hide');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');
var regexpExec = require('./_regexp-exec');

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":47,"./_fails":54,"./_hide":62,"./_redefine":111,"./_regexp-exec":113,"./_wks":148,"./es6.regexp.exec":245}],56:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":26}],57:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":44,"./_is-array":69,"./_is-object":71,"./_to-length":137,"./_wks":148}],58:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":26,"./_ctx":44,"./_is-array-iter":68,"./_iter-call":73,"./_to-length":137,"./core.get-iterator-method":149}],59:[function(require,module,exports){
module.exports = require('./_shared')('native-function-to-string', Function.toString);

},{"./_shared":122}],60:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],61:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],62:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":48,"./_object-dp":91,"./_property-desc":109}],63:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":60}],64:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":48,"./_dom-create":49,"./_fails":54}],65:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":71,"./_set-proto":118}],66:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],67:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":37}],68:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":78,"./_wks":148}],69:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":37}],70:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":71}],71:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],72:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":37,"./_is-object":71,"./_wks":148}],73:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":26}],74:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":62,"./_object-create":90,"./_property-desc":109,"./_set-to-string-tag":120,"./_wks":148}],75:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":52,"./_hide":62,"./_iter-create":74,"./_iterators":78,"./_library":79,"./_object-gpo":98,"./_redefine":111,"./_set-to-string-tag":120,"./_wks":148}],76:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":148}],77:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],78:[function(require,module,exports){
module.exports = {};

},{}],79:[function(require,module,exports){
module.exports = false;

},{}],80:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],81:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":84}],82:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],83:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],84:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],85:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":54,"./_has":61,"./_is-object":71,"./_object-dp":91,"./_uid":143}],86:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":52,"./_shared":122,"./es6.map":180,"./es6.weak-map":287}],87:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":37,"./_global":60,"./_task":132}],88:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":21}],89:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":48,"./_fails":54,"./_iobject":67,"./_object-gops":97,"./_object-keys":100,"./_object-pie":101,"./_to-object":138}],90:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":26,"./_dom-create":49,"./_enum-bug-keys":50,"./_html":63,"./_object-dps":92,"./_shared-key":121}],91:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":26,"./_descriptors":48,"./_ie8-dom-define":64,"./_to-primitive":139}],92:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":26,"./_descriptors":48,"./_object-dp":91,"./_object-keys":100}],93:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":54,"./_global":60,"./_library":79}],94:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":48,"./_has":61,"./_ie8-dom-define":64,"./_object-pie":101,"./_property-desc":109,"./_to-iobject":136,"./_to-primitive":139}],95:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":96,"./_to-iobject":136}],96:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":50,"./_object-keys-internal":99}],97:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],98:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":61,"./_shared-key":121,"./_to-object":138}],99:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":30,"./_has":61,"./_shared-key":121,"./_to-iobject":136}],100:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":50,"./_object-keys-internal":99}],101:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],102:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":42,"./_export":52,"./_fails":54}],103:[function(require,module,exports){
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"./_descriptors":48,"./_object-keys":100,"./_object-pie":101,"./_to-iobject":136}],104:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":26,"./_global":60,"./_object-gopn":96,"./_object-gops":97}],105:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":60,"./_string-trim":130,"./_string-ws":131}],106:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":60,"./_string-trim":130,"./_string-ws":131}],107:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],108:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":26,"./_is-object":71,"./_new-promise-capability":88}],109:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],110:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":111}],111:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var $toString = require('./_function-to-string');
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":42,"./_function-to-string":59,"./_global":60,"./_has":61,"./_hide":62,"./_uid":143}],112:[function(require,module,exports){
'use strict';

var classof = require('./_classof');
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

},{"./_classof":36}],113:[function(require,module,exports){
'use strict';

var regexpFlags = require('./_flags');

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

},{"./_flags":56}],114:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],115:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],116:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":21,"./_ctx":44,"./_export":52,"./_for-of":58}],117:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":52}],118:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":26,"./_ctx":44,"./_is-object":71,"./_object-gopd":94}],119:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":48,"./_global":60,"./_object-dp":91,"./_wks":148}],120:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":61,"./_object-dp":91,"./_wks":148}],121:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":122,"./_uid":143}],122:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":42,"./_global":60,"./_library":79}],123:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":21,"./_an-object":26,"./_wks":148}],124:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":54}],125:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":47,"./_to-integer":135}],126:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":47,"./_is-regexp":72}],127:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":47,"./_export":52,"./_fails":54}],128:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":47,"./_string-repeat":129,"./_to-length":137}],129:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":47,"./_to-integer":135}],130:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":47,"./_export":52,"./_fails":54,"./_string-ws":131}],131:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],132:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":37,"./_ctx":44,"./_dom-create":49,"./_global":60,"./_html":63,"./_invoke":66}],133:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":135}],134:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":135,"./_to-length":137}],135:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],136:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":47,"./_iobject":67}],137:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":135}],138:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":47}],139:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":71}],140:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":25,"./_array-copy-within":27,"./_array-fill":28,"./_array-includes":30,"./_array-methods":31,"./_classof":36,"./_ctx":44,"./_descriptors":48,"./_export":52,"./_fails":54,"./_global":60,"./_has":61,"./_hide":62,"./_is-array-iter":68,"./_is-object":71,"./_iter-detect":76,"./_iterators":78,"./_library":79,"./_object-create":90,"./_object-dp":91,"./_object-gopd":94,"./_object-gopn":96,"./_object-gpo":98,"./_property-desc":109,"./_redefine-all":110,"./_set-species":119,"./_species-constructor":123,"./_to-absolute-index":133,"./_to-index":134,"./_to-integer":135,"./_to-length":137,"./_to-object":138,"./_to-primitive":139,"./_typed":142,"./_typed-buffer":141,"./_uid":143,"./_wks":148,"./core.get-iterator-method":149,"./es6.array.iterator":161}],141:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":25,"./_array-fill":28,"./_descriptors":48,"./_fails":54,"./_global":60,"./_hide":62,"./_library":79,"./_object-dp":91,"./_object-gopn":96,"./_redefine-all":110,"./_set-to-string-tag":120,"./_to-index":134,"./_to-integer":135,"./_to-length":137,"./_typed":142}],142:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":60,"./_hide":62,"./_uid":143}],143:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],144:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":60}],145:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":71}],146:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":42,"./_global":60,"./_library":79,"./_object-dp":91,"./_wks-ext":147}],147:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":148}],148:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":60,"./_shared":122,"./_uid":143}],149:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":36,"./_core":42,"./_iterators":78,"./_wks":148}],150:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":52,"./_replacer":114}],151:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":23,"./_array-copy-within":27,"./_export":52}],152:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":31,"./_export":52,"./_strict-method":124}],153:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":23,"./_array-fill":28,"./_export":52}],154:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":31,"./_export":52,"./_strict-method":124}],155:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":23,"./_array-methods":31,"./_export":52}],156:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":23,"./_array-methods":31,"./_export":52}],157:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":31,"./_export":52,"./_strict-method":124}],158:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":43,"./_ctx":44,"./_export":52,"./_is-array-iter":68,"./_iter-call":73,"./_iter-detect":76,"./_to-length":137,"./_to-object":138,"./core.get-iterator-method":149}],159:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":30,"./_export":52,"./_strict-method":124}],160:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":52,"./_is-array":69}],161:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":23,"./_iter-define":75,"./_iter-step":77,"./_iterators":78,"./_to-iobject":136}],162:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":52,"./_iobject":67,"./_strict-method":124,"./_to-iobject":136}],163:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":52,"./_strict-method":124,"./_to-integer":135,"./_to-iobject":136,"./_to-length":137}],164:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":31,"./_export":52,"./_strict-method":124}],165:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":43,"./_export":52,"./_fails":54}],166:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":32,"./_export":52,"./_strict-method":124}],167:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":32,"./_export":52,"./_strict-method":124}],168:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":37,"./_export":52,"./_fails":54,"./_html":63,"./_to-absolute-index":133,"./_to-length":137}],169:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":31,"./_export":52,"./_strict-method":124}],170:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":21,"./_export":52,"./_fails":54,"./_strict-method":124,"./_to-object":138}],171:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":119}],172:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":52}],173:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":45,"./_export":52}],174:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":52,"./_fails":54,"./_to-object":138,"./_to-primitive":139}],175:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":46,"./_hide":62,"./_wks":148}],176:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":111}],177:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":35,"./_export":52}],178:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":71,"./_object-dp":91,"./_object-gpo":98,"./_wks":148}],179:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":48,"./_object-dp":91}],180:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":41,"./_collection-strong":38,"./_validate-collection":145}],181:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":52,"./_math-log1p":82}],182:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":52}],183:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":52}],184:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":52,"./_math-sign":84}],185:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":52}],186:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":52}],187:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":52,"./_math-expm1":80}],188:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":52,"./_math-fround":81}],189:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":52}],190:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":52,"./_fails":54}],191:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":52}],192:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":52,"./_math-log1p":82}],193:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":52}],194:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":52,"./_math-sign":84}],195:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":52,"./_fails":54,"./_math-expm1":80}],196:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":52,"./_math-expm1":80}],197:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":52}],198:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":37,"./_descriptors":48,"./_fails":54,"./_global":60,"./_has":61,"./_inherit-if-required":65,"./_object-create":90,"./_object-dp":91,"./_object-gopd":94,"./_object-gopn":96,"./_redefine":111,"./_string-trim":130,"./_to-primitive":139}],199:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":52}],200:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":52,"./_global":60}],201:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":52,"./_is-integer":70}],202:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":52}],203:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":52,"./_is-integer":70}],204:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":52}],205:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":52}],206:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":52,"./_parse-float":105}],207:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":52,"./_parse-int":106}],208:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":22,"./_export":52,"./_fails":54,"./_string-repeat":129,"./_to-integer":135}],209:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":22,"./_export":52,"./_fails":54}],210:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":52,"./_object-assign":89}],211:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":52,"./_object-create":90}],212:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":48,"./_export":52,"./_object-dps":92}],213:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":48,"./_export":52,"./_object-dp":91}],214:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":71,"./_meta":85,"./_object-sap":102}],215:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":94,"./_object-sap":102,"./_to-iobject":136}],216:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":95,"./_object-sap":102}],217:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":98,"./_object-sap":102,"./_to-object":138}],218:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":71,"./_object-sap":102}],219:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":71,"./_object-sap":102}],220:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":71,"./_object-sap":102}],221:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":52,"./_same-value":115}],222:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":100,"./_object-sap":102,"./_to-object":138}],223:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":71,"./_meta":85,"./_object-sap":102}],224:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":71,"./_meta":85,"./_object-sap":102}],225:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":52,"./_set-proto":118}],226:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":36,"./_redefine":111,"./_wks":148}],227:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":52,"./_parse-float":105}],228:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":52,"./_parse-int":106}],229:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":21,"./_an-instance":25,"./_classof":36,"./_core":42,"./_ctx":44,"./_export":52,"./_for-of":58,"./_global":60,"./_is-object":71,"./_iter-detect":76,"./_library":79,"./_microtask":87,"./_new-promise-capability":88,"./_perform":107,"./_promise-resolve":108,"./_redefine-all":110,"./_set-species":119,"./_set-to-string-tag":120,"./_species-constructor":123,"./_task":132,"./_user-agent":144,"./_wks":148}],230:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":21,"./_an-object":26,"./_export":52,"./_fails":54,"./_global":60}],231:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":21,"./_an-object":26,"./_bind":35,"./_export":52,"./_fails":54,"./_global":60,"./_is-object":71,"./_object-create":90}],232:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":26,"./_export":52,"./_fails":54,"./_object-dp":91,"./_to-primitive":139}],233:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":26,"./_export":52,"./_object-gopd":94}],234:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":26,"./_export":52,"./_iter-create":74}],235:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":26,"./_export":52,"./_object-gopd":94}],236:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":26,"./_export":52,"./_object-gpo":98}],237:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":26,"./_export":52,"./_has":61,"./_is-object":71,"./_object-gopd":94,"./_object-gpo":98}],238:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":52}],239:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":26,"./_export":52}],240:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":52,"./_own-keys":104}],241:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":26,"./_export":52}],242:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":52,"./_set-proto":118}],243:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":26,"./_export":52,"./_has":61,"./_is-object":71,"./_object-dp":91,"./_object-gopd":94,"./_object-gpo":98,"./_property-desc":109}],244:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":48,"./_fails":54,"./_flags":56,"./_global":60,"./_inherit-if-required":65,"./_is-regexp":72,"./_object-dp":91,"./_object-gopn":96,"./_redefine":111,"./_set-species":119,"./_wks":148}],245:[function(require,module,exports){
'use strict';
var regexpExec = require('./_regexp-exec');
require('./_export')({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

},{"./_export":52,"./_regexp-exec":113}],246:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":48,"./_flags":56,"./_object-dp":91}],247:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toLength = require('./_to-length');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');

// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"./_advance-string-index":24,"./_an-object":26,"./_fix-re-wks":55,"./_regexp-exec-abstract":112,"./_to-length":137}],248:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

},{"./_advance-string-index":24,"./_an-object":26,"./_fix-re-wks":55,"./_regexp-exec-abstract":112,"./_to-integer":135,"./_to-length":137,"./_to-object":138}],249:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var sameValue = require('./_same-value');
var regExpExec = require('./_regexp-exec-abstract');

// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"./_an-object":26,"./_fix-re-wks":55,"./_regexp-exec-abstract":112,"./_same-value":115}],250:[function(require,module,exports){
'use strict';

var isRegExp = require('./_is-regexp');
var anObject = require('./_an-object');
var speciesConstructor = require('./_species-constructor');
var advanceStringIndex = require('./_advance-string-index');
var toLength = require('./_to-length');
var callRegExpExec = require('./_regexp-exec-abstract');
var regexpExec = require('./_regexp-exec');
var fails = require('./_fails');
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

},{"./_advance-string-index":24,"./_an-object":26,"./_fails":54,"./_fix-re-wks":55,"./_is-regexp":72,"./_regexp-exec":113,"./_regexp-exec-abstract":112,"./_species-constructor":123,"./_to-length":137}],251:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":26,"./_descriptors":48,"./_fails":54,"./_flags":56,"./_redefine":111,"./es6.regexp.flags":246}],252:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":41,"./_collection-strong":38,"./_validate-collection":145}],253:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":127}],254:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":127}],255:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":127}],256:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":127}],257:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":52,"./_string-at":125}],258:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":52,"./_fails-is-regexp":53,"./_string-context":126,"./_to-length":137}],259:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":127}],260:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":127}],261:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":127}],262:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":52,"./_to-absolute-index":133}],263:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":52,"./_fails-is-regexp":53,"./_string-context":126}],264:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":127}],265:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":75,"./_string-at":125}],266:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":127}],267:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":52,"./_to-iobject":136,"./_to-length":137}],268:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":52,"./_string-repeat":129}],269:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":127}],270:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":52,"./_fails-is-regexp":53,"./_string-context":126,"./_to-length":137}],271:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":127}],272:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":127}],273:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":127}],274:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":130}],275:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":26,"./_descriptors":48,"./_enum-keys":51,"./_export":52,"./_fails":54,"./_global":60,"./_has":61,"./_hide":62,"./_is-array":69,"./_is-object":71,"./_library":79,"./_meta":85,"./_object-create":90,"./_object-dp":91,"./_object-gopd":94,"./_object-gopn":96,"./_object-gopn-ext":95,"./_object-gops":97,"./_object-keys":100,"./_object-pie":101,"./_property-desc":109,"./_redefine":111,"./_set-to-string-tag":120,"./_shared":122,"./_to-iobject":136,"./_to-object":138,"./_to-primitive":139,"./_uid":143,"./_wks":148,"./_wks-define":146,"./_wks-ext":147}],276:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":26,"./_export":52,"./_fails":54,"./_global":60,"./_is-object":71,"./_set-species":119,"./_species-constructor":123,"./_to-absolute-index":133,"./_to-length":137,"./_typed":142,"./_typed-buffer":141}],277:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":52,"./_typed":142,"./_typed-buffer":141}],278:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],279:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],280:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],281:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],282:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],283:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],284:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],285:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":140}],286:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":140}],287:[function(require,module,exports){
'use strict';
var global = require('./_global');
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var validate = require('./_validate-collection');
var NATIVE_WEAK_MAP = require('./_validate-collection');
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":31,"./_collection":41,"./_collection-weak":40,"./_global":60,"./_is-object":71,"./_meta":85,"./_object-assign":89,"./_redefine":111,"./_validate-collection":145}],288:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":41,"./_collection-weak":40,"./_validate-collection":145}],289:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":21,"./_add-to-unscopables":23,"./_array-species-create":34,"./_export":52,"./_flatten-into-array":57,"./_to-length":137,"./_to-object":138}],290:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":23,"./_array-species-create":34,"./_export":52,"./_flatten-into-array":57,"./_to-integer":135,"./_to-length":137,"./_to-object":138}],291:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":23,"./_array-includes":30,"./_export":52}],292:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":37,"./_export":52,"./_global":60,"./_microtask":87}],293:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":37,"./_export":52}],294:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":52,"./_global":60}],295:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":116}],296:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":117}],297:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":39,"./_export":52}],298:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":52}],299:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":52}],300:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":52}],301:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":52,"./_math-fround":81,"./_math-scale":83}],302:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":52}],303:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":52}],304:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":52}],305:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":52}],306:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":52}],307:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":52,"./_math-scale":83}],308:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":52}],309:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":52}],310:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":21,"./_descriptors":48,"./_export":52,"./_object-dp":91,"./_object-forced-pam":93,"./_to-object":138}],311:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":21,"./_descriptors":48,"./_export":52,"./_object-dp":91,"./_object-forced-pam":93,"./_to-object":138}],312:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":52,"./_object-to-array":103}],313:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":43,"./_export":52,"./_object-gopd":94,"./_own-keys":104,"./_to-iobject":136}],314:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":48,"./_export":52,"./_object-forced-pam":93,"./_object-gopd":94,"./_object-gpo":98,"./_to-object":138,"./_to-primitive":139}],315:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":48,"./_export":52,"./_object-forced-pam":93,"./_object-gopd":94,"./_object-gpo":98,"./_to-object":138,"./_to-primitive":139}],316:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":52,"./_object-to-array":103}],317:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":21,"./_an-instance":25,"./_an-object":26,"./_core":42,"./_export":52,"./_for-of":58,"./_global":60,"./_hide":62,"./_microtask":87,"./_redefine-all":110,"./_set-species":119,"./_wks":148}],318:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":42,"./_export":52,"./_global":60,"./_promise-resolve":108,"./_species-constructor":123}],319:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":52,"./_new-promise-capability":88,"./_perform":107}],320:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":26,"./_metadata":86}],321:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":26,"./_metadata":86}],322:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":26,"./_array-from-iterable":29,"./_metadata":86,"./_object-gpo":98,"./es6.set":252}],323:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":26,"./_metadata":86,"./_object-gpo":98}],324:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":26,"./_metadata":86}],325:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":26,"./_metadata":86}],326:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":26,"./_metadata":86,"./_object-gpo":98}],327:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":26,"./_metadata":86}],328:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":21,"./_an-object":26,"./_metadata":86}],329:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":116}],330:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":117}],331:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":39,"./_export":52}],332:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);
var $fails = require('./_fails');

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":52,"./_fails":54,"./_string-at":125}],333:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":47,"./_export":52,"./_flags":56,"./_is-regexp":72,"./_iter-create":74,"./_to-length":137}],334:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":52,"./_string-pad":128,"./_user-agent":144}],335:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":52,"./_string-pad":128,"./_user-agent":144}],336:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":130}],337:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":130}],338:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":146}],339:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":146}],340:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":52,"./_global":60}],341:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":116}],342:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":117}],343:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":116}],344:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":117}],345:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":60,"./_hide":62,"./_iterators":78,"./_object-keys":100,"./_redefine":111,"./_wks":148,"./es6.array.iterator":161}],346:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":52,"./_task":132}],347:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var userAgent = require('./_user-agent');
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":52,"./_global":60,"./_user-agent":144}],348:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.exec');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":42,"./modules/es6.array.copy-within":151,"./modules/es6.array.every":152,"./modules/es6.array.fill":153,"./modules/es6.array.filter":154,"./modules/es6.array.find":156,"./modules/es6.array.find-index":155,"./modules/es6.array.for-each":157,"./modules/es6.array.from":158,"./modules/es6.array.index-of":159,"./modules/es6.array.is-array":160,"./modules/es6.array.iterator":161,"./modules/es6.array.join":162,"./modules/es6.array.last-index-of":163,"./modules/es6.array.map":164,"./modules/es6.array.of":165,"./modules/es6.array.reduce":167,"./modules/es6.array.reduce-right":166,"./modules/es6.array.slice":168,"./modules/es6.array.some":169,"./modules/es6.array.sort":170,"./modules/es6.array.species":171,"./modules/es6.date.now":172,"./modules/es6.date.to-iso-string":173,"./modules/es6.date.to-json":174,"./modules/es6.date.to-primitive":175,"./modules/es6.date.to-string":176,"./modules/es6.function.bind":177,"./modules/es6.function.has-instance":178,"./modules/es6.function.name":179,"./modules/es6.map":180,"./modules/es6.math.acosh":181,"./modules/es6.math.asinh":182,"./modules/es6.math.atanh":183,"./modules/es6.math.cbrt":184,"./modules/es6.math.clz32":185,"./modules/es6.math.cosh":186,"./modules/es6.math.expm1":187,"./modules/es6.math.fround":188,"./modules/es6.math.hypot":189,"./modules/es6.math.imul":190,"./modules/es6.math.log10":191,"./modules/es6.math.log1p":192,"./modules/es6.math.log2":193,"./modules/es6.math.sign":194,"./modules/es6.math.sinh":195,"./modules/es6.math.tanh":196,"./modules/es6.math.trunc":197,"./modules/es6.number.constructor":198,"./modules/es6.number.epsilon":199,"./modules/es6.number.is-finite":200,"./modules/es6.number.is-integer":201,"./modules/es6.number.is-nan":202,"./modules/es6.number.is-safe-integer":203,"./modules/es6.number.max-safe-integer":204,"./modules/es6.number.min-safe-integer":205,"./modules/es6.number.parse-float":206,"./modules/es6.number.parse-int":207,"./modules/es6.number.to-fixed":208,"./modules/es6.number.to-precision":209,"./modules/es6.object.assign":210,"./modules/es6.object.create":211,"./modules/es6.object.define-properties":212,"./modules/es6.object.define-property":213,"./modules/es6.object.freeze":214,"./modules/es6.object.get-own-property-descriptor":215,"./modules/es6.object.get-own-property-names":216,"./modules/es6.object.get-prototype-of":217,"./modules/es6.object.is":221,"./modules/es6.object.is-extensible":218,"./modules/es6.object.is-frozen":219,"./modules/es6.object.is-sealed":220,"./modules/es6.object.keys":222,"./modules/es6.object.prevent-extensions":223,"./modules/es6.object.seal":224,"./modules/es6.object.set-prototype-of":225,"./modules/es6.object.to-string":226,"./modules/es6.parse-float":227,"./modules/es6.parse-int":228,"./modules/es6.promise":229,"./modules/es6.reflect.apply":230,"./modules/es6.reflect.construct":231,"./modules/es6.reflect.define-property":232,"./modules/es6.reflect.delete-property":233,"./modules/es6.reflect.enumerate":234,"./modules/es6.reflect.get":237,"./modules/es6.reflect.get-own-property-descriptor":235,"./modules/es6.reflect.get-prototype-of":236,"./modules/es6.reflect.has":238,"./modules/es6.reflect.is-extensible":239,"./modules/es6.reflect.own-keys":240,"./modules/es6.reflect.prevent-extensions":241,"./modules/es6.reflect.set":243,"./modules/es6.reflect.set-prototype-of":242,"./modules/es6.regexp.constructor":244,"./modules/es6.regexp.exec":245,"./modules/es6.regexp.flags":246,"./modules/es6.regexp.match":247,"./modules/es6.regexp.replace":248,"./modules/es6.regexp.search":249,"./modules/es6.regexp.split":250,"./modules/es6.regexp.to-string":251,"./modules/es6.set":252,"./modules/es6.string.anchor":253,"./modules/es6.string.big":254,"./modules/es6.string.blink":255,"./modules/es6.string.bold":256,"./modules/es6.string.code-point-at":257,"./modules/es6.string.ends-with":258,"./modules/es6.string.fixed":259,"./modules/es6.string.fontcolor":260,"./modules/es6.string.fontsize":261,"./modules/es6.string.from-code-point":262,"./modules/es6.string.includes":263,"./modules/es6.string.italics":264,"./modules/es6.string.iterator":265,"./modules/es6.string.link":266,"./modules/es6.string.raw":267,"./modules/es6.string.repeat":268,"./modules/es6.string.small":269,"./modules/es6.string.starts-with":270,"./modules/es6.string.strike":271,"./modules/es6.string.sub":272,"./modules/es6.string.sup":273,"./modules/es6.string.trim":274,"./modules/es6.symbol":275,"./modules/es6.typed.array-buffer":276,"./modules/es6.typed.data-view":277,"./modules/es6.typed.float32-array":278,"./modules/es6.typed.float64-array":279,"./modules/es6.typed.int16-array":280,"./modules/es6.typed.int32-array":281,"./modules/es6.typed.int8-array":282,"./modules/es6.typed.uint16-array":283,"./modules/es6.typed.uint32-array":284,"./modules/es6.typed.uint8-array":285,"./modules/es6.typed.uint8-clamped-array":286,"./modules/es6.weak-map":287,"./modules/es6.weak-set":288,"./modules/es7.array.flat-map":289,"./modules/es7.array.flatten":290,"./modules/es7.array.includes":291,"./modules/es7.asap":292,"./modules/es7.error.is-error":293,"./modules/es7.global":294,"./modules/es7.map.from":295,"./modules/es7.map.of":296,"./modules/es7.map.to-json":297,"./modules/es7.math.clamp":298,"./modules/es7.math.deg-per-rad":299,"./modules/es7.math.degrees":300,"./modules/es7.math.fscale":301,"./modules/es7.math.iaddh":302,"./modules/es7.math.imulh":303,"./modules/es7.math.isubh":304,"./modules/es7.math.rad-per-deg":305,"./modules/es7.math.radians":306,"./modules/es7.math.scale":307,"./modules/es7.math.signbit":308,"./modules/es7.math.umulh":309,"./modules/es7.object.define-getter":310,"./modules/es7.object.define-setter":311,"./modules/es7.object.entries":312,"./modules/es7.object.get-own-property-descriptors":313,"./modules/es7.object.lookup-getter":314,"./modules/es7.object.lookup-setter":315,"./modules/es7.object.values":316,"./modules/es7.observable":317,"./modules/es7.promise.finally":318,"./modules/es7.promise.try":319,"./modules/es7.reflect.define-metadata":320,"./modules/es7.reflect.delete-metadata":321,"./modules/es7.reflect.get-metadata":323,"./modules/es7.reflect.get-metadata-keys":322,"./modules/es7.reflect.get-own-metadata":325,"./modules/es7.reflect.get-own-metadata-keys":324,"./modules/es7.reflect.has-metadata":326,"./modules/es7.reflect.has-own-metadata":327,"./modules/es7.reflect.metadata":328,"./modules/es7.set.from":329,"./modules/es7.set.of":330,"./modules/es7.set.to-json":331,"./modules/es7.string.at":332,"./modules/es7.string.match-all":333,"./modules/es7.string.pad-end":334,"./modules/es7.string.pad-start":335,"./modules/es7.string.trim-left":336,"./modules/es7.string.trim-right":337,"./modules/es7.symbol.async-iterator":338,"./modules/es7.symbol.observable":339,"./modules/es7.system.global":340,"./modules/es7.weak-map.from":341,"./modules/es7.weak-map.of":342,"./modules/es7.weak-set.from":343,"./modules/es7.weak-set.of":344,"./modules/web.dom.iterable":345,"./modules/web.immediate":346,"./modules/web.timers":347}]},{},[17])

